/*! ===========================================================================
 *  AV Milestone Event  —  site-wide auto celebration + "catch N" mini-game.
 *  ---------------------------------------------------------------------------
 *  • Trigger is AUTOMATIC from the live product count (rendered by Liquid into
 *    #av-ms-root[data-count]); active while count is in [milestone, milestone+buffer).
 *  • Works for EVERY milestone (100..10000); tier/points come from data-milestones.
 *  • Catch GOAL tokens -> reveal the universal promo code (copyable). Progress is
 *    persisted per-milestone in localStorage, so it survives navigation.
 *  • Hybrid: ambient tokens drift while browsing + an arcade "challenge round".
 *  • Accessibility: keyboard-operable; prefers-reduced-motion -> static a11y
 *    variant (still mandatory catching, no motion).
 *  Testing overrides (query params):
 *    ?av_milestone=1000  force a milestone active (preview before you hit it)
 *    ?av_ms_mode=lite|rich  force the accessible / rich variant
 *    ?av_ms_reset=1  clear this browser's saved progress
 *  =========================================================================== */
(function () {
  "use strict";
  var root = document.getElementById("av-ms-root");
  if (!root || root.__avMs) return; root.__avMs = 1;

  /* ------------------------------ config -------------------------------- */
  var COUNT  = parseInt(root.dataset.count  || "0", 10) || 0;
  var BUFFER = parseInt(root.dataset.buffer || "90", 10) || 90;
  var RATE   = parseFloat(root.dataset.rate || "0") || 0;   // templates/day — only to estimate DAYS left
  var GOAL   = parseInt(root.dataset.goal   || "10", 10) || 10;
  var CODE   = (root.dataset.code  || "MILESTONE").trim();
  var LABEL  = (root.dataset.label || "").trim();       // optional, e.g. "15% OFF"
  var MILES  = []; try { MILES = JSON.parse(root.dataset.milestones || "[]"); } catch (e) { MILES = []; }

  var qs = null; try { qs = new URLSearchParams(location.search); } catch (e) { qs = { get: function(){return null;} }; }
  var forceN    = qs.get("av_milestone");
  var forceMode = qs.get("av_ms_mode");
  // Keep the preview trigger alive across page navigation while testing on a draft
  // (session-only; never set for real visitors, who have no such URL param). Use
  // ?av_milestone=off to stop previewing.
  try {
    if (forceN === "off") { sessionStorage.removeItem("av_ms_preview"); forceN = null; }
    else if (forceN) { sessionStorage.setItem("av_ms_preview", forceN); }
    else { forceN = sessionStorage.getItem("av_ms_preview"); }
    if (forceMode) sessionStorage.setItem("av_ms_mode_p", forceMode);
    else if (forceMode === null) forceMode = sessionStorage.getItem("av_ms_mode_p");
  } catch (e) {}
  if (qs.get("av_ms_reset")) { try { Object.keys(localStorage).forEach(function (k) { if (k.indexOf("av_ms_") === 0) localStorage.removeItem(k); }); } catch (e) {} }

  /* --------------------------- pick milestone --------------------------- */
  // Two states: a CELEBRATION (game) while count is in [milestone, milestone+buffer),
  // or a pre-milestone TEASER while we're within LEAD templates of the next milestone
  // ("only X to go — a surprise awaits"). Teaser auto-hands-off to the game on hit.
  // Teaser lead-in is PROPORTIONAL: the setting (default 30) is the anchor at the
  // 1,000 milestone; every milestone gets lead = round(n * anchor / 1000). So bigger
  // milestones (with bigger gaps) get a proportionally longer teaser window.
  var ANCHOR = parseInt(root.dataset.lead || "30", 10) || 30;
  function leadFor(m) { return Math.max(3, Math.round(m.n * ANCHOR / 1000)); }
  function pickAuto() {
    var m = null;
    for (var i = 0; i < MILES.length; i++) { if (COUNT >= MILES[i].n) m = MILES[i]; }
    if (!m) return null;
    if (COUNT - m.n >= BUFFER) return null;           // celebration window has passed
    return m;
  }
  function pickUpcoming() { for (var i = 0; i < MILES.length; i++) { if (MILES[i].n > COUNT) return MILES[i]; } return null; }
  function byN(n) { return MILES.filter(function (m) { return m.n == n; })[0] || { n: n, tier: "silver", pts: 0 }; }
  var forceTease = qs.get("av_ms_teaser");
  var milestone = null, mode = null, isPreview = false, remaining = 0;
  if (forceN) {
    milestone = byN(parseInt(forceN, 10) || 1000); mode = "celebration"; isPreview = true;
  } else if (forceTease) {
    milestone = byN(parseInt(forceTease, 10) || 1000);
    remaining = milestone.n - COUNT; var _l = leadFor(milestone); if (remaining < 1 || remaining > _l) remaining = Math.max(1, Math.round(_l * 0.4));
    mode = "teaser"; isPreview = true;
  } else {
    milestone = pickAuto();
    if (milestone) { mode = "celebration"; }
    else {
      var up = pickUpcoming();
      if (up) { remaining = up.n - COUNT; if (remaining >= 1 && remaining <= leadFor(up)) { milestone = up; mode = "teaser"; } }
    }
  }
  // 🕹 ARCADE — the easter egg. Without this the engine stops right below whenever no
  // celebration and no teaser is running, so the game would be unreachable for most of
  // the year. If the page carries an opt-in launcher ([data-av-ms-arcade="1000"] — the
  // "easter egg" badge on the reward table) we boot a THIRD mode instead: the full game
  // ON DEMAND ONLY. No ambient medals, no HUD, no site-wide event light, its own
  // localStorage namespace, and NEVER the promo code (see NS / setUnlocked / win).
  // ?av_ms_arcade=1 forces it over a live celebration (test lever), =off disables it.
  var ARCADE = false, arcadeBusy = false;
  var arcForce = qs.get("av_ms_arcade");
  if (arcForce !== "off" && (!milestone || !mode || arcForce === "1")) {
    var arcadeHost = document.querySelector("[data-av-ms-arcade]");
    if (arcadeHost) {
      var arcN = parseInt(arcadeHost.getAttribute("data-av-ms-arcade") || "", 10);
      if (!arcN) { var arcUp = pickUpcoming(); arcN = arcUp ? arcUp.n : 1000; }
      milestone = byN(arcN); mode = "arcade"; ARCADE = true;
    }
  }
  if (!milestone || !mode) return;                     // nothing to show right now
  var TIER = milestone.tier || "silver";
  var MEDALS = {
    bronze:   "https://cdn.shopify.com/s/files/1/0884/4771/3613/files/autovectors.com_ppf_template_bronze_medal.png?v=1773657769",
    silver:   "https://cdn.shopify.com/s/files/1/0884/4771/3613/files/autovectors.com_ppf_template_Silver_medal.png?v=1773657769",
    gold:     "https://cdn.shopify.com/s/files/1/0884/4771/3613/files/autovectors.com_ppf_template_Gold_medal.png?v=1773657769",
    platinum: "https://cdn.shopify.com/s/files/1/0884/4771/3613/files/autovectors.com_ppf_template_Platinum_medal.png?v=1773657769"
  };
  var MEDAL_SRC = MEDALS[TIER] || MEDALS.silver;
  var NEXT_TIER = { bronze: "silver", silver: "gold", gold: "platinum", platinum: "platinum" }[TIER] || "gold";
  var NEXT_MEDAL_SRC = MEDALS[NEXT_TIER] || MEDAL_SRC;
  // Dedicated BOSS artwork per tier — the final boss matches the milestone's OWN tier
  // (1000/1500 = silver boss, 2000+ = gold, 7000+ = platinum).
  var BOSS_SRC = {
    bronze:   "https://cdn.shopify.com/s/files/1/0884/4771/3613/files/bronze_boss.png?v=1784309670",
    silver:   "https://cdn.shopify.com/s/files/1/0884/4771/3613/files/SILVER_BOSS.png?v=1784309669",
    gold:     "https://cdn.shopify.com/s/files/1/0884/4771/3613/files/gold_boss.png?v=1784310081",
    platinum: "https://cdn.shopify.com/s/files/1/0884/4771/3613/files/platinum_boss.png?v=1784310178"
  };
  var TIER_LADDER = ["bronze", "silver", "gold", "platinum"];
  function activeTier() {                                        // fun levels climb the tier ladder: L5+ = +1, L10+ = +2
    if (!funMode) return TIER;
    var i = TIER_LADDER.indexOf(TIER); if (i < 0) i = 1;
    return TIER_LADDER[Math.min(3, i + (funLevel >= 8 ? 2 : funLevel >= 5 ? 1 : 0))];
  }
  try { var _wb = new Image(); _wb.src = BOSS_SRC[TIER]; } catch (e) {}   // warm the boss art

  /* ------------------------------ state --------------------------------- */
  // Arcade rounds live in their OWN namespace so a practice game can never write into
  // (or unlock) a real milestone bucket. ?av_ms_reset=1 still clears both.
  var NS  = ARCADE ? "av_ms_arc_" : "av_ms_";
  var KEY = NS + "v1_" + milestone.n;
  var caughtMem = 0, unlockMem = false;
  function getCaught() { try { return parseInt(localStorage.getItem(KEY + "_caught") || "0", 10) || 0; } catch (e) { return caughtMem; } }
  function setCaught(v) { caughtMem = v; try { localStorage.setItem(KEY + "_caught", v); } catch (e) {} }
  function isUnlocked() { if (unlockMem) return true; try { return localStorage.getItem(KEY + "_unlocked") === "1"; } catch (e) { return false; } }
  function setUnlocked() { if (ARCADE) return; unlockMem = true; try { localStorage.setItem(KEY + "_unlocked", "1"); } catch (e) {} }   // 🕹 the arcade never grants the code

  /* --------------------------- capabilities ----------------------------- */
  function mm(q) { return window.matchMedia && matchMedia(q).matches; }
  var reduce = mm("(prefers-reduced-motion: reduce)");
  var coarse = mm("(hover:none),(pointer:coarse)");
  // Default is ALWAYS the rich animated game (the medals are lightweight DOM, not the
  // heavy WebGL that the site's "Lite" mode turns off) — so Lite mode does NOT force
  // low-motion. Only genuine prefers-reduced-motion (or the manual toggle / ?av_ms_mode=lite) does.
  var a11y   = forceMode === "lite" || (forceMode !== "rich" && reduce);

  /* ------------------------------ helpers ------------------------------- */
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function tier(e) { e.classList.add("av-ms"); e.setAttribute("data-tier", TIER); return e; }
  function rnd(a, b) { return a + (b - a) * Math.random(); }
  function pseudo() { return Math.random(); }
  function medalGlyph() { return TIER === "gold" || TIER === "platinum" ? "✦" : "★"; }
  var TIER_NAME = { bronze: "Bronze", silver: "Silver", gold: "Gold", platinum: "Platinum" }[TIER] || "Silver";
  // Per-tier INTENSITY dial — one place that scales every celebration effect so the
  // journey escalates Bronze (subtle) -> Platinum (finale). Each effect keeps its own hard cap.
  var TIER_FX = {
    bronze:   { rank: "Street", shards: 6,  confetti: 120, rays: 3, aura: false },
    silver:   { rank: "Sport",  shards: 7,  confetti: 160, rays: 4, aura: false },
    gold:     { rank: "Track",  shards: 9,  confetti: 200, rays: 5, aura: false },
    platinum: { rank: "Apex",   shards: 11, confetti: 250, rays: 6, aura: true }
  };
  var FX = TIER_FX[TIER] || TIER_FX.silver;

  // Opt-in procedural sound (OFF by default, no files; unlocked only via the toggle = a user gesture)
  // Always-on procedural sound (no files, no toggle). Browsers block audio until a user
  // gesture — the game needs clicks anyway, so we unlock the context on the first interaction.
  var Sound = (function () {
    var ctx = null;
    function ac() { if (ctx) return ctx; try { ctx = new (window.AudioContext || window.webkitAudioContext)(); } catch (e) { ctx = null; } return ctx; }
    function play(c, freq, dur, type, vol, when, pan) {
      var t = c.currentTime + (when || 0), o = c.createOscillator(), g = c.createGain();
      o.type = type || "sine"; o.frequency.setValueAtTime(freq, t);
      g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(vol || 0.14, t + 0.008); g.gain.exponentialRampToValueAtTime(0.0001, t + (dur || 0.12));
      o.connect(g);
      if (pan && c.createStereoPanner) {                          // sounds live WHERE the medal is
        var p = c.createStereoPanner(); p.pan.setValueAtTime(Math.max(-0.7, Math.min(0.7, pan)), t);
        g.connect(p); p.connect(c.destination);
      } else g.connect(c.destination);
      o.start(t); o.stop(t + (dur || 0.12) + 0.03);
    }
    function tone(freq, dur, type, vol, when, pan) {
      var c = ac(); if (!c) return;
      if (c.state === "suspended") { try { c.resume().then(function () { play(c, freq, dur, type, vol, when, pan); }, function () {}); } catch (e) {} return; }
      play(c, freq, dur, type, vol, when, pan);
    }
    // Tier-keyed scales: catch blips are QUANTIZED to the round's key, so the round
    // sounds composed instead of random. Fun-tier upgrades change the key too.
    var SCALES = {
      bronze:   [349.2, 392, 440, 493.9, 523.3, 587.3, 659.3, 698.5, 784, 880],
      silver:   [392, 440, 493.9, 523.3, 587.3, 659.3, 698.5, 784, 880, 987.8],
      gold:     [370, 415.3, 440, 493.9, 554.4, 587.3, 659.3, 740, 830.6, 880],
      platinum: [370, 415.3, 493.9, 554.4, 622.3, 659.3, 740, 830.6, 932.3, 987.8]
    };
    function quantize(f) {
      var sc = SCALES[activeTier()] || SCALES.silver, best = sc[0];
      for (var qi = 1; qi < sc.length; qi++) if (Math.abs(sc[qi] - f) < Math.abs(best - f)) best = sc[qi];
      return best;
    }
    // Near-subliminal 2-4 voice tonal BED per round; dawn stages open extra voices.
    var bed = { on: false, nodes: [] }, BEDGAIN = 0.026;
    var BED = {
      bronze:   [73.4, 110, 146.8, 220],
      silver:   [110, 164.8, 220, 261.6],
      gold:     [82.4, 123.5, 164.8, 246.9],
      platinum: [123.5, 185, 246.9, 311.1]
    };
    function bedStart(quiet, stage) {
      var c = ac(); if (!c || c.state === "suspended" || bed.on) return bed.on;
      bed.on = true;
      var fs = BED[activeTier()] || BED.silver;
      for (var i = 0; i < fs.length; i++) {
        var o = c.createOscillator(), o2 = c.createOscillator(), g = c.createGain();
        o.type = i === 1 ? "triangle" : "sine"; o2.type = "sine";
        o.frequency.value = fs[i]; o2.frequency.value = fs[i] * 1.004;   // slow natural beating
        g.gain.value = 0.0001;
        o.connect(g); o2.connect(g); g.connect(c.destination);
        o.start(); o2.start();
        bed.nodes.push({ o: o, o2: o2, g: g });
      }
      bedLevel(stage || 0, quiet);
      return true;
    }
    function bedLevel(stage, quiet) {
      if (!bed.on) return;
      var q = quiet ? 0.55 : 1;
      bed.nodes.forEach(function (n, i) {
        var vol = i <= Math.min(1 + stage, 3) ? BEDGAIN * q * (i < 2 ? 1 : 0.7) : 0.0001;
        try { n.g.gain.setTargetAtTime(Math.max(0.0001, vol), n.g.context.currentTime, 1.2); } catch (e) {}
      });
    }
    function bedStop() {
      bed.nodes.forEach(function (n) { try {
        n.g.gain.setTargetAtTime(0.0001, n.g.context.currentTime, 0.35);
        n.o.stop(n.g.context.currentTime + 1.6); n.o2.stop(n.g.context.currentTime + 1.6);
      } catch (e) {} });
      bed.nodes = []; bed.on = false;
    }
    function unlock() {
      var c = ac(); if (c && c.state === "suspended") { try { c.resume(); } catch (e) {} }
      window.removeEventListener("pointerdown", unlock, true); window.removeEventListener("keydown", unlock, true);
    }
    return {
      arm: function () { window.addEventListener("pointerdown", unlock, true); window.addEventListener("keydown", unlock, true); },
      hit: function (worth, prog, pan) {
        var base = 380 + Math.min(1, prog || 0) * 340;            // pitch ladder: each catch rings a little higher
        if (perfNow() < feverUntil) base *= 1.5;                  // 🔥 FEVER: jump up a fifth
        base = quantize(base);                                    // snapped to the tier's key -> it sounds composed
        tone(worth > 1 ? quantize(base * 1.25) : base, 0.1, "triangle", 0.13, 0, pan);
        if (worth > 1) tone(quantize(base * 1.5), 0.09, "triangle", 0.1, 0.05, pan);
      },
      bed: { start: bedStart, level: bedLevel, stop: bedStop },
      combo: function (n) { tone(400 + Math.min(n, 10) * 55, 0.08, "square", 0.09); },
      fx: function (name) {
        if (name === "crack") tone(210, 0.09, "square", 0.11);
        else if (name === "freeze") { tone(880, 0.12, "sine", 0.12); tone(660, 0.14, "sine", 0.11, 0.09); tone(440, 0.2, "sine", 0.1, 0.19); }
        else if (name === "magnet") { tone(330, 0.1, "sawtooth", 0.07); tone(495, 0.12, "sawtooth", 0.07, 0.09); }
        else if (name === "time") { tone(700, 0.08, "triangle", 0.12); tone(1050, 0.1, "triangle", 0.12, 0.07); }
        else if (name === "frenzy") { [440, 554, 659, 880].forEach(function (f, i) { tone(f, 0.07, "square", 0.09, i * 0.05); }); }
        else if (name === "chrome") { [1046.5, 1174.7, 1318.5, 1568, 1760].forEach(function (f, i) { tone(f, 0.06, "triangle", 0.1, i * 0.045); }); }
        else if (name === "feverout") { tone(660, 0.22, "sine", 0.1); tone(494, 0.34, "sine", 0.09, 0.14); }
        else if (name === "goldflip") { [523.3, 659.3, 784].forEach(function (f, i) { tone(f, 0.14, "triangle", 0.12, i * 0.07); }); }
        else if (name === "typeline") { for (var ti = 0; ti < 18; ti++) tone(1300 + (ti % 4) * 90, 0.012, "square", 0.028, ti * 0.1); }
        else if (name === "bosshit") { tone(160, 0.16, "square", 0.15); tone(320, 0.1, "square", 0.1, 0.06); tone(520, 0.08, "square", 0.08, 0.13); }
        else if (name === "trap") { tone(150, 0.18, "sawtooth", 0.12); tone(105, 0.24, "sawtooth", 0.1, 0.1); }
        else if (name === "beat") { tone(80, 0.12, "sine", 0.2); }
        else if (name === "go") { [523.3, 659.3, 880].forEach(function (f, i) { tone(f, 0.11, "triangle", 0.13, i * 0.055); }); }
        else if (name === "cutsnap") { tone(quantize(900 + Math.random() * 200), 0.045, "square", 0.07); }
        else if (name === "cutdone") {                           // the blade runs the path, then the liner lifts
          for (var ci2 = 0; ci2 < 8; ci2++) tone(1500 + (ci2 % 3) * 160, 0.016, "square", 0.05, ci2 * 0.035);
          tone(520, 0.1, "triangle", 0.11, 0.3); tone(760, 0.22, "sine", 0.07, 0.36);
        }
        else if (name === "bossin") {                            // ⚠ rising alarm, then the boss lands
          for (var ri = 0; ri < 9; ri++) tone(130 + ri * 62, 0.11, "sawtooth", 0.045, ri * 0.1);
          tone(880, 0.05, "square", 0.09, 0.95);
          tone(72, 0.55, "sawtooth", 0.17, 0.97); tone(48, 0.8, "sawtooth", 0.13, 1.08);
        }
        else if (name === "bossdie") {
          tone(200, 0.3, "sawtooth", 0.15); tone(140, 0.4, "sawtooth", 0.12, 0.18); tone(90, 0.55, "sawtooth", 0.12, 0.38);
          [900, 700, 1100, 800].forEach(function (f, i) { tone(f, 0.03, "square", 0.06, 0.1 + i * 0.16); });
        }
        else if (name === "squeak") { tone(620, 0.07, "triangle", 0.1); tone(360, 0.07, "triangle", 0.09, 0.05); tone(170, 0.09, "triangle", 0.08, 0.1); }
        else if (name === "storm") { tone(1500, 0.04, "triangle", 0.07); tone(1250, 0.05, "triangle", 0.06, 0.04); tone(70, 0.9, "sawtooth", 0.08, 0.06); tone(52, 1.2, "sawtooth", 0.06, 0.16); }   // crack, then rolling thunder
        else if (name === "thunder") { tone(1600, 0.03, "square", 0.08); tone(64, 0.7, "sawtooth", 0.08, 0.04); tone(46, 1.0, "sawtooth", 0.06, 0.14); }
        else if (name === "plink") { tone(quantize(480 + Math.random() * 420), 0.1, "sine", 0.055); }
        else if (name.indexOf("zap") === 0) {                    // ⚡ chain link N — climbs the tier scale
          var zi = parseInt(name.slice(3), 10) || 0;
          tone(quantize(420 * Math.pow(1.14, zi)), 0.07, "square", 0.085);
          tone(quantize(840 * Math.pow(1.14, zi)), 0.05, "triangle", 0.05, 0.02);
        }
        else if (name === "ding") { tone(quantize(700 + Math.random() * 300), 0.08, "triangle", 0.09); }
        else if (name === "plotter") {
          tone(90, 1.5, "sawtooth", 0.04);                                        // servo hum
          for (var pi = 0; pi < 15; pi++) tone(1500 + (pi % 3) * 180, 0.018, "square", 0.05, 0.06 + pi * 0.09);   // blade ticks
          tone(520, 0.1, "triangle", 0.1, 1.5);                                   // blade lift
          tone(700, 0.25, "sine", 0.06, 1.55); tone(1000, 0.2, "sine", 0.05, 1.68);   // liner peel
        }
        else if (name === "check") { tone(587, 0.1, "triangle", 0.12); tone(784, 0.12, "triangle", 0.12, 0.08); }
      },
      win: function () { [523, 659, 784, 1046, 1318].forEach(function (f, i) { tone(f, 0.2, "triangle", 0.14, i * 0.1); }); }
    };
  })();

  /* =====================================================================
     HUD  (always present while the game is running or after unlock)
     ===================================================================== */
  var hud, hudRingI, hudVal, pop;
  function buildHUD() {
    hud = tier(el("div", "av-ms-hud"));
    hud.setAttribute("role", "button"); hud.setAttribute("tabindex", "0");
    hud.setAttribute("aria-label", milestone.n + " templates milestone reward game");
    hud.innerHTML =
      '<span class="av-ms-hud__medal"><img src="' + MEDAL_SRC + '" alt="" aria-hidden="true"></span>' +
      '<span class="av-ms-hud__txt"><span class="av-ms-hud__k">' + (isPreview ? "Preview • " : "") + 'Milestone</span>' +
      '<span class="av-ms-hud__v">' + fmt(milestone.n) + ' reached</span></span>' +
      '<span class="av-ms-hud__ring"><i></i></span>';
    document.body.appendChild(hud);
    hudRingI = hud.querySelector(".av-ms-hud__ring i");
    hudVal   = hud.querySelector(".av-ms-hud__v");
    // no ✕ button: the bar must always stay reachable (discount code, game entry)
    hud.addEventListener("click", function () { togglePop(); });
    hud.addEventListener("keydown", function (ev) { if (ev.key === "Enter" || ev.key === " ") { ev.preventDefault(); togglePop(); } });
    updateHUD();
  }
  function updateHUD() {
    if (!hud) return;
    var c = getCaught(), done = isUnlocked();
    var pct = Math.min(100, Math.round((c / GOAL) * 100));
    hud.querySelector(".av-ms-hud__ring").style.setProperty("--p", done ? 100 : pct);
    hudRingI.textContent = done ? "✓" : (c + "/" + GOAL);
    hud.classList.toggle("is-final", !done && c >= GOAL - 3);      // heartbeat while the final medal is out
    if (!done && c >= GOAL - 3) bossHint();                        // reliable finale-hint trigger
    if (done) { hud.classList.add("is-done"); hud.classList.remove("is-final"); if (hudVal) hudVal.textContent = "Code ready"; }
    if (pop) refreshPop();
  }

  /* ----------------------------- popover -------------------------------- */
  function buildPop() {
    pop = tier(el("div", "av-ms-pop")); pop.hidden = true; document.body.appendChild(pop); refreshPop();
  }
  function refreshPop() {
    if (!pop) return;
    var c = getCaught(), done = isUnlocked(), pct = Math.min(100, Math.round((c / GOAL) * 100));
    if (done) {
      pop.innerHTML =
        '<button class="av-ms-pop__x" type="button" aria-label="Close">✕</button>' +
        '<h4>' + fmt(milestone.n) + ' templates published 🎉</h4>' +
        '<p>You reached the AutoVectors <b>' + fmt(milestone.n) + '-template</b> milestone and unlocked the reward' + (LABEL ? ' — <b>' + esc(LABEL) + '</b>' : '') + '. Copy the code and use it at checkout.</p>' +
        '<div class="av-ms-code"><input readonly value="' + esc(CODE) + '" aria-label="Promo code"><button type="button" data-copy>Copy</button></div>' +
        '<div class="av-ms-pop-timer"></div>' +                  // ⌛ how long the won code stays valid
        '<a class="av-ms-btn" href="/discount/' + encodeURIComponent(CODE) + '?redirect=/pages/template-library">Shop with code</a>' +
        '<button class="av-ms-btn av-ms-btn--ghost" type="button" data-fun style="margin-top:8px">🎮 Play for fun — Level ' + funLevel + ' (' + funSecs() + 's · boss ×' + funBoost().toFixed(1) + ')</button>';
      pop.querySelector(".av-ms-pop-timer").appendChild(makeCountdown("av-ms-count--pop"));
      wireCopy(pop);
      var fbtn = pop.querySelector("[data-fun]");
      if (fbtn) fbtn.addEventListener("click", function () { funMode = true; funCaught = 0; pop.hidden = true; startArena(); });
    } else {
      pop.innerHTML =
        '<button class="av-ms-pop__x" type="button" aria-label="Close">✕</button>' +
        '<h4>We just hit ' + fmt(milestone.n) + ' templates! 🎉</h4>' +
        '<p>AutoVectors just published its <b>' + fmt(milestone.n) + 'th</b> pre-cut PPF template — a new library milestone. To celebrate, beat the <b>Challenge Round</b>: catch <b>' + GOAL + '</b> glowing ' + TIER_NAME + ' medals against the clock to unlock your discount code' + (LABEL ? ' — <b>' + esc(LABEL) + '</b>' : '') + '.</p>' +
        '<div class="av-ms-bar"><i style="width:' + pct + '%"></i></div>' +
        '<div class="av-ms-pop-timer"></div>' +
        '<button class="av-ms-btn" type="button" data-round>▶ Start challenge round</button>' +
        '<div class="av-ms-mini">' + c + ' / ' + GOAL + ' caught · <button type="button" data-a11y>' + (a11y ? "rich mode" : "keyboard / low-motion mode") + '</button></div>';
      pop.querySelector(".av-ms-pop-timer").appendChild(makeCountdown("av-ms-count--pop"));
      pop.querySelector("[data-round]").addEventListener("click", function () {
        funMode = false; pop.hidden = true; primerThen(startArena);
      });
      pop.querySelector("[data-a11y]").addEventListener("click", function () { a11y = !a11y; rebuild(); togglePop(true); });
    }
    // On desktop you close this by clicking the HUD medal again; on a phone the panel
    // covers it, so there was no visible way out at all.
    var px = pop.querySelector(".av-ms-pop__x");
    if (px) px.addEventListener("click", function (ev) { ev.stopPropagation(); pop.hidden = true; });
  }
  // tap/click outside the panel closes it — the expected gesture on touch
  document.addEventListener("pointerdown", function (ev) {
    if (!pop || pop.hidden || arena) return;
    if (ev.target && ev.target.closest && (ev.target.closest(".av-ms-pop") || ev.target.closest(".av-ms-hud"))) return;
    pop.hidden = true;
  }, true);
  function togglePop(forceOpen) {
    if (!pop) return;
    pop.hidden = forceOpen === true ? false : !pop.hidden;
    if (!pop.hidden) refreshPop();
  }

  /* =====================================================================
     RICH ambient medals + shared MOTION engine (rAF drift + GENTLE dodge).
     Medals ease along a baseline drift and softly steer AWAY from the cursor
     only when it's close — and the dodge FADES to zero at point-blank range,
     so they stop fleeing right when you're on them. A forgiving click radius
     means a near-click counts. Same engine drives the arcade medals
     (bounded/bouncing, mode:"arena"). Sizes are randomized (~40%..100%).
     ===================================================================== */
  var overlay, spawnTimer, active = 0, MAXTOK = coarse ? 2 : 3, BASE = 76;
  var freezeUntil = 0, forceRare = false;                       // "?" wildcard effects + comeback bonus
  // 🧲 The magnet works by POSITION so it also works on touch: desktop follows the
  // cursor, mobile stays anchored at the tap point and vacuums coins in range.
  var magnet = { x: 0, y: 0, until: 0, follow: false, ate: 0 }, magnetFx = null;
  /* -- quick-win juice: impact frames, haptics, fever, chain spark ---------- */
  var hitStopUntil = 0, feverUntil = 0, lastBuzz = 0, lastSpark = 0;
  function hitStop(ms) { hitStopUntil = Math.max(hitStopUntil, perfNow() + ms); }   // arcade "impact frames"
  function buzz(p) { try { if (coarse && navigator.vibrate) { var n = perfNow(); if (n - lastBuzz < 90) return; lastBuzz = n; navigator.vibrate(p); } } catch (e) {} }
  function arenaShake() {
    if (reduce || !arena) return;
    var pf = arena.querySelector(".av-ms-arena"); if (!pf) return;
    pf.classList.remove("is-shake"); void pf.offsetWidth; pf.classList.add("is-shake");
  }
  function startFever() {
    feverUntil = perfNow() + 5000;
    if (arena) { var pf = arena.querySelector(".av-ms-arena"); if (pf) pf.classList.add("is-fever"); }
    Sound.fx("frenzy"); buzz([15, 30, 15, 30, 15]);
    toast("🔥 <b>FEVER!</b> Everything +1 — don’t miss!", 2400);
    setTimeout(function () { if (perfNow() >= feverUntil) endFever(false); }, 5060);
  }
  function endFever(broken, x, y) {
    feverUntil = 0;
    if (arena) {
      var pf = arena.querySelector(".av-ms-arena");
      if (pf) { pf.classList.remove("is-fever");
        if (broken && !reduce) { pf.classList.add("is-feverout"); setTimeout(function () { pf.classList.remove("is-feverout"); }, 960); } }
    }
    if (broken) {                                                // a warm goodbye, not a punishment
      Sound.fx("feverout");
      toast("🔥 <b>beautiful run.</b>", 1600);
      if (x != null && !reduce) { burst.spawn(x, y, 5); showWarm(x, y, "✨ beautiful run."); }
    }
  }
  function showWarm(x, y, txt) {
    var p = tier(el("div", "av-ms-plus av-ms-plus--warm", txt));
    p.style.cssText += ";position:fixed;left:" + (x - 44) + "px;top:" + (y - 12) + "px;";
    document.body.appendChild(p); setTimeout(function () { p.remove(); }, 900);
  }
  function specRipple(x, y) {                                    // the game's ONLY rainbow — CHROME exclusive
    if (reduce) return;
    for (var i = 0; i < 2; i++) (function (k) { setTimeout(function () {
      var g = tier(el("div", "av-ms-specring" + (k ? " is-b" : "")));
      g.style.left = (x + (k ? 4 : 0)) + "px"; g.style.top = (y - (k ? 4 : 0)) + "px";
      document.body.appendChild(g); setTimeout(function () { g.remove(); }, 680);
    }, k * 60); })(i);
  }
  function chainSpark(src, x, y) {                               // aimed tracer shot at the NEAREST plain medal (+1, no chaining)
    if (reduce || perfNow() < magnet.until || perfNow() - lastSpark < 300) return;
    var RANGE = coarse ? 200 : 240;                              // long directional snipe on both platforms
    var best = null, bd = 1e9;
    for (var i = 0; i < mobs.length; i++) {
      var o = mobs[i];
      if (o === src || o.removed || o.el.__caught || o.bossFight || o.trapTok || o.special || o.chromeTok || (o.hp && o.hp > 1)) continue;
      var dx = (o.x + o._hw) - x, dy = (o.y + o._hh) - y, d = dx * dx + dy * dy;
      if (d < RANGE * RANGE && d < bd) { bd = d; best = o; }
    }
    if (!best) return;
    lastSpark = perfNow();
    var tx = best.x + best._hw, ty = best.y + best._hh;
    var dist = Math.sqrt(bd), dur = Math.max(90, Math.min(260, Math.round(dist * 1.1)));   // flight time reads at any range
    var ang = Math.round(Math.atan2(ty - y, tx - x) * 180 / Math.PI);
    var s = tier(el("div", "av-ms-spark"));
    s.style.transitionDuration = dur + "ms";
    s.style.transform = "translate(" + x + "px," + y + "px) rotate(" + ang + "deg)";
    document.body.appendChild(s);
    requestAnimationFrame(function () { requestAnimationFrame(function () {
      s.style.transform = "translate(" + tx + "px," + ty + "px) rotate(" + ang + "deg)";
    }); });
    (function (o2) { setTimeout(function () {
      s.remove();
      if (o2.removed || o2.el.__caught) return;
      o2.el.__caught = 1; o2.frozen = true; o2.el.classList.add("is-caught");
      setTimeout(function () { removeMob(o2); }, 330);
      gainCatch(1, o2.x + o2._hw, o2.y + o2._hh);
    }, dur + 20); })(best);
  }
  function showCrit(x, y) {
    var p = tier(el("div", "av-ms-plus av-ms-plus--crit", "CRITICAL!"));
    p.style.cssText += ";position:fixed;left:" + (x - 34) + "px;top:" + (y - 14) + "px;";
    document.body.appendChild(p); setTimeout(function () { p.remove(); }, 780);
    arenaShake();
  }
  var bossDying = false, KILLCAM = 1500, ENTRANCE = 1900;        // trophy-shot hold · boss arrival cinematic
  /* ================== ✂️ CUT THE PATTERN ==================================
     The boss's armour is a pre-cut template. You don't click it off — you DRAG
     through its anchor nodes to trace the cut line, exactly like the vector paths
     the store sells. One unbroken stroke = CLEAN CUT = two layers at once.
     ====================================================================== */
  /* ============ ✒️ PEN: draw vector curves that CAGE the boss ==============
     Two weapons, two phases. The pen draws smooth bezier walls the boss bounces
     off; when it stops making progress inside them the script calls it TRAPPED and
     holds it still — which is your window to switch to the knife and cut.
     ====================================================================== */
  var weapon = "pen", lines = [], ink = 1, linesSvg = null, drawing = null, weaponBar = null, bossO = null;
  // any press landing on arena CHROME is a UI click, never a stroke and never a catch
  var CHROME_SEL = ".av-ms-weapons,.av-ms-arena__foot,.av-ms-guide,.av-ms-arena__hud,.av-ms-arena__title";
  var trapHist = [], trapBounce = 0, trapUntil = 0, trapped = false;
  function cancelDraw() {                                        // a press that lands a catch must not also leave a stroke
    if (!drawing) return;
    if (drawing.el && drawing.el.parentNode) drawing.el.remove();
    drawing = null;
  }
  function penActive() { return !!weaponBar && weapon === "pen" && !bossDying && !guidePause; }
  function smoothPath(p) {                                       // quadratic-midpoint smoothing = the curvy vector look
    if (p.length < 2) return "";
    var d = "M " + p[0].x.toFixed(1) + " " + p[0].y.toFixed(1);
    for (var i = 1; i < p.length - 1; i++) {
      d += " Q " + p[i].x.toFixed(1) + " " + p[i].y.toFixed(1) + " " +
           ((p[i].x + p[i + 1].x) / 2).toFixed(1) + " " + ((p[i].y + p[i + 1].y) / 2).toFixed(1);
    }
    return d + " L " + p[p.length - 1].x.toFixed(1) + " " + p[p.length - 1].y.toFixed(1);
  }
  function svgEl(t) { return document.createElementNS("http://www.w3.org/2000/svg", t); }
  // A guide card is a READING moment: the round freezes while it's up, you close it
  // with ✕ (or let it run out), and a big GO! tells you play has resumed.
  var guidePause = false, guideEl = null, guideT = 0, guideTick = 0;
  function closeGuide(silent) {
    clearTimeout(guideT); clearInterval(guideTick);
    if (!guideEl) return;
    var g = guideEl; guideEl = null; guidePause = false;
    g.classList.remove("is-in");
    setTimeout(function () { if (g.parentNode) g.remove(); }, 420);
    if (!silent) goSplash();
  }
  function goSplash() {
    var host = (arena && arena.querySelector(".av-ms-arena")) || overlay;
    if (!host || reduce) return;
    var s = tier(el("div", "av-ms-go", "GO!"));
    host.appendChild(s); Sound.fx("go"); buzz([14, 40, 14]);
    setTimeout(function () { if (s.parentNode) s.remove(); }, 950);
  }
  function guideCard(host, title, steps, ms) {
    if (!host) return;
    closeGuide(true);                                            // one card at a time, no GO between them
    [].forEach.call(document.querySelectorAll(".av-ms-guide"), function (o) { o.remove(); });
    var dur = ms || 9000, left = Math.ceil(dur / 1000);
    var g = tier(el("div", "av-ms-guide"));
    g.innerHTML = '<button class="av-ms-guide__x" type="button" aria-label="Skip and start now">✕</button>' +
      '<b>' + title + '</b>' +
      // the step text MUST sit in its own wrapper: the row is a flex container, and a bare
      // <em>/<b> inside it would become a separate flex ITEM and break the sentence apart
      steps.map(function (s, i) { return '<p><i>' + (i + 1) + '</i><span>' + s + '</span></p>'; }).join("") +
      '<u>⏸ Paused — starts in <em data-gsec>' + left + '</em>s · tap ✕ to go now</u>' +
      '<s class="av-ms-guide__bar" style="animation-duration:' + dur + 'ms"></s>';
    host.appendChild(g);
    guideEl = g; guidePause = true;                              // ⏸ the round clock stops while you read
    var x = g.querySelector(".av-ms-guide__x");
    x.addEventListener("pointerdown", function (ev) { ev.preventDefault(); ev.stopPropagation(); closeGuide(); }, true);
    x.addEventListener("click", function (ev) { ev.stopPropagation(); closeGuide(); }, true);   // keyboard / fallback
    requestAnimationFrame(function () { requestAnimationFrame(function () { g.classList.add("is-in"); }); });
    guideTick = setInterval(function () {                        // a visible countdown: the card is plainly temporary
      var n = g.querySelector("[data-gsec]");
      if (--left <= 0) { clearInterval(guideTick); left = 0; }
      if (n) n.textContent = left;
    }, 1000);
    guideT = setTimeout(closeGuide, dur);
  }
  var tutForce = false;                                          // level 1 replays every tutorial, seen or not
  function seenOnce(key) {
    try { if (localStorage.getItem(key)) return tutForce ? false : true; localStorage.setItem(key, "1"); } catch (e) {}
    return false;
  }
  // ✒️ the PEN is available from the very first second of every round — walls trap
  // ordinary medals too (and fade after ~3s). The ✂️ knife only joins at the boss.
  function weaponsInit(host) {
    weapon = "pen"; lines = []; ink = 1; drawing = null;
    bossO = null; trapped = false; trapHist = []; trapBounce = 0; trapUntil = 0;
    if (!host || reduce) return;
    linesSvg = svgEl("svg"); linesSvg.setAttribute("class", "av-ms-lines"); host.appendChild(linesSvg);
    weaponBar = tier(el("div", "av-ms-weapons"));
    weaponBar.innerHTML = '<button type="button" data-w="pen" class="is-on"><b>✒️</b><span>DRAW</span><i></i></button>';
    host.appendChild(weaponBar);
    weaponBar.addEventListener("pointerdown", function (ev) {
      var b = ev.target.closest("[data-w]"); if (!b) return;
      ev.stopPropagation(); setWeapon(b.getAttribute("data-w"));
    }, true);
    if (!seenOnce("av_ms_tut_pen")) guideCard(host, "✒️ YOUR TOOL: VECTOR LINES", [
      "Hold and <em>drag</em> anywhere to draw a curve.",
      "Curves are <em>walls</em> — medals bounce off them, so you can corral them.",
      "They fade after a few seconds. Ink refills by itself."
    ], 16000);
  }
  function weaponsEnd() {
    bossO = null; trapped = false; weapon = "pen";
    if (linesSvg) { linesSvg.remove(); linesSvg = null; }
    if (weaponBar) { weaponBar.remove(); weaponBar = null; }
    lines = []; drawing = null;
  }
  function bossPhaseStart(o) {                                   // the boss brings the SECOND weapon
    bossO = o; trapHist = []; trapBounce = 0; trapped = false; trapUntil = 0;
    lines.slice().forEach(killLine);                             // clean slate: pre-boss webs do not carry over
    for (var su = 0; su < mobs.length; su++) if (mobs[su].stuck) unstick(mobs[su]);
    var host = (arena && arena.querySelector(".av-ms-arena")) || overlay;
    if (!host || reduce || !weaponBar || !o.hpShield) return;    // no armour -> no blade, and no "tap CUT" hint
    var kb = el("button", "", '<b>✂️</b><span>CUT</span><i></i>');
    kb.type = "button"; kb.setAttribute("data-w", "knife"); kb.classList.add("is-new");
    weaponBar.appendChild(kb);
    setTimeout(function () { kb.classList.remove("is-new"); }, 2200);
    Sound.fx("goldflip");
    toast("✂️ <b>NEW WEAPON: CUT</b>", 2600);
    if (!seenOnce("av_ms_tut_boss")) guideCard(host, "🎯 BOSS TUTORIAL — PIN IT, THEN CUT IT", [
      "✒️ <em>DRAW</em> curves around the boss to <b>box it in</b> — it bounces off your walls.",
      "When it can’t move it goes <b>TRAPPED</b> and the ✂️ button starts flashing.",
      "Tap ✂️ <em>CUT</em>, then drag through the nodes to peel its armour and finish it."
    ], 22000);
    else guideCard(host, "🎯 HOW TO BEAT IT", [
      "✒️ Box it in with curves until it’s <b>TRAPPED</b>.",
      "✂️ Then switch to CUT and drag through the nodes."
    ], 13000);
  }
  function bossPhaseEnd() {
    bossO = null; trapped = false;
    var kb = weaponBar && weaponBar.querySelector('[data-w="knife"]');
    if (kb) kb.remove();
    lines.slice().forEach(killLine);                             // the cage dies with the boss
    setWeapon("pen");
  }
  function setWeapon(w) {
    if (!weaponBar) return;
    if (w === "knife" && !weaponBar.querySelector('[data-w="knife"]')) return;   // no knife before the boss
    if (weapon === w) return;
    weapon = w;
    [].forEach.call(weaponBar.querySelectorAll("[data-w]"), function (b) {
      b.classList.toggle("is-on", b.getAttribute("data-w") === w);
      if (b.getAttribute("data-w") === "knife" && w === "knife") b.classList.remove("is-urge");
    });
    Sound.fx("check");
    if (drawing) finishStroke();                                 // never leave a half-drawn wall behind
    if (w === "knife") { if (bossO && bossO.hpShield) startCut(bossO); }
    else cutClear();                                             // ✂️ is completely off while drawing
  }
  function addLine(pts) {
    if (pts.length < 2 || !linesSvg) return;
    var p = svgEl("path");
    p.setAttribute("class", "av-ms-line");
    p.setAttribute("d", smoothPath(pts));
    linesSvg.appendChild(p);
    var anchors = [];
    for (var i = 0; i < pts.length; i += Math.max(1, Math.round(pts.length / 4))) {
      var r = svgEl("rect");
      r.setAttribute("class", "av-ms-lineanchor");
      r.setAttribute("x", (pts[i].x - 4).toFixed(1)); r.setAttribute("y", (pts[i].y - 4).toFixed(1));
      r.setAttribute("width", 8); r.setAttribute("height", 8);
      linesSvg.appendChild(r); anchors.push(r);
    }
    // before the boss walls are temporary (~3s) so the field can't be scribbled shut;
    // once the boss is out they stay up until it dies.
    var ln = { pts: pts, el: p, anchors: anchors, born: perfNow(), life: bossO ? 1e9 : 6000 };
    lines.push(ln);
    while (lines.length > (bossO ? 6 : 4)) killLine(lines[0]);   // keep the field readable and the math cheap
    Sound.fx("cutdone");
  }
  function killLine(ln) {
    var k = lines.indexOf(ln); if (k > -1) lines.splice(k, 1);
    for (var u = 0; u < mobs.length; u++) if (mobs[u].stuck === ln) unstick(mobs[u]);
    if (ln.el) { ln.el.classList.add("is-gone"); (function (e) { setTimeout(function () { if (e.parentNode) e.remove(); }, 400); })(ln.el); }
    ln.anchors.forEach(function (a) { setTimeout(function () { if (a.parentNode) a.remove(); }, 400); });
  }
  function linesTick(now) {                                      // walls age out on their own
    for (var i = lines.length - 1; i >= 0; i--) if (now - lines[i].born > lines[i].life) killLine(lines[i]);
  }
  // 🕸 STICKY WEB — before the boss, a drawn curve CATCHES medals instead of batting
  // them away. Bouncing looked good but was useless: a deflected medal is no easier to
  // collect. Sticking turns the pen into a net — draw a web, then walk it and cash in.
  // The boss and its twins are exempt: their curves are a CAGE, and that fight is built
  // on bouncing them into a corner.
  function stickMob(o, ln, px, py, nx, ny, R) {
    if (o.stuck) return;
    o.stuck = ln;
    o.sbv = Math.max(0.6, Math.sqrt((o.bvx || 0) * (o.bvx || 0) + (o.bvy || 0) * (o.bvy || 0)) || 1.2);
    o.vx = 0; o.vy = 0; o.bvx = 0; o.bvy = 0;
    o.x = px + nx * R - o._hw; o.y = py + ny * R - o._hh;         // snap it onto the strand
    o.el.classList.add("is-stuck");
    if (now2 - (o.lastPing || 0) > 90) { o.lastPing = now2; Sound.fx("cutsnap"); }
  }
  function unstick(o) {
    if (!o.stuck) return;
    o.stuck = 0;
    o.el.classList.remove("is-stuck");
    // NEVER release with a zero baseline — motionStep eases velocity toward it, so the
    // medal would silently coast to a dead stop (the same trap doTrap once fell into).
    var a = Math.random() * 6.283, sp = o.sbv || 1.2;
    o.bvx = Math.cos(a) * sp; o.bvy = Math.sin(a) * sp;
    o.vx = o.bvx * 1.6; o.vy = o.bvy * 1.6;
  }
  var now2 = 0;                                                   // lineBounce shares its clock with stickMob

  function lineBounce(o, now, isBoss) {                          // EVERYTHING in the arena hits the drawn walls
    if (!lines.length) { o.bounceRun = 0; return; }
    // A PINNED boss is positionally immovable — motionStep zeroes its velocity every frame,
    // so de-penetrating it here can only teleport it (and the cut template anchored to it).
    // Safe: every exit from `trapped` (breakFree / releaseBoss / bossPhaseEnd) kills the
    // walls in the same call, so it can never un-pin while still inside one.
    if (isBoss && (trapped || bossDying)) { o.bounceRun = 0; return; }
    now2 = now;
    if (o.stuck) return;                                        // already caught in the web
    var cx = o.x + o._hw, cy = o.y + o._hh, R = o._hw * 0.92, hit = false;
    var REST = isBoss ? 0.62 : 0.88;                             // restitution < 1: a wedged boss must bleed energy
    var ax = 0, ay = 0;                                          // corrections ACCUMULATE and land once, below
    for (var i = lines.length - 1; i >= 0; i--) {
      var ln = lines[i];
      if (!ln.el.parentNode) continue;
      // A polyline is ONE surface, so resolve only its CLOSEST point. Pushing per
      // overlapping segment counted the same contact ~7 times (a wall is sampled every
      // 12px, the boss radius is ~42px) and injected ~100px of position per frame — that
      // is the thrashing when a line is drawn through a boss that is already boxed in.
      var bd2 = R * R, bpx = 0, bpy = 0, bsx = 0, bsy = 0, found = false;
      for (var j = 0; j < ln.pts.length - 1; j++) {
        var a = ln.pts[j], b = ln.pts[j + 1];
        var sx = b.x - a.x, sy = b.y - a.y, L2 = sx * sx + sy * sy || 1;
        var t = Math.max(0, Math.min(1, ((cx - a.x) * sx + (cy - a.y) * sy) / L2));
        var px = a.x + sx * t, py = a.y + sy * t, dx = cx - px, dy = cy - py, d2 = dx * dx + dy * dy;
        if (d2 >= bd2) continue;                                 // rejects "no overlap" AND "not the deepest"
        bd2 = d2; bpx = px; bpy = py; bsx = sx; bsy = sy; found = true;
      }
      if (!found) continue;
      var d = Math.sqrt(bd2), nx, ny;
      if (d > 0.5) { nx = (cx - bpx) / d; ny = (cy - bpy) / d; }
      else {                                                     // drawn dead through the centre: sub-pixel
        var sl = Math.sqrt(bsx * bsx + bsy * bsy) || 1;          // geometry is pure noise, so take the segment's
        nx = -bsy / sl; ny = bsx / sl;                           // own perpendicular and eject the way it came
        if (nx * o.vx + ny * o.vy > 0) { nx = -nx; ny = -ny; }
      }
      // pre-boss: ordinary medals are CAUGHT by the strand rather than deflected
      if (!bossO && !o.bossFight && !o.el.classList.contains("is-decoy") && !o.el.classList.contains("is-key")) {
        stickMob(o, ln, bpx, bpy, nx, ny, R);
        ln.el.classList.remove("is-ping"); void ln.el.getBBox; ln.el.classList.add("is-ping");
        return;
      }
      var dot = o.vx * nx + o.vy * ny;
      if (dot < 0) {                                             // ONE reflection per WALL, not per segment
        o.vx = (o.vx - 2 * dot * nx) * REST;                     // (7 reflections meant REST^7 = 0.035, which
        o.vy = (o.vy - 2 * dot * ny) * REST;                     //  annihilated velocity and made every damper
        o.bvx = o.vx * 0.5; o.bvy = o.vy * 0.5;                  //  downstream a no-op)
      }
      ax += nx * (R - d); ay += ny * (R - d);                    // separate walls ARE separate surfaces: a corner
      if (!hit) { hit = true; if (isBoss) trapBounce++;          // must push out of both, so these do sum
        ln.el.classList.remove("is-ping"); void ln.el.getBBox; ln.el.classList.add("is-ping");
        if (now - (o.lastPing || 0) > 120) { o.lastPing = now; Sound.fx("cutsnap"); if (!reduce) burst.spawn(bpx, bpy, 2); } }
    }
    // Applied ONCE, and deliberately UNCAPPED: a capped push could leave a body still
    // inside the wall, and next frame it would be resolved to the far side — i.e. walls
    // would become permeable, which is worse than the jitter this fixes.
    o.x += ax; o.y += ay;
    if (!isBoss) return;
    o.bounceRun = hit ? (o.bounceRun || 0) + 1 : 0;
    if (o.bounceRun > 5) { o.vx *= 0.55; o.vy *= 0.55; o.bvx *= 0.55; o.bvy *= 0.55; }   // stop the jackhammer
    if (o.bounceRun > 14 && !trapped && !bossDying) doTrap(o);   // pinned in a niche IS a cage - reward it
  }
  function trapTick(o, now) {                                    // "is it stuck?" — small travel box + real wall hits
    if (trapped || !bossO || bossDying) return;
    trapHist.push({ t: now, x: o.x + o._hw, y: o.y + o._hh });
    while (trapHist.length && now - trapHist[0].t > 1500) trapHist.shift();
    if (trapHist.length < 12 || trapBounce < 3) return;
    var mnx = 1e9, mxx = -1e9, mny = 1e9, mxy = -1e9;
    trapHist.forEach(function (h) { mnx = Math.min(mnx, h.x); mxx = Math.max(mxx, h.x); mny = Math.min(mny, h.y); mxy = Math.max(mxy, h.y); });
    if (mxx - mnx < 190 && mxy - mny < 190) doTrap(o);
  }
  function doTrap(o) {
    trapped = true; trapUntil = perfNow() + 6000; trapBounce = 0; trapHist = [];
    o.vx *= 0.05; o.vy *= 0.05; o.bvx = 0; o.bvy = 0;
    o.el.classList.add("is-trapped");
    lines.forEach(function (ln) { ln.el.classList.add("is-locked"); ln.life = 12000; ln.born = perfNow(); });
    Sound.fx("bosshit"); hitStop(140); arenaShake(); buzz([25, 50, 25]);
    var hasBlade = !!(weaponBar && weaponBar.querySelector('[data-w="knife"]'));
    toast(hasBlade ? "🕸 <b>TRAPPED!</b> Now tap ✂️ CUT" : "🕸 <b>TRAPPED!</b> Hit it now!", 3200);
    // the player picks the weapon — we only make the right button impossible to miss
    if (weaponBar && weapon !== "knife") {
      var kb = weaponBar.querySelector('[data-w="knife"]');
      if (kb) kb.classList.add("is-urge");                       // stays lit until they arm it or it breaks free
    }
  }
  function breakFree(o) {
    releaseBoss(o);                                              // same restore as a phase change — it must MOVE after
    Sound.fx("bossdie"); arenaShake(); buzz([30, 60]);
    toast("💥 <b>It broke free!</b> ✒️ Cage it again", 2600);
    if (weaponBar) {
      var kb2 = weaponBar.querySelector('[data-w="knife"]'); if (kb2) kb2.classList.remove("is-urge");
      var pb = weaponBar.querySelector('[data-w="pen"]');
      if (pb) { pb.classList.add("is-urge"); setTimeout(function () { pb.classList.remove("is-urge"); }, 5000); }
    }
    if (!o.removed) enrage(o);                                   // releaseBoss already set the velocity + baseline
  }
  var cut = null;
  function cutClear() {
    if (blade) { blade.remove(); blade = null; }
    if (!cut) return;
    clearTimeout(cut.graceT);
    if (cut.wrap && cut.wrap.parentNode) cut.wrap.remove();
    cut = null;
  }
  function startCut(o) {
    if (weapon !== "knife") return;                              // the blade only exists while CUT is the armed weapon
    if (!o || o.removed || o.el.__caught || !o.hpShield || reduce) return;
    cutClear();
    var host = (arena && arena.querySelector(".av-ms-arena")) || overlay;
    if (!host) return;
    var n = funMode ? (funLevel >= 10 ? 5 : funLevel >= 5 ? 4 : 3) : 3;
    var W = Math.round(Math.min(300, FLD.w * 0.6)), PAD = 34, H = 132;
    var wrap = tier(el("div", "av-ms-cutwrap"));
    wrap.style.width = (W + PAD * 2) + "px"; wrap.style.height = H + "px";
    wrap.style.marginLeft = -((W + PAD * 2) / 2) + "px"; wrap.style.marginTop = -(H / 2) + "px";
    var pts = [], i;
    for (i = 0; i < n; i++) {
      var t = i / (n - 1);
      pts.push({ x: PAD + W * t, y: H / 2 + (i % 2 ? 1 : -1) * rnd(16, 38) });
    }
    var poly = pts.map(function (p) { return p.x.toFixed(0) + " " + p.y.toFixed(0); }).join(", ");
    wrap.innerHTML =
      '<svg class="av-ms-cutsvg" viewBox="0 0 ' + (W + PAD * 2) + ' ' + H + '">' +
        '<polyline class="guide" points="' + poly + '" />' +
        '<polyline class="drag" points="" />' +
        '<polyline class="live" points="" />' +
      '</svg>';
    pts.forEach(function (p, k) {
      var nd = el("span", "av-ms-cutnode");
      nd.style.left = p.x + "px"; nd.style.top = p.y + "px";
      nd.setAttribute("data-i", k);
      if (k === 0) nd.classList.add("is-next");
      wrap.appendChild(nd);
      p.el = nd;
    });
    host.appendChild(wrap);
    cut = { o: o, wrap: wrap, pts: pts, hit: 0, stroke: false, broke: false,
            hw: (W + PAD * 2) / 2, hh: H / 2,                     // cached: cutFollow runs every frame
            live: wrap.querySelector(".live"), drag: wrap.querySelector(".drag"), graceT: 0 };
    cutFollow();
    toast("✂️ <b>CUT THE PATTERN</b> — hold and drag through the nodes", 2800);
  }
  // Forgiving, distance-based hit test on the NEXT node only — elementFromPoint on a
  // 15px square made cutting feel like guesswork.
  function cutTry(x, y) {
    if (!cut || cut.done || !cut.stroke) return;
    var p = cut.pts[cut.hit]; if (!p) return;
    var r = p.el.getBoundingClientRect(), dx = x - (r.left + r.width / 2), dy = y - (r.top + r.height / 2);
    var R = coarse ? 46 : 36;
    if (dx * dx + dy * dy <= R * R) cutNodeHit(p.el);
    else if (dx * dx + dy * dy <= (R * 2) * (R * 2)) p.el.classList.add("is-near");
    else p.el.classList.remove("is-near");
  }
  function cutDrag(x, y) {                                       // rubber band from the last node to the cursor = "I am cutting"
    if (!cut || cut.done || !cut.drag) return;
    if (!cut.stroke || !cut.hit) { cut.drag.setAttribute("points", ""); return; }
    var wr = cut.wrap.getBoundingClientRect(), sc = (cut.wrap.offsetWidth || 1) / (wr.width || 1);
    var last = cut.pts[cut.hit - 1];
    cut.drag.setAttribute("points", last.x.toFixed(0) + " " + last.y.toFixed(0) + ", " +
      ((x - wr.left) * sc).toFixed(0) + " " + ((y - wr.top) * sc).toFixed(0));
  }
  function bladeAt(x, y, on) {                                   // a visible blade so you always see where you cut
    if (reduce) return;
    if (!on) { if (blade) { blade.remove(); blade = null; } return; }
    if (!blade) { blade = tier(el("div", "av-ms-blade")); document.body.appendChild(blade); }
    blade.style.transform = "translate(" + x + "px," + y + "px)";
    blade.classList.toggle("is-cutting", !!(cut && cut.stroke));
  }
  var blade = null;
  function cutFollow() {                                         // the template rides on the boss
    if (!cut || !cut.o || cut.o.removed) return;
    var tx = cut.o.x + cut.o._hw, ty = cut.o.y + cut.o._hh;
    // CLAMP into the arena: cornered bosses used to carry half the template (and its
    // first nodes) off-screen, where you could neither see nor reach the cut. The wrap
    // is centred on this point by negative margins, so clamping the centre by its own
    // half-size keeps every node visible. Uses innerWidth/Height - reading layout here
    // would force a reflow every frame.
    var m = 8;
    tx = Math.max(FLD.x0 + cut.hw + m, Math.min(FLD.x1 - cut.hw - m, tx));
    ty = Math.max(cut.hh + m, Math.min(innerHeight - cut.hh - m, ty));
    cut.wrap.style.transform = "translate(" + tx.toFixed(1) + "px," + ty.toFixed(1) + "px)";
  }
  function cutNodeHit(nd) {
    if (!cut || cut.done || weapon !== "knife" || guidePause) return;
    var k = parseInt(nd.getAttribute("data-i"), 10);
    if (k !== cut.hit) return;                                   // must follow the path in order
    var p = cut.pts[k];
    p.el.classList.remove("is-next", "is-near"); p.el.classList.add("is-hit");
    cut.hit++;
    cut.live.setAttribute("points", cut.pts.slice(0, cut.hit).map(function (q) { return q.x.toFixed(0) + " " + q.y.toFixed(0); }).join(", "));
    Sound.fx("cutsnap"); buzz(8);
    if (!reduce) { var r = p.el.getBoundingClientRect(); burst.spawn(r.left + r.width / 2, r.top + r.height / 2, 3); }
    if (cut.hit < cut.pts.length) cut.pts[cut.hit].el.classList.add("is-next");
    else cutFinish();
  }
  function cutFinish() {
    if (!cut || cut.done || weapon !== "knife" || guidePause) return;
    cut.done = true;
    var o = cut.o, clean = !cut.broke, w = cut.wrap;
    w.classList.add("is-done"); if (clean) w.classList.add("is-clean");
    Sound.fx("cutdone"); hitStop(clean ? 140 : 100); arenaShake(); buzz(clean ? [20, 40, 20, 40, 30] : [20, 50]);
    var rr = w.getBoundingClientRect();
    if (!reduce) { burst.spawn(rr.left + rr.width / 2, rr.top + rr.height / 2, clean ? 16 : 10); impactRing(rr.left + rr.width / 2, rr.top + rr.height / 2); }
    var layers = clean ? 2 : 1;
    o.hpShield = Math.max(0, o.hpShield - layers);
    bossRibbon(o);
    if (clean) { Sound.fx("goldflip"); toast("✂️ <b>CLEAN CUT!</b> Two layers peeled", 2400); }
    else toast(o.hpShield ? "✂️ <b>Cut made</b> — " + o.hpShield + " layer" + (o.hpShield > 1 ? "s" : "") + " left" : "✂️ <b>Template stripped!</b> Now hurt it", 2200);
    setTimeout(function () {
      cutClear();
      if (o.removed || o.el.__caught) return;
      if (o.hpShield) { bossNextPhase(o); return; }               // cage spent -> it breaks loose again
      endCutPhase(o);                                            // armour gone -> PHASE 2
    }, 620);
  }
  function phaseBanner(title, sub) {                             // a beat that says "that phase is over"
    var host = arena && arena.querySelector(".av-ms-arena");
    if (!host || reduce) return;
    var b = tier(el("div", "av-ms-phase", "<b>" + title + "</b><span>" + sub + "</span>"));
    host.appendChild(b);
    Sound.fx("bossin"); hitStop(120); arenaShake(); buzz([20, 55, 20]);
    setTimeout(function () { b.classList.add("is-out"); }, 1450);
    setTimeout(function () { if (b.parentNode) b.remove(); }, 2050);
  }
  // A peeled layer ends a PHASE: the cage is spent, so the walls shatter with it and the
  // boss breaks loose to be trapped somewhere new. Without this it stayed pinned in the
  // same walls and every remaining layer was cut for free in the same spot.
  function releaseBoss(o) {                                      // a phase ends -> the cage is spent, it runs loose
    trapped = false; trapUntil = 0; trapBounce = 0; trapHist = [];
    if (o) o.el.classList.remove("is-trapped");
    lines.slice().forEach(killLine);
    if (!o || o.removed) return;
    // doTrap zeroes the BASELINE drift (bvx/bvy) and motionStep eases velocity toward it,
    // so restoring only vx/vy left the boss coasting to a dead stop a second later — which
    // is why the next phase started with it standing still. enrage() could not rescue it
    // either: it MULTIPLIES the baseline, and 0 x 1.28 is still 0.
    var ang = Math.random() * 6.283, sp = Math.max(1.4, (o.maxSp || 4) * 0.45);
    o.bvx = Math.cos(ang) * sp; o.bvy = Math.sin(ang) * sp;      // a real baseline again…
    o.vx = o.bvx * 2.6; o.vy = o.bvy * 2.6;                      // …plus a visible kick out of the cage
    o.bounceRun = 0;
  }
  function bossNextPhase(o) {
    var left = o.hpShield, total = o.armour0 || left, done = total - left;
    setWeapon("pen");                                            // the blade is useless while it runs loose
    releaseBoss(o);
    if (!o.removed) enrage(o);
    phaseBanner("⚔ PHASE " + done + " CLEARED",                  // `done` = layers peeled so far, and a CLEAN cut peels 2
      left + " layer" + (left > 1 ? "s" : "") + " left — it broke loose, cage it again");
    if (weaponBar) {
      var kb = weaponBar.querySelector('[data-w="knife"]'); if (kb) kb.classList.remove("is-urge");
      var pb = weaponBar.querySelector('[data-w="pen"]');
      if (pb) { pb.classList.add("is-urge"); setTimeout(function () { pb.classList.remove("is-urge"); }, 4200); }
    }
  }
  // PHASE 2: no armour left, so the blade has no job. Retire it, re-arm the pen
  // automatically, and the fight becomes "spot the real one among the twins and hit it".
  function endCutPhase(o) {
    cutClear();
    setWeapon("pen");
    var kb = weaponBar && weaponBar.querySelector('[data-w="knife"]');
    if (kb) { kb.classList.add("is-spent"); setTimeout(function () { if (kb.parentNode) kb.remove(); }, 420); }
    releaseBoss(o);                                              // the cage falls too — a pinned boss would give
    enrage(o);                                                   // the twins away instantly, killing the disguise
    phaseBanner("🛡 ARMOUR STRIPPED", "Final phase — spot the real one and hit it");
    toast("🛡 <b>Armour stripped!</b> ✒️ Lines only now — find the REAL one and hit it", 3600);
    var host = (arena && arena.querySelector(".av-ms-arena")) || overlay;
    if (host && !seenOnce("av_ms_tut_phase2")) guideCard(host, "🎭 PHASE 2 — SPOT THE REAL ONE", [
      "Its <em>twins</em> look identical — only a hit tells them apart.",
      "✒️ Your curves still work: wall them in, then <em>hit</em> the real boss.",
      "A twin just pops with a “Decoy!” — no harm, keep hunting."
    ], 18000);
  }
  function cutBreak() {                                          // stroke lifted mid-path -> short grace, then reset
    if (!cut || cut.done || !cut.hit) return;
    cut.broke = true;
    cut.graceT = setTimeout(function () {
      if (!cut || cut.done || weapon !== "knife" || guidePause) return;
      cut.pts.forEach(function (p, k) { p.el.classList.remove("is-hit", "is-next"); if (!k) p.el.classList.add("is-next"); });
      cut.hit = 0; cut.live.setAttribute("points", "");
      cut.wrap.classList.remove("is-broke");
      Sound.fx("crack"); toast("✂️ Cut lost — start again", 1500);
    }, 1300);
    cut.wrap.classList.add("is-broke");
  }
  /* ---- pen strokes: draw -> becomes a wall on release ---- */
  window.addEventListener("pointerdown", function (ev) {
    if (!penActive() || ink < 0.06) { if (penActive()) outOfInk(); return; }
    if (ev.target && ev.target.closest && ev.target.closest(CHROME_SEL)) return;   // never swallow a UI button
    ev.preventDefault();                                         // stop text-selection / native drag stealing the gesture
    drawing = { pts: [{ x: ev.clientX, y: ev.clientY }], el: svgEl("path"), id: ev.pointerId };
    drawing.el.setAttribute("class", "av-ms-line is-draft");
    if (linesSvg) {
      linesSvg.appendChild(drawing.el);
      // capture the pointer so a FAST drag can never outrun the element under it
      try { if (linesSvg.parentNode && linesSvg.parentNode.setPointerCapture) linesSvg.parentNode.setPointerCapture(ev.pointerId); } catch (e) {}
    }
  }, true);
  window.addEventListener("pointermove", function (ev) {
    if (!drawing || !penActive()) return;
    var last = drawing.pts[drawing.pts.length - 1];
    var dx = ev.clientX - last.x, dy = ev.clientY - last.y, d2 = dx * dx + dy * dy;
    if (d2 < 144) return;                                        // sample every ~12px: smooth but cheap
    var d = Math.sqrt(d2);
    if (d > 90 && ev.getCoalescedEvents) {                       // a fast flick can skip pixels — fill the gap in
      var co = ev.getCoalescedEvents();
      for (var ci = 0; ci < co.length; ci++) {
        var lp = drawing.pts[drawing.pts.length - 1], cdx = co[ci].clientX - lp.x, cdy = co[ci].clientY - lp.y;
        if (cdx * cdx + cdy * cdy >= 144) drawing.pts.push({ x: co[ci].clientX, y: co[ci].clientY });
      }
    }
    ink -= d / 5200;                                             // roomier ink so a full cage never runs dry mid-stroke
    drawing.pts.push({ x: ev.clientX, y: ev.clientY });
    drawing.el.setAttribute("d", smoothPath(drawing.pts));
    paintInk();
    if (ink <= 0) { ink = 0; finishStroke(); outOfInk(); }
  }, { passive: true });
  function outOfInk() {
    if (!weaponBar) return;
    var b = weaponBar.querySelector('[data-w="pen"]');
    if (!b || b.classList.contains("is-dry")) return;
    b.classList.add("is-dry"); Sound.fx("trap");
    toast("✒️ <b>Out of ink</b> — it refills, keep it short", 1800);
    setTimeout(function () { b.classList.remove("is-dry"); }, 1400);
  }
  function finishStroke() {
    if (!drawing) return;
    var pts = drawing.pts;
    if (drawing.el.parentNode) drawing.el.remove();
    drawing = null;
    if (pts.length >= 2) addLine(pts);
  }
  window.addEventListener("pointerup", function () { if (drawing) finishStroke(); }, { passive: true });
  window.addEventListener("pointercancel", function () { if (drawing) finishStroke(); }, { passive: true });
  function paintInk() {
    if (!weaponBar) return;
    var b = weaponBar.querySelector('[data-w="pen"] i');
    if (b) b.style.transform = "scaleY(" + Math.max(0, Math.min(1, ink)).toFixed(3) + ")";
  }
  window.addEventListener("pointerdown", function (ev) {
    if (!cut || cut.done || weapon !== "knife" || guidePause) return;
    if (ev.target && ev.target.closest && ev.target.closest(CHROME_SEL)) return;
    cut.stroke = true; clearTimeout(cut.graceT); cut.wrap.classList.add("is-live"); cut.wrap.classList.remove("is-broke");
    cutTry(ev.clientX, ev.clientY); cutDrag(ev.clientX, ev.clientY); bladeAt(ev.clientX, ev.clientY, true);
  }, true);
  window.addEventListener("pointermove", function (ev) {
    if (!cut || cut.done || weapon !== "knife" || guidePause) return;
    bladeAt(ev.clientX, ev.clientY, true);
    if (!cut.stroke) return;
    cutTry(ev.clientX, ev.clientY);
    cutDrag(ev.clientX, ev.clientY);
  }, { passive: true });
  window.addEventListener("pointerup", function () {
    if (!cut || cut.done || weapon !== "knife" || guidePause) return;
    cut.stroke = false; cut.wrap.classList.remove("is-live"); cutDrag(0, 0); bladeAt(0, 0, false);
    if (cut.hit && cut.hit < cut.pts.length) cutBreak();
  }, { passive: true });
  function bossDeath(o, worth, cx, cy) {                         // FINAL BLOW: the boss goes out with a show
    if (o.el.__caught || bossDying) return;
    o.el.__caught = 1; o.frozen = true; bossDying = true;
    cutClear(); bossPhaseEnd();                                  // ✂️ put the tools away
    o.el.classList.add("is-dying");
    Sound.fx("bossdie"); buzz([30, 60, 30, 60, 80]);
    hitStop(220); arenaShake(); slowmo = 0.35;
    // KILL CAM: dim the arena and glide the boss to centre stage so its artwork is
    // actually readable — the old version popped in place and was over too fast.
    var host = (arena && arena.querySelector(".av-ms-arena")) || document.body;
    var cam = null;
    if (!reduce) {
      cam = tier(el("div", "av-ms-killcam")); cam.innerHTML = "<i></i>";
      host.appendChild(cam);
      requestAnimationFrame(function () { requestAnimationFrame(function () { cam.classList.add("is-on"); }); });
      var x0 = o.x, y0 = o.y, tx = FLD.x0 + FLD.w / 2 - o._hw, ty = innerHeight * 0.42 - o._hh, t0c = perfNow();
      var glide = setInterval(function () {
        var k = Math.min(1, (perfNow() - t0c) / 520);
        var e = 1 - Math.pow(1 - k, 3);
        o.x = x0 + (tx - x0) * e; o.y = y0 + (ty - y0) * e;
        if (k >= 1) clearInterval(glide);
      }, 16);
      setTimeout(function () { clearInterval(glide); }, 900);
    }
    var decs = [];                                               // the decoys die with their master
    for (var di = 0; di < mobs.length; di++) if (mobs[di] !== o && !mobs[di].removed && mobs[di].el.classList.contains("is-decoy")) decs.push(mobs[di]);
    decs.forEach(function (d2, k) { setTimeout(function () {
      if (d2.removed || d2.el.__caught) return;
      d2.el.__caught = 1; d2.frozen = true; d2.el.classList.add("is-caught");
      if (!reduce) burst.spawn(d2.x + d2._hw, d2.y + d2._hh, 4);
      setTimeout(function () { removeMob(d2); }, 300);
    }, 140 + k * 150); });
    (function (m) { setTimeout(function () {                     // TROPHY SHOT: the enlarged boss gets STAMPED
      if (!document.body.contains(m.el)) return;
      m.el.appendChild(el("span", "av-ms-token__defeated", "DEFEATED"));
      Sound.fx("bosshit"); buzz(40); arenaShake();
    }, reduce ? 240 : 620); })(o);
    var N = reduce ? 0 : 5;                                      // crackling mini-explosions across the boss
    for (var bi = 0; bi < N; bi++) (function (k) {
      setTimeout(function () {
        if (!document.body.contains(o.el)) return;
        var r = o.el.getBoundingClientRect();
        burst.spawn(r.left + r.width * (0.2 + Math.random() * 0.6), r.top + r.height * (0.2 + Math.random() * 0.6), 6);
        Sound.combo(k + 4); arenaShake();
      }, KILLCAM + k * 170);
    })(bi);
    setTimeout(function () {                                     // THE BIG ONE -> then the win flows as usual
      var r = o.el.getBoundingClientRect(), fx2 = r.left + r.width / 2, fy2 = r.top + r.height / 2;
      slowmo = 1; bossDying = false;
      if (cam) { cam.classList.remove("is-on"); setTimeout(function () { cam.remove(); }, 500); }
      if (!reduce) {
        burst.spawn(fx2, fy2, 24); impactRing(fx2, fy2); bloom();
        setTimeout(function () { impactRing(fx2, fy2); burst.spawn(fx2, fy2, 10); }, 130);   // double pulse reads on phones
        var sw = tier(el("div", "av-ms-shock")); document.body.appendChild(sw); setTimeout(function () { sw.remove(); }, 900);
      }
      o.el.classList.add("is-caught");
      setTimeout(function () { removeMob(o); }, 330);
      hitStop(160); arenaShake(); Sound.fx("bosshit");
      gainCatch(worth, fx2, fy2, true);                          // the killing blow banks the reserved points
    }, KILLCAM + N * 170 + 220);
  }
  var mobs = [], motionRaf = 0, lastMotionAt = 0, pointerX = -99999, pointerY = -99999;
  // ---- PLAY FIELD BAND -------------------------------------------------
  // On a wide desktop the arena used to span the whole monitor: medals crossed
  // enormous distances and the browser composited a huge surface every frame.
  // The field is now a CENTRED BAND ~20% narrower (never below 1100px, never
  // above 1900px) with the sides letterboxed. Coordinates stay in viewport
  // space on purpose — the band only moves the BOUNDS, so nothing shifts.
  // Touch keeps the full width: phone screens have no spare room to give away.
  var FLD = { x0: 0, x1: 0, w: 0 };
  function fieldSize() {
    var w = coarse ? innerWidth
                   : Math.min(innerWidth, Math.max(1100, Math.round(innerWidth * 0.8)), 1900);
    FLD.w = w; FLD.x0 = Math.round((innerWidth - w) / 2); FLD.x1 = FLD.x0 + w;
    if (arena) {
      var pf = arena.querySelector(".av-ms-arena");
      if (pf) pf.style.setProperty("--ms-bar", FLD.x0 + "px");
    }
  }
  fieldSize();
  addEventListener("resize", fieldSize);


  window.addEventListener("pointerdown", forgivingCatch, true);   // near-miss catch on EVERY device (touch too), before page handlers
  if (!coarse) {
    var trackPtr = function (e) { pointerX = e.clientX; pointerY = e.clientY; };
    window.addEventListener("pointermove", trackPtr, { passive: true });
    window.addEventListener("pointerdown", trackPtr, { passive: true });
    window.addEventListener("blur", function () { pointerX = pointerY = -99999; });
  }
  function buildOverlay() { overlay = el("div", "av-ms-overlay"); overlay.setAttribute("aria-hidden", "false"); document.body.appendChild(overlay); }
  function scheduleSpawn() {
    clearTimeout(spawnTimer);
    spawnTimer = setTimeout(function () { spawnAmbient(); scheduleSpawn(); }, rnd(1800, 3800));
  }
  function makeToken(rare, scale, boss, kind) {
    var b = tier(el("button", "av-ms-token")); b.type = "button";
    if (rare) b.classList.add("is-rare");
    if (boss) b.classList.add("is-boss");
    if (kind) b.classList.add("is-" + kind);                     // is-wild / is-chrome / is-time
    var h = Math.round(BASE * (scale || 1)), w = Math.round(h * 0.87);
    b.style.width = w + "px"; b.style.height = h + "px";
    var im = document.createElement("img");
    var tk = activeTier();
    b.setAttribute("data-tier", tk);                             // fun L5+ upgrades the whole look to gold/platinum
    im.className = "av-ms-token__img"; im.src = boss ? (BOSS_SRC[tk] || MEDAL_SRC) : (MEDALS[tk] || MEDAL_SRC); im.alt = ""; im.setAttribute("aria-hidden", "true");
    im.style.animationDelay = (-Math.random() * 4).toFixed(2) + "s";
    b.appendChild(im);
    if (boss) b.appendChild(el("span", "av-ms-token__ribbon", "FINAL"));
    if (kind === "wild") b.appendChild(el("span", "av-ms-token__q", "?"));
    if (kind === "time") b.appendChild(el("span", "av-ms-token__q", "+5s"));
    if (kind === "mag") b.appendChild(el("span", "av-ms-token__q", "🧲"));
    b.setAttribute("aria-label", boss ? "Catch the final medal" : kind === "wild" ? "Catch the mystery medal" : ("Catch a " + TIER_NAME + " milestone medal"));
    b._hw = w / 2; b._hh = h / 2;
    return b;
  }
  function addMob(o) {
    mobs.push(o);
    // WATCHDOG: also revive if the engine went quiet while motionRaf still holds a
    // stale id (the historical "all medals frozen forever" death mode).
    if (!motionRaf || perfNow() - lastMotionAt > 600) { try { cancelAnimationFrame(motionRaf); } catch (e) {} motionRaf = requestAnimationFrame(motionStep); }
  }
  function removeMob(o) { if (o.removed) return; o.removed = true; o.dead = true; if (o.el.parentNode) o.el.remove(); if (o.onGone) o.onGone(); }
  function catchMob(o, cx, cy) {
    if (o.el.__caught || o.removed) return;
    o.frozen = false;                                            // release the press-freeze (boss/heavy keep moving after a non-final hit)
    if (o.bossFight) {                                           // BOSS FIGHT: multi-hit, enrages between hits
      if (o.dashUntil && perfNow() < o.dashUntil) return;        // phasing mid-dash — untouchable
      if (o.hpShield) {                                          // ✂️ armoured: clicks bounce off — you must CUT the template
        if (reduce) {                                            // low-motion fallback keeps the old click-to-strip
          o.hpShield--; bossRibbon(o); Sound.fx("crack");
          toast(o.hpShield ? "🛡 <b>ARMOUR " + o.hpShield + " left</b>" : "🛡 <b>ARMOUR BROKEN!</b>", 1600);
          return;
        }
        Sound.fx("crack"); hitStop(70); buzz(18);
        if (!reduce) burst.spawn(cx, cy, 3);
        o.el.classList.remove("is-tease"); void o.el.offsetWidth; o.el.classList.add("is-tease");
        toast(weapon === "knife" ? "🛡 <b>Armoured!</b> Drag through the nodes to cut"
                                 : "🛡 <b>Armoured!</b> ✒️ Cage it, then pick ✂️ CUT", 1900);
        if (weapon === "knife" && !cut) startCut(o);              // never auto-arm the blade from a click
        return;
      }
      var crit = o.critUntil && perfNow() < o.critUntil, dmg = crit ? 2 : 1;   // weak-point window after the dash
      if (crit) { showCrit(cx, cy); hitStop(140); buzz([20, 40, 20, 40, 30]); }
      if (o.hp > dmg) { o.hp -= dmg; gainCatch(dmg, cx, cy, true); enrage(o); return; }   // only boss damage may pass GOAL-3
      bossDeath(o, o.hp, cx, cy);                                // FINAL BLOW: dramatic death, then banks remaining hits
      return;
    }
    if (!o.bossFight && o.hp && o.hp > 1) {                      // HEAVY medal: first hit only CRACKS it
      o.hp--; o.el.classList.add("is-cracked"); Sound.fx("crack"); buzz([10, 30, 10]);
      if (!reduce) burst.spawn(cx, cy, 4);
      o.vx += rnd(-1.6, 1.6); o.vy += rnd(-1.2, 1.2);            // knock it loose
      return;
    }
    o.el.__caught = 1; o.frozen = true;
    var r = o.el.getBoundingClientRect(); o.el.classList.add("is-caught");
    setTimeout(function () { removeMob(o); }, 330);
    if (o.special) { o.special(r.left + r.width / 2, r.top + r.height / 2); return; }   // "?" / ⏱ medals
    if (o.combo) { var now = perfNow(); combo = now - lastCatch < 900 ? combo + 1 : 1; lastCatch = now; if (combo > maxCombo) maxCombo = combo; if (combo >= 2) flashCombo(cx, cy); if (combo >= 8 && now > feverUntil) startFever(); }
    var w = o.worth || 1;
    if (perfNow() < feverUntil) w += 1;                          // 🔥 FEVER: everything +1
    if (o.chromeTok) { Sound.fx("chrome"); specRipple(cx, cy); hitStop(90); buzz([10, 30, 10, 30, 20]); }
    else if (w > 1) { hitStop(50); buzz([10, 40, 10]); }
    else buzz(8);
    gainCatch(w, r.left + r.width / 2, r.top + r.height / 2);
    chainSpark(o, r.left + r.width / 2, r.top + r.height / 2);
  }
  function bindCatch(o, worth) {
    o.worth = worth;
    o.el.addEventListener("click", function (ev) {
      ev.preventDefault();
      if (guidePause) return;                                    // ⏸ a tutorial card is up: the round has not started
      catchMob(o, ev.clientX, ev.clientY);
    });   // safety net for touch/keyboard — catchMob is idempotent (__caught guard)
  }
  function forgivingCatch(ev) {                        // a click NEAR a medal is enough (no pixel-perfect aim)
    if (guidePause) return;                                      // ⏸ nothing is catchable while the guide is up
    if (playHalted() || !mobs.length) return;
    if (ev.target && ev.target.classList && ev.target.classList.contains("av-ms-cutnode")) return;   // ✂️ the cut owns its own touches
    if (weapon === "knife" && cut) return;                       // ✂️ a cut stroke is never a catch
    if (ev.target && ev.target.closest && ev.target.closest(CHROME_SEL)) return;
    var best = null, bd = 1e9, near = null, nd = 1e9;
    for (var i = 0; i < mobs.length; i++) {
      var o = mobs[i]; if (o.removed || o.el.__caught) continue;
      var dx = (o.x + o._hw) - ev.clientX, dy = (o.y + o._hh) - ev.clientY, d = Math.sqrt(dx * dx + dy * dy);
      if (d < o._hw + 34 && d < bd) { bd = d; best = o; }
      if (d < nd) { nd = d; near = o; }
    }
    // PHASE 1 only: while the REAL boss still wears armour the blade owns it, so a pen
    // stroke across it never lands a hit. Once stripped (PHASE 2) hitting is the point.
    // Decoys are deliberately NOT protected — popping fakes is how you filter down to the
    // real one, and it must work in every phase (they spawn on armour hits too).
    if (best && best === bossO && bossO.hpShield && weapon === "pen") return;
    if (best) {                                                  // press-squash: 55ms anticipation, then the pop
      cancelDraw();                                              // this press is a catch, not a stroke
      best.frozen = true;                                        // stop dead ON press — no darting away mid-squash
      best.el.classList.add("is-press");
      (function (b, bx, by) { setTimeout(function () { b.el.classList.remove("is-press"); catchMob(b, bx, by); }, 55); })(best, ev.clientX, ev.clientY);
      return;
    }
    if (perfNow() < feverUntil) endFever(true, ev.clientX, ev.clientY);   // whiffed during FEVER -> a warm goodbye
    [].forEach.call(document.querySelectorAll(".av-ms-ember"), function (e2) { e2.remove(); });   // whiff snuffs the embers
    if (near && nd < 150 && perfNow() > (near.teaseCd || 0)) {   // near-miss: the medal wobbles, teasing you
      near.teaseCd = perfNow() + 1000;
      near.el.classList.add("is-tease");
      (function (m) { setTimeout(function () { if (!m.removed) m.el.classList.remove("is-tease"); }, 480); })(near);
    }
  }
  function motionStep(now) {
    lastMotionAt = now;                                          // heartbeat for the addMob watchdog
    if (lines.length) {                                          // ✒️ walls stop EVERYTHING in the arena
      linesTick(now);
      for (var dq = 0; dq < mobs.length; dq++) {
        var dm = mobs[dq];
        if (dm.removed || dm.el.__caught || dm.mode !== "arena") continue;
        lineBounce(dm, now, dm === bossO);
      }
    }
    if (ink < 1 && weaponBar) { ink = Math.min(1, ink + 0.0022); paintInk(); }
    if (now < tow.until) towTick(now);                          // 🧲 drag boss + twins toward the beam
    if (bossO && !bossO.removed && !bossDying) {                 // 🕸 cage detection + escape
      if (trapped) {
        bossO.vx = 0; bossO.vy = 0; bossO.bvx = 0; bossO.bvy = 0;   // PINNED: the template must not slide under the cursor
        if (now > trapUntil) breakFree(bossO);
      } else {
        // cutting is the precision beat, so take the shiver off the nodes — but only
        // gently: freezing it here would make the cage pointless. A real wedge is handled
        // by the restitution + auto-trap in lineBounce, which PINS it properly.
        if (cut && cut.o === bossO) { bossO.vx *= 0.93; bossO.vy *= 0.93; bossO.bvx *= 0.93; bossO.bvy *= 0.93; }
        trapTick(bossO, now);
      }
    }
    if (cut) cutFollow();                                        // ✂️ the cut template rides along with the boss
    if (waveEl) {                                                // 🪞 drive the bath surface (visual + physics share one number)
      var wh = curWaveH();
      waveY = wh > 2 ? innerHeight - wh : 0;
      waveEl.style.transform = "translateY(" + (innerHeight - wh).toFixed(1) + "px)";
    }
    if (now < magnet.until) {                                    // vortex follows the cursor (desktop) or stays anchored
      if (magnet.follow && pointerX > -9000) { magnet.x = pointerX; magnet.y = pointerY; }
      if (magnetFx) magnetFx.style.transform = "translate(" + magnet.x + "px," + magnet.y + "px)";
    } else if (magnetFx) { magnetFx.remove(); magnetFx = null; }
    try {                                                        // ARMOR: an exception here must never kill the rAF chain
    for (var i = mobs.length - 1; i >= 0; i--) {
      var o = mobs[i];
      if (!o) continue;                                          // array may shift if a catch ends the round mid-frame
      if (o.removed) { mobs.splice(i, 1); continue; }
      if (o.stuck) { o.born += 16; }                             // 🕸 held by the web: no drift, no wind, no magnet
      else if (!o.frozen && !o.dead) {
        if (guidePause || now < freezeUntil || now < hitStopUntil) { o.born += 16; }   // ⏸ guide / ❄ FREEZE / impact-frame
        else {
        if (o.zig) o.bvy = Math.sin((now - o.born) / 320 + (o.seed || 0)) * 1.15;               // zigzag persona
        if (o.sway) o.bvx = Math.sin((now - o.born) / 300 + (o.seed || 0)) * 0.9;               // rain drops sway while falling
        if (windX && !o.bossFight && (o.mode === "arena" || o.rainTok)) {                        // 🌬 CROSSWIND: everything leans downwind (rain included)
          o.vx += windX * 0.14;                                                                  // strong enough to beat the baseline easing
          o.bvx += (windX * 1.8 - o.bvx) * 0.006;                                                // and it slowly bends their drift too
        }
        if (o.dart && now > (o.nextDart || 0)) { o.vx += rnd(-3.5, 3.5); o.vy += rnd(-2.5, 2.5); o.nextDart = now + rnd(1100, 2800); }   // sprinter darts
        o.vx += (o.bvx - o.vx) * 0.04; o.vy += (o.bvy - o.vy) * 0.04;          // ease toward baseline drift
        var cx = o.x + o._hw, cy = o.y + o._hh;
        if (now < magnet.until && !o.trapTok && !o.bossFight) {                // 🧲 MAGNET pulls by position (touch too)
          var mdx = cx - magnet.x, mdy = cy - magnet.y, md = Math.sqrt(mdx * mdx + mdy * mdy) || 1;
          if (md < 500) {
            if (md > 34) { var pf = 0.5 + 0.7 * (1 - md / 500); o.vx -= (mdx / md) * pf; o.vy -= (mdy / md) * pf; }
            else magnetEat(o);                                                 // reached the core -> swallowed
          }
        } else if (!coarse && pointerX > -9000) {
          var dx = cx - pointerX, dy = cy - pointerY, d2 = dx * dx + dy * dy, R = o.rad;
          if (d2 < R * R && d2 > o.dead0 * o.dead0) {                          // GENTLE dodge, fades to 0 at point-blank
            if (o.shyTok && d2 < R * R * 0.45 && now > (o.blinkCd || 0)) { shyBlink(o); }
            else {
              var d = Math.sqrt(d2), f = (1 - d / R) * (1 - o.dead0 / d);
              o.vx += (dx / d) * f * o.push; o.vy += (dy / d) * f * o.push;
            }
          }
        }
        if (waveY && !o.bossFight) {                                            // 🪞 BUOYANCY: the rising bath lifts EVERYTHING out of it (rain drops included)
          var bot = o.y + o._hh * 2;
          if (bot > waveY) {
            var depth = bot - waveY;
            o.vy -= Math.min(2.2, depth * 0.05);                                // pushed up, harder the deeper it is
            o.vy *= 0.86; o.vx *= 0.97;                                          // liquid drag -> they settle and bob
            o.bvy = Math.min(o.bvy, 0);
            o.y -= Math.min(9, depth * 0.09);                                    // direct lift too, so speed caps can't trap them under
            o.buoy = 1;
          }
        }
        var cap = (o.dashUntil && now < o.dashUntil) ? o.maxSp * 3 : o.maxSp;   // boss escape-dash overshoots the cap
        if (now < magnet.until && !o.trapTok && !o.bossFight) cap = Math.max(cap, o.maxSp * 2);   // sucked in FAST
        if (o.rainTok && !o.splashed && o.y > innerHeight - 80) {               // 💧 SPLASH: drops land in sparks + a musical plink
          o.splashed = 1;
          if (!reduce) burst.spawn(o.x + o._hw, innerHeight - 50, 2);
          Sound.fx("plink");
        }
        var sp = Math.sqrt(o.vx * o.vx + o.vy * o.vy); if (sp > cap) { o.vx *= cap / sp; o.vy *= cap / sp; }
        o.x += o.vx * slowmo; o.y += o.vy * slowmo;
        if (o.mode === "arena") {
          var bounced = false;
          if (o.x < o.minX) { o.x = o.minX; o.vx = Math.abs(o.vx); o.bvx = Math.abs(o.bvx); bounced = true; }
          else if (o.x > o.maxX) { o.x = o.maxX; o.vx = -Math.abs(o.vx); o.bvx = -Math.abs(o.bvx); bounced = true; }
          if (o.y < o.minY) { o.y = o.minY; o.vy = Math.abs(o.vy); o.bvy = Math.abs(o.bvy); bounced = true; }
          else if (o.y > o.maxY) { o.y = o.maxY; o.vy = -Math.abs(o.vy); o.bvy = -Math.abs(o.bvy); bounced = true; }
          if (bounced && now < pinballUntil && pinballHits < 10 && !o.bossFight && !o.trapTok && !o.special) {
            pinballHits++;                                       // 💥 every wall hit scores while the bumpers are live
            bounceScore(o.x + o._hw, o.y + o._hh, pinballHits);
          }
          if (now - o.born > o.ttl) o.dead = true;
        } else if (o.bossFight) {                                              // the BOSS never leaves the screen — bounce
          var bw = o._hw * 2, bh = o._hh * 2;
          if (o.x < FLD.x0 + 8) { o.x = FLD.x0 + 8; o.vx = Math.abs(o.vx); o.bvx = Math.abs(o.bvx); }
          else if (o.x > FLD.x1 - bw - 8) { o.x = FLD.x1 - bw - 8; o.vx = -Math.abs(o.vx); o.bvx = -Math.abs(o.bvx); }
          if (o.y < 64) { o.y = 64; o.vy = Math.abs(o.vy); o.bvy = Math.abs(o.bvy); }
          else if (o.y > innerHeight - bh - 8) { o.y = innerHeight - bh - 8; o.vy = -Math.abs(o.vy); o.bvy = -Math.abs(o.bvy); }
          if (now - o.born > o.ttl) o.dead = true;
        } else if (o.x < FLD.x0 - 170 || o.x > FLD.x1 + 170 || o.y < -170 || o.y > innerHeight + 170 || now - o.born > o.ttl) { o.dead = true; }
        }
      }
      o.el.style.transform = "translate(" + o.x.toFixed(1) + "px," + o.y.toFixed(1) + "px)";
      if (o.dead) { removeMob(o); mobs.splice(i, 1); }
    }
    } catch (e) {}                                               // swallow — the re-arm below MUST always run
    motionRaf = mobs.length ? requestAnimationFrame(motionStep) : 0;
  }
  function bossOnScreen() { return !!(overlay && overlay.querySelector(".av-ms-token.is-boss:not(.is-decoy)")); }
  function clearField(mode) { for (var i = mobs.length - 1; i >= 0; i--) { if (mobs[i].mode === mode && !mobs[i].el.classList.contains("is-boss")) removeMob(mobs[i]); } }
  var bossHintShown = false;
  function toast(html, ms) {                                     // one small top pill at a time (latest wins)
    var old = document.querySelector(".av-ms-bosshint"); if (old) old.remove();
    var h = tier(el("div", "av-ms-bosshint", html));
    document.body.appendChild(h);
    requestAnimationFrame(function () { requestAnimationFrame(function () { h.classList.add("is-in"); }); });
    setTimeout(function () { h.classList.remove("is-in"); setTimeout(function () { h.remove(); }, 500); }, ms || 3000);
  }
  function bossHint() {                                          // heads-up a beat BEFORE the arrival cinematic
    if (bossHintShown) return; bossHintShown = true;
    toast('⚠ <b>INCOMING…</b>', 1800);
  }
  function shyBlink(o) {                                         // SHY medal: vanishes in a puff, reappears elsewhere
    o.blinkCd = perfNow() + 2600;
    if (!reduce) burst.spawn(o.x + o._hw, o.y + o._hh, 4);
    o.el.classList.add("is-blink");
    setTimeout(function () {
      if (o.removed) return;
      o.x = rnd(FLD.x0 + 70, Math.max(FLD.x0 + 140, FLD.x1 - 160)); o.y = rnd(90, Math.max(160, innerHeight * 0.72));
      if (o.mode === "arena") { o.x = Math.min(Math.max(o.x, o.minX), o.maxX); o.y = Math.min(Math.max(o.y, o.minY), o.maxY); }
      o.vx = o.bvx; o.vy = o.bvy;
      o.el.classList.remove("is-blink");
    }, 230);
  }
  function startMagnet(x, y, comboRain) {
    magnet.x = x; magnet.y = y; magnet.until = perfNow() + 4500; magnet.follow = !coarse; magnet.ate = 0;
    Sound.fx("magnet");
    toast(comboRain ? "🌀 <b>MAGNET COMBO</b> — it feasts on the rain!" : "🧲 <b>MAGNET</b> — they come to you!", 2800);
    if (!magnetFx) { magnetFx = tier(el("div", "av-ms-magnetfx")); document.body.appendChild(magnetFx); }
    magnetFx.style.transform = "translate(" + x + "px," + y + "px)";
    setTimeout(function () { if (magnetFx && perfNow() >= magnet.until) { magnetFx.remove(); magnetFx = null; } }, 4900);
  }
  function magnetEat(o) {                                        // the vortex swallows coins that reach its core
    if (o.el.__caught || o.removed || o.special || o.bossFight || o.trapTok || (o.hp && o.hp > 1)) return;
    if (o.rainTok && magnet.ate >= 5) {                          // rain scoring is CAPPED: extra drops are eaten for show
      o.el.__caught = 1; o.frozen = true; o.el.classList.add("is-caught");
      setTimeout(function () { removeMob(o); }, 260);
      if (!reduce) burst.spawn(o.x + o._hw, o.y + o._hh, 3);
      Sound.combo(magnet.ate); return;
    }
    if (o.rainTok) magnet.ate++;
    // DEFERRED: this is called from inside motionStep's mob loop — a direct catch can
    // finish the round (closeArena splices mobs) and crash the iteration, killing the
    // motion engine for good. A 0ms hop runs it safely between frames.
    setTimeout(function () { catchMob(o, o.x + o._hw, o.y + o._hh); }, 0);
  }
  var lastFxAt = 0;
  function catchFx(x, y, worth) {                                // perf: full flourish, throttled under rapid-fire (magnet feasts)
    if (reduce) return;
    var n2 = perfNow(), full = n2 - lastFxAt > 140; lastFxAt = n2;
    burst.spawn(x, y, full ? FX.shards + (worth > 1 ? 4 : 0) : 3);
    if (full) { impactRing(x, y); eventPulse(); }
  }
  function bounceScore(x, y, n) {                                // called FROM motionStep -> defer (a score can end the round)
    setTimeout(function () {
      if (isUnlocked() && !funMode) return;
      Sound.fx("ding");
      if (!reduce) { burst.spawn(x, y, 3); impactRing(x, y); }
      gainCatch(1, x, y);
      if (n >= 10) toast("💥 <b>TILT!</b> 10 bumper hits", 1800);
    }, 0);
  }
  function showPenalty(x, y, txt) {
    var p = tier(el("div", "av-ms-plus av-ms-plus--bad", txt));
    p.style.cssText += ";position:fixed;left:" + (x - 12) + "px;top:" + (y - 10) + "px;";
    document.body.appendChild(p); setTimeout(function () { p.remove(); }, 720);
  }
  function wildEffect(x, y) {                                    // "?" medal: random surprise
    var r = Math.random();
    if (r < 0.3) { gainCatch(3, x, y); toast("✨ Mystery medal — <b>+3</b>!", 2200); }
    else if (r < 0.55) {
      freezeUntil = perfNow() + 3000;
      document.documentElement.classList.add("av-ms-freeze");
      setTimeout(function () { document.documentElement.classList.remove("av-ms-freeze"); }, 3000);
      Sound.fx("freeze"); toast("❄ <b>FREEZE</b> — they can’t run!", 2600); gainCatch(1, x, y);
    } else if (r < 0.8) { startMagnet(x, y); gainCatch(1, x, y); }
    else { toast("☔ <b>MEDAL RAIN!</b>", 2400); gainCatch(1, x, y); rain(); }   // rain() plays its own storm
  }
  /* ===================== ⚡💥🪞 COMBO SET PIECES =========================
     Same shape as RAIN+MAGNET: an EVENT dresses the arena, a KEY coin pops in,
     and catching the key fuses two systems into a screen-wide payoff.
     Each has a DIFFERENT motion signature: chain (spreads), pulse (pushes),
     dip (upgrades) — so none of them feels like the magnet vortex (pulls).
     ===================================================================== */
  function keyCoin(host, glyph, cls, onCatch, label) {          // the catchable that triggers a payoff
    if (!host || !document.body.contains(host)) return;
    var b = makeToken(false, 1.05, false, "mag");               // bigger than a normal medal — it's the prize
    b.classList.remove("is-mag"); b.classList.add(cls, "is-key");
    var q = b.querySelector(".av-ms-token__q"); if (q) q.textContent = glyph;
    if (label) b.appendChild(el("span", "av-ms-token__cap", label));   // says what it DOES, right on the coin
    if (label) toast("👉 <b>Catch the " + label.toLowerCase() + "!</b>", 2600);   // instruction lands WITH the object
    var pad = 70, w = b._hw * 2, h = b._hh * 2;
    var minX = FLD.x0 + pad, maxX = Math.max(minX + 40, FLD.x1 - pad - w), minY = pad + 54, maxY = Math.max(minY + 40, innerHeight * 0.62);
    var x0 = rnd(minX, maxX), y0 = rnd(minY, maxY);
    var o = { el: b, x: x0, y: y0, vx: 0, vy: 0, bvx: rnd(-0.4, 0.4), bvy: rnd(-0.3, 0.3), _hw: b._hw, _hh: b._hh,
      rad: 90, dead0: 30, push: 0.12, maxSp: 2, mode: arena ? "arena" : "ambient",
      minX: minX, maxX: maxX, minY: minY, maxY: Math.max(minY + 40, innerHeight - pad - h), ttl: 7000, born: perfNow(), combo: !!arena, onGone: function () {} };
    o.special = function (x, y) { onCatch(x, y); gainCatch(1, x, y); };
    host.appendChild(b); b.style.transform = "translate(" + x0 + "px," + y0 + "px)";
    if (!reduce) impactRing(x0 + b._hw, y0 + b._hh);
    Sound.fx("check");
    bindCatch(o, 1); addMob(o);
  }
  function boltBetween(x1, y1, x2, y2) {                        // a jagged arc from A to B (rotated strip + zigzag svg)
    if (reduce) return;
    var dx = x2 - x1, dy = y2 - y1, len = Math.sqrt(dx * dx + dy * dy) || 1;
    var ang = Math.atan2(dy, dx) * 180 / Math.PI;
    var s = "", px = 0;
    while (px < 92) { px += rnd(10, 18); s += px.toFixed(0) + " " + rnd(2, 18).toFixed(0) + ", "; }
    var pts = "0 10, " + s + "100 10";
    var d = tier(el("div", "av-ms-arc"));
    d.style.cssText += ";left:" + x1 + "px;top:" + y1 + "px;width:" + len + "px;transform:rotate(" + ang + "deg);";
    d.innerHTML = '<svg viewBox="0 0 100 20" preserveAspectRatio="none">' +
      '<polyline class="g1" points="' + pts + '" /><polyline class="core" points="' + pts + '" /></svg>';   // layered strokes, no filter
    document.body.appendChild(d);
    setTimeout(function () { d.remove(); }, 300);
  }
  function spTesla(host) {                                      // ⚡ CHAIN: charge the field, then a cascade arcs medal->medal
    toast("⚡ <b>TESLA COIL</b> — catch it to chain!", 2400);
    Sound.fx("storm");
    mobs.forEach(function (o) { if (!o.removed && !o.el.__caught && o.mode === "arena" && !o.bossFight && !o.special) o.el.classList.add("is-charged"); });
    for (var ci = 0; ci < (coarse ? 5 : 7); ci++) (function (k) {   // ENERGIZE the field so the chain has fuel
      setTimeout(function () {
        if (playHalted() || !document.body.contains(host)) return;
        var b = makeToken(false, rnd(0.45, 0.62)); b.classList.add("is-lite", "is-charged");
        var pad = 64, w = b._hw * 2, h = b._hh * 2;
        var minX = FLD.x0 + pad, maxX = Math.max(minX + 40, FLD.x1 - pad - w), minY = pad + 54, maxY = Math.max(minY + 40, innerHeight - pad - h);
        var x0 = rnd(minX, maxX), y0 = rnd(minY, maxY), ang = Math.random() * 6.283;
        var o = { el: b, x: x0, y: y0, vx: Math.cos(ang) * 0.7, vy: Math.sin(ang) * 0.7, bvx: Math.cos(ang) * 0.7, bvy: Math.sin(ang) * 0.7,
          _hw: b._hw, _hh: b._hh, rad: 70, dead0: 26, push: 0.18, maxSp: 2.2, mode: "arena",
          minX: minX, maxX: maxX, minY: minY, maxY: maxY, ttl: 9000, born: perfNow(), combo: true, onGone: function () {} };
        host.appendChild(b); b.style.transform = "translate(" + x0 + "px," + y0 + "px)";
        Sound.fx("zap" + Math.min(7, k));
        bindCatch(o, 1); addMob(o);
      }, 140 + k * 130);
    })(ci);
    setTimeout(function () { keyCoin(host, "⚡", "is-tesla", function (x, y) {   // key arrives once the field is charged
      // (labelled below so the player knows instantly what this coin does)
      Sound.fx("frenzy"); hitStop(120); arenaShake();
      var px = x, py = y, links = 0;
      (function hop() {
        if (links >= 8 || playHalted() || !arena) return;
        var best = null, bd = 1e9;
        for (var i = 0; i < mobs.length; i++) {
          var o = mobs[i];
          if (o.removed || o.el.__caught || o.bossFight || o.trapTok || o.special || (o.hp && o.hp > 1)) continue;
          var ddx = (o.x + o._hw) - px, ddy = (o.y + o._hh) - py, d2 = ddx * ddx + ddy * ddy;
          if (d2 < bd) { bd = d2; best = o; }
        }
        if (!best) return;
        var tx = best.x + best._hw, ty = best.y + best._hh;
        boltBetween(px, py, tx, ty);
        best.el.__caught = 1; best.frozen = true; best.el.classList.add("is-caught");
        (function (m) { setTimeout(function () { removeMob(m); }, 300); })(best);
        Sound.fx("zap" + Math.min(7, links));
        if (!reduce) burst.spawn(tx, ty, 4);
        gainCatch(1, tx, ty);
        px = tx; py = ty; links++;
        setTimeout(hop, 115);
      })();
    }, "TESLA COIL"); }, 1000);
  }
  /* ===================================================================
     BOSS DROPS — small, fast pickups that only exist during the boss fight.
     Before this the finale branch cleared the field to just the boss, so there
     was nothing to do but draw and cut. Each drop is worth 0 points: `special`
     fires INSTEAD of scoring, so none of them can touch the GOAL-3 reserve.
     They deliberately do NOT copy keyCoin's trailing gainCatch(1) — during the
     boss fight `caught` is already GOAL-3, so that would print a "+1" that
     banks nothing. Phase split keeps the signature mechanics intact:
       armour up   -> ❄ STOP  (hold it still so the cut nodes stop sliding)
       armour gone -> 💣 BREACH (damage — refuses while armour remains, so the
                      vector cut can never be skipped)
       always      -> 🧲 TOW (drags the boss AND every twin identically — an
                      effect that moved only the real one would end phase 2)
                      ✒️ INK (buy more walls)
     =================================================================== */
  var tow = { x: 0, y: 0, until: 0, follow: false };
  function bossBody(o) { return o.bossFight || o.el.classList.contains("is-decoy"); }
  function towTick(now) {
    if (now >= tow.until) return;
    if (tow.follow && pointerX > -9000) { tow.x = pointerX; tow.y = pointerY; }
    for (var i = 0; i < mobs.length; i++) {
      var o = mobs[i];
      if (o.removed || o.el.__caught || o.mode !== "arena" || !bossBody(o)) continue;
      if (trapped && o === bossO) continue;                      // never yank a caged boss out of its cage
      if (bossDying || (o.dashUntil && now < o.dashUntil)) continue;
      var dx = tow.x - (o.x + o._hw), dy = tow.y - (o.y + o._hh), d = Math.sqrt(dx * dx + dy * dy) || 1;
      if (d < 30) { o.vx *= 0.8; o.vy *= 0.8; continue; }         // parked: stop pulling so it can't orbit
      var f = Math.max(0.9, (o.push || 0.4) * 1.7);               // must out-pull a deep-level boss's own dodge
      o.vx += (dx / d) * f; o.vy += (dy / d) * f;                 // velocity ONLY — the baseline stays its own
    }
  }
  function dropEffect(kind, x, y) {
    var host = arena && arena.querySelector(".av-ms-arena");
    if (kind === "tow") {
      tow.x = x; tow.y = y; tow.until = perfNow() + 3400; tow.follow = !coarse;
      Sound.fx("magnet"); buzz(20);
      toast(coarse ? "🧲 <b>TOW BEAM</b> — everything is dragged to that spot"
                   : "🧲 <b>TOW BEAM</b> — steer it with your cursor!", 2600);
      if (!reduce) impactRing(x, y);
    } else if (kind === "stop") {
      freezeUntil = Math.max(freezeUntil, perfNow() + 1600);
      document.documentElement.classList.add("av-ms-freeze");
      setTimeout(function () {                                    // re-check: two stops must not un-freeze early
        if (perfNow() >= freezeUntil) document.documentElement.classList.remove("av-ms-freeze");
      }, 1650);
      Sound.fx("trap"); hitStop(90); buzz([18, 40]);
      toast("❄ <b>DEAD STOP</b> — everything frozen, cut now!", 2400);
      if (!reduce) impactRing(x, y);
    } else if (kind === "ink") {
      ink = 1; paintInk();
      var pb = weaponBar && weaponBar.querySelector('[data-w="pen"]');
      if (pb) { pb.classList.remove("is-dry"); pb.classList.add("is-urge");
                setTimeout(function () { pb.classList.remove("is-urge"); }, 2600); }
      Sound.fx("check"); toast("✒️ <b>INK REFILLED</b> — draw freely", 2200);
    } else if (kind === "time") {
      var add = 4000 + Math.min(4000, Math.max(0, funLevel - 6) * 350);
      if (addTime) addTime(add);
      Sound.fx("time"); buzz([14, 30]);
      toast("⏱ <b>+" + (add / 1000).toFixed(1) + " seconds</b>", 2200);
      if (!reduce) { burst.spawn(x, y, 7); impactRing(x, y); }
    } else if (kind === "breach") {
      if (!bossO || bossO.removed || bossDying || bossO.hpShield) return;
      var dmg = Math.max(1, Math.round((bossO.hp0 || bossO.hp) * 0.33));
      if (dmg >= bossO.hp) dmg = bossO.hp - 1;                    // the killing blow stays the player's
      if (dmg < 1) { toast("💣 <b>BREACH</b> — it's on its last hit, finish it yourself!", 2600); return; }
      bossO.hp -= dmg;
      bombBlast(host, bossO.x + bossO._hw, bossO.y + bossO._hh);
      gainCatch(dmg, bossO.x + bossO._hw, bossO.y + bossO._hh, true);   // boss-reserved: the only path past GOAL-3
      enrage(bossO);
      toast("💣 <b>BREACH!</b> −" + dmg + " HP · " + bossO.hp + " left", 2600);
    }
  }
  var DROPS = {
    tow:    { g: "🧲", cls: "is-tow",    cap: "TOW" },
    stop:   { g: "❄",  cls: "is-stop",   cap: "STOP" },
    ink:    { g: "✒️", cls: "is-inkdrop", cap: "INK" },
    time:   { g: "⏱", cls: "is-timedrop", cap: "+TIME" },
    breach: { g: "💣", cls: "is-breach", cap: "BOMB" }
  };
  function bossDrop(host) {
    if (!host || !bossO || bossO.removed || bossDying || reduce) return;
    // TOW is the staple, but a caged boss is already where you want it and towTick
    // refuses to drag it out — so it would be a dud pickup. Skip it while trapped.
    var pool = trapped ? [] : ["tow", "tow"];
    if (bossO.hpShield) pool.push("stop", "stop");                // phase 1: hold it still to cut
    else pool.push("breach", "breach");                           // phase 2: damage, cut already done
    if (ink < 0.75 && weaponBar) pool.push("ink");                // never spawn a dud refill
    // ⏱ the finale clears the field, so once the boss lands the clock ONLY goes down —
    // the PUMP needs catches and the boss is the only thing left to catch. Weight time
    // drops up with the level, where the armour stack is what eats the clock.
    if (addTime) { var tw = Math.min(4, 1 + Math.floor(Math.max(0, funLevel - 6) / 4));
                   for (var ti = 0; ti < tw; ti++) pool.push("time"); }
    var kind = pool[Math.floor(Math.random() * pool.length)], D = DROPS[kind];
    var b = makeToken(false, coarse ? 0.7 : 0.62, false, "mag");
    b.classList.remove("is-mag"); b.classList.add("av-ms-drop", D.cls, "is-key");
    var q = b.querySelector(".av-ms-token__q"); if (q) q.textContent = D.g;
    b.appendChild(el("span", "av-ms-token__cap", D.cap));
    var pad = 74, w = b._hw * 2, h = b._hh * 2;
    var minX = FLD.x0 + pad, maxX = Math.max(minX + 40, FLD.x1 - pad - w);
    var minY = pad + 54, maxY = Math.max(minY + 40, innerHeight - pad - h);
    var x0 = rnd(minX, maxX), y0 = rnd(minY, maxY), ang = Math.random() * 6.283, spd = rnd(4.6, 6.2);
    var o = { el: b, x: x0, y: y0, vx: Math.cos(ang) * spd, vy: Math.sin(ang) * spd,
      bvx: Math.cos(ang) * spd, bvy: Math.sin(ang) * spd, _hw: b._hw, _hh: b._hh,
      rad: 74, dead0: 26, push: 0.42, maxSp: 7.6, mode: "arena",   // FAST — worth chasing, easy to miss
      minX: minX, maxX: maxX, minY: minY, maxY: maxY, ttl: 5200, born: perfNow(), combo: false,
      onGone: function () {} };
    o.special = function (cx, cy) { dropEffect(kind, cx, cy); };
    host.appendChild(b); b.style.transform = "translate(" + x0 + "px," + y0 + "px)";
    if (!reduce) impactRing(x0 + b._hw, y0 + b._hh);
    Sound.fx("ding");
    bindCatch(o, 0); addMob(o);
  }
  function bombBlast(host, x, y) {                              // 💥 the detonation itself — transform/opacity only
    if (reduce) return;
    burst.spawn(x, y, 26); impactRing(x, y); bloom();
    if (!host) return;
    var b = tier(el("div", "av-ms-blast", "<i></i><i></i><u></u>"));
    b.style.left = x + "px"; b.style.top = y + "px";
    host.appendChild(b);
    setTimeout(function () { if (b.parentNode) b.remove(); }, 1100);
  }
  function spPinball(host) {                                    // 💥 PULSE: bumpers light up, then everything gets FLUNG
    toast("💥 <b>BUMPERS LIVE</b> — pop the pulse!", 2400);
    Sound.fx("magnet");
    var bump = tier(el("div", "av-ms-bumpers")); bump.innerHTML = "<i></i>";
    host.appendChild(bump); setTimeout(function () { bump.remove(); }, 9000);
    for (var bi2 = 0; bi2 < (coarse ? 5 : 7); bi2++) (function (k) {   // rack the BALLS so the pulse has something to fling
      setTimeout(function () {
        if (playHalted() || !document.body.contains(host)) return;
        var b = makeToken(false, rnd(0.45, 0.62)); b.classList.add("is-lite");
        var pad = 64, w = b._hw * 2, h = b._hh * 2;
        var minX = FLD.x0 + pad, maxX = Math.max(minX + 40, FLD.x1 - pad - w), minY = pad + 54, maxY = Math.max(minY + 40, innerHeight - pad - h);
        var x0 = rnd(minX, maxX), y0 = rnd(minY, maxY), ang = Math.random() * 6.283;
        var o = { el: b, x: x0, y: y0, vx: Math.cos(ang) * 1.1, vy: Math.sin(ang) * 1.1, bvx: Math.cos(ang) * 1.1, bvy: Math.sin(ang) * 1.1,
          _hw: b._hw, _hh: b._hh, rad: 70, dead0: 26, push: 0.2, maxSp: 3, mode: "arena",
          minX: minX, maxX: maxX, minY: minY, maxY: maxY, ttl: 10000, born: perfNow(), combo: true, onGone: function () {} };
        host.appendChild(b); b.style.transform = "translate(" + x0 + "px," + y0 + "px)";
        Sound.fx("ding");
        bindCatch(o, 1); addMob(o);
      }, 140 + k * 120);
    })(bi2);
    setTimeout(function () { keyCoin(host, "💥", "is-pulse", function (x, y) {
      pinballUntil = perfNow() + 4200; pinballHits = 0;
      bump.classList.add("is-live");
      Sound.fx("bossdie"); hitStop(160); arenaShake(); buzz([30, 60, 30, 60, 40]);
      bombBlast(host, x, y);
      var defused = 0;                                          // 🛡 the blast DEFUSES every red fake on the field
      for (var di = 0; di < mobs.length; di++) {
        var t2 = mobs[di];
        if (t2.removed || t2.el.__caught || !t2.trapTok) continue;
        t2.el.__caught = 1; t2.frozen = true;                   // marked first so MINEFIELD's onGone can't double-pay
        t2.el.classList.add("is-defused");
        (function (m) { setTimeout(function () { removeMob(m); }, 320); })(t2);
        if (!reduce) burst.spawn(t2.x + t2._hw, t2.y + t2._hh, 4);
        defused++;
        if (defused <= 6 && addTime) addTime(500);              // each cleared fake buys back half a second
      }
      // 💣 CHAIN DETONATION — the real payoff: HALF the scoring medals on the field go up
      // and they PAY. Nearest to the blast first, so it reads as an outward chain reaction.
      var scor = [];
      for (var si = 0; si < mobs.length; si++) {
        var m = mobs[si];
        if (m.removed || m.el.__caught || m.bossFight || m.mode !== "arena") continue;
        if (m.trapTok || m.el.classList.contains("is-decoy")) continue;   // fakes were just defused above
        m._bd = Math.pow((m.x + m._hw) - x, 2) + Math.pow((m.y + m._hh) - y, 2);
        scor.push(m);
      }
      scor.sort(function (p, q) { return p._bd - q._bd; });
      var take = Math.floor(scor.length / 2), blown = 0;
      for (var bk = 0; bk < take; bk++) (function (m, k) {
        blown++;
        setTimeout(function () {                                // staggered: a chain, not one flat pop
          if (m.removed || m.el.__caught) return;
          var mx = m.x + m._hw, my = m.y + m._hh;
          if (!reduce) { burst.spawn(mx, my, 7); impactRing(mx, my); }
          Sound.hit(1, k / Math.max(1, take), (mx / innerWidth - 0.5) * 1.4);
          catchMob(m, mx, my);                                  // deferred by design — catching can end the round
        }, 90 + k * 70);
      })(scor[bk], bk);
      toast("💥 <b>PULSE!</b> " + (blown ? blown + " medal" + (blown > 1 ? "s" : "") + " detonated · " : "") +
            (defused ? "🛡 " + defused + " fake" + (defused > 1 ? "s" : "") + " cleared +" + (Math.min(defused, 6) * 0.5).toFixed(1) + "s · " : "") +
            "wall hits score", 3200);
      if (defused) Sound.fx("check");
      for (var i = 0; i < mobs.length; i++) {                   // and the SURVIVORS get flung outward
        var o = mobs[i];
        if (o.removed || o.el.__caught || o.bossFight || o.mode !== "arena") continue;
        var ddx = (o.x + o._hw) - x, ddy = (o.y + o._hh) - y, dd = Math.sqrt(ddx * ddx + ddy * ddy) || 1;
        o.vx = (ddx / dd) * 13; o.vy = (ddy / dd) * 13;
        o.bvx = (ddx / dd) * 3.2; o.bvy = (ddy / dd) * 3.2;
        o.maxSp = Math.max(o.maxSp, 9);
      }
      setTimeout(function () { bump.classList.remove("is-live"); }, 4300);
    }, "PULSE"); }, 1000);
  }
  function spChrome(host) {                                     // 🪞 DIP: a chrome wave rises and PLATES every medal
    toast("🪞 <b>CHROME BATH</b> — grab the dipper!", 2400);
    Sound.fx("chrome");
    var wave = tier(el("div", "av-ms-chromewave")); wave.innerHTML = "<i></i>";
    host.appendChild(wave);
    waveEl = wave; wvFrom = 0; wvTo = 0; wvT0 = perfNow(); wvDur = 1;
    setWave(innerHeight * 0.14, 1100);                           // the bath starts filling
    setTimeout(function () { if (waveEl === wave) { waveEl = null; waveY = 0; } wave.remove(); }, 12000);
    setTimeout(function () { keyCoin(host, "🪣", "is-dip", function (x, y) {
      chromeDipUntil = perfNow() + 4500;
      setWave(innerHeight * 0.58, 900);                          // SURGE: the bath swells and lifts everything above it
      setTimeout(function () { setWave(0, 1400); }, 4700);       // then it drains away
      Sound.fx("chrome"); hitStop(110); arenaShake(); buzz([12, 30, 12, 30, 20]);
      toast("🪞 <b>CHROME DIP!</b> Everything floats — and it’s chrome", 2800);
      for (var i = 0; i < mobs.length; i++) {                   // plate what's already on the field
        var o = mobs[i];
        if (o.removed || o.el.__caught || o.bossFight || o.trapTok || o.special) continue;
        o.chromeTok = 1; o.worth = 3;
        o.el.classList.remove("is-lite"); o.el.classList.add("is-chrome");
        if (!reduce) specRipple(o.x + o._hw, o.y + o._hh);
      }
    }, "DIPPER"); }, 1000);
  }
  function setPiece(host) {                                     // rotate so consecutive rounds differ
    var pool = [spTesla, spPinball, spChrome];
    (pool[(funMode ? funLevel : Math.floor(Math.random() * 3)) % 3])(host);
  }
  function lightning(host, side) {                              // ⚡ a full-arena flash + a jagged bolt (opacity/transform only)
    if (reduce || !host) return;
    var fl = tier(el("div", "av-ms-flash")); host.appendChild(fl);
    setTimeout(function () { fl.remove(); }, 620);
    var xPct = side ? rnd(58, 82) : rnd(18, 42);                 // alternate sides so it feels alive
    var bolt = el("div", "av-ms-bolt");
    var seg = "", x = xPct, y = 0, step = coarse ? 18 : 12;      // fewer segments on phones = fewer path points to raster
    while (y < 86) { x += rnd(-8, 8); y += rnd(step - 2, step + 3); seg += x.toFixed(1) + " " + y.toFixed(0) + ", "; }
    var pts = xPct + " 0, " + seg + (x + rnd(-4, 4)).toFixed(1) + " 100";
    // glow is LAYERED STROKES, never filter:drop-shadow — a full-screen blurred SVG
    // stalls mobile GPUs for whole frames (that was the freeze during lightning).
    bolt.innerHTML = '<svg viewBox="0 0 100 100" preserveAspectRatio="none">' +
      '<polyline class="g2" points="' + pts + '" /><polyline class="g1" points="' + pts + '" /><polyline class="core" points="' + pts + '" /></svg>';
    host.appendChild(bolt);
    setTimeout(function () { bolt.remove(); }, 500);
  }
  function rain() {                                              // heavy shower + a 🧲 COMBO coin pops in somewhere random
    var host = arena ? arena.querySelector(".av-ms-arena") : overlay;
    if (!host) return;
    Sound.fx("storm");                                           // low thunder + first droplets
    if (!reduce) {                                               // a cool storm-light washes over the arena
      var st2 = tier(el("div", "av-ms-stormtint"));
      host.appendChild(st2); setTimeout(function () { st2.remove(); }, 4200);
      lightning(host, 0);                                        // ⚡ flash on the thunder...
      setTimeout(function () { if (document.body.contains(host)) { lightning(host, 1); Sound.fx("thunder"); } }, 1900);   // ...and a second strike mid-shower
    }
    var RN = coarse ? 7 : 10;
    for (var i = 0; i < RN; i++) (function (i) {
      setTimeout(function () {
        if (playHalted() || !document.body.contains(host)) return;
        var b = makeToken(false, rnd(0.34, 0.5)); b.classList.add("is-lite");
        var x0 = rnd(FLD.x0 + 50, Math.max(FLD.x0 + 140, FLD.x1 - 120)), y0 = -70;
        var o = { el: b, x: x0, y: y0, vx: rnd(-0.4, 0.4), vy: rnd(2.1, 3), bvx: rnd(-0.3, 0.3), bvy: rnd(2.1, 3), _hw: b._hw, _hh: b._hh,
          rad: 60, dead0: 22, push: 0.1, maxSp: 4.2, mode: "ambient", ttl: 9000, born: perfNow(), combo: !!arena, rainTok: 1, onGone: function () {} };
        o.sway = 1; o.seed = Math.random() * 6.28;               // drops SWAY as they fall
        host.appendChild(b); b.style.transform = "translate(" + x0 + "px," + y0 + "px)";
        bindCatch(o, 1); addMob(o);
      }, i * 220);
    })(i);
    setTimeout(function () {                                     // catch the 🧲 coin -> the vortex feasts on the rain
      if (playHalted() || !document.body.contains(host)) return;
      var b = makeToken(false, 0.85, false, "mag");
      var pad = 70, w = b._hw * 2, h = b._hh * 2;
      var minX = FLD.x0 + pad, maxX = Math.max(minX + 40, FLD.x1 - pad - w), minY = pad + 48, maxY = Math.max(minY + 40, innerHeight * 0.65);
      var x0 = rnd(minX, maxX), y0 = rnd(minY, maxY);
      var o = { el: b, x: x0, y: y0, vx: 0, vy: 0, bvx: rnd(-0.4, 0.4), bvy: rnd(-0.3, 0.3), _hw: b._hw, _hh: b._hh,
        rad: 90, dead0: 30, push: 0.12, maxSp: 2, mode: arena ? "arena" : "ambient",
        minX: minX, maxX: maxX, minY: minY, maxY: Math.max(minY + 40, innerHeight - pad - h), ttl: 6500, born: perfNow(), combo: !!arena, onGone: function () {} };
      o.special = function (x, y) { startMagnet(x, y, true); gainCatch(1, x, y); };
      host.appendChild(b); b.style.transform = "translate(" + x0 + "px," + y0 + "px)";
      if (!reduce) impactRing(x0 + b._hw, y0 + b._hh);           // the "pop" announcing it
      Sound.fx("check");
      bindCatch(o, 1); addMob(o);
    }, 900);
  }
  function armBoss(o, b) {                                       // BOSS FIGHT: hp = hits left to the goal
    o.bossFight = 1; o.hp = Math.max(1, GOAL - (funMode ? funCaught : getCaught()));
    o.hp0 = o.hp;                                                // 💣 BREACH sizes its 33% off the STARTING pool
    // ARMOUR scales with the level (shield hits cost time but give NO progress, so the
    // GOAL math stays exact) — this is what makes deep-level bosses an actual fight.
    // Real round gets exactly ONE layer so every player meets the vector cut once;
    // fun levels stack more. Armour is stripped by CUTTING, never by clicking.
    var sh = funMode ? Math.max(1, Math.min(5, Math.ceil((funLevel - 1) / 2.4))) : 1;   // L1-2:1 L4:2 L6:3 L9:4 L11+:5
    if (wallTier) { sh += wallTier >= 4 ? 2 : 1; o.wallFeint = wallTier >= 3; }   // 🧱 walls stack on top
    o.hpShield = Math.min(7, sh);
    o.armour0 = o.hpShield;
    b.appendChild(el("span", "av-ms-token__rim"));               // rim light silhouettes the boss (warms per hit)
    b.setAttribute("data-rim", "0");
    bossRibbon(o, b);
  }
  function bossRibbon(o, b) {
    var rib = (b || o.el).querySelector(".av-ms-token__ribbon");
    if (!rib) return;
    rib.textContent = (o.hpShield ? "🛡" + o.hpShield + " " : "") + Array(o.hp + 1).join("◆");
    rib.classList.toggle("is-armoured", !!o.hpShield);
  }
  function enrage(o) {                                           // each hit: faster, angrier, dashes away, spawns decoys
    o.maxSp *= 1.35; o.push *= 1.35; o.rad += 15; o.bvx *= 1.28; o.bvy *= 1.28;
    o.el.classList.add("is-enraged");
    bossRibbon(o);
    Sound.fx("bosshit"); hitStop(120); arenaShake(); buzz([20, 50, 20]);
    o.el.setAttribute("data-rim", o.hp === 2 ? "1" : "2");       // rim warms: base -> ember -> furnace
    o.critUntil = perfNow() + 970;                               // dash (450ms) + weak-point CRITICAL window (~520ms)
    (function (m) {
      setTimeout(function () { if (!m.removed && !m.el.__caught) m.el.classList.add("is-crit"); }, 455);
      setTimeout(function () { if (!m.removed) m.el.classList.remove("is-crit"); }, 975);
    })(o);
    toast(o.hp === 2 ? "⚔️ Boss hit — <b>2 more!</b>" : "🔥 Boss ENRAGED — <b>1 more hit!</b>", 2000);
    if (!reduce) {
      o.dashUntil = perfNow() + 450;
      o.el.classList.add("is-dashing");
      (function (m) { setTimeout(function () { if (!m.removed) m.el.classList.remove("is-dashing"); }, 470); })(o);
      if (pointerX > -9000) { var dx = (o.x + o._hw) - pointerX, dy = (o.y + o._hh) - pointerY, dd = Math.sqrt(dx * dx + dy * dy) || 1; o.vx = (dx / dd) * 9; o.vy = (dy / dd) * 9; }
      burst.spawn(o.x + o._hw, o.y + o._hh, 8);
      if (o.wallFeint && Math.random() < 0.55) {                 // 🧱 PHANTOM FEINT: a second surprise dash mid-window
        (function (m) { setTimeout(function () {
          if (m.removed || m.el.__caught) return;
          m.dashUntil = perfNow() + 380; m.el.classList.add("is-dashing");
          setTimeout(function () { if (!m.removed) m.el.classList.remove("is-dashing"); }, 390);
          if (pointerX > -9000) { var fdx = (m.x + m._hw) - pointerX, fdy = (m.y + m._hh) - pointerY, fdd = Math.sqrt(fdx * fdx + fdy * fdy) || 1; m.vx = (fdx / fdd) * 8; m.vy = (fdy / fdd) * 8; }
        }, 640); })(o);
      }
    }
    [].forEach.call(document.querySelectorAll(".av-ms-token.is-decoy"), function (d) {   // older decoys warm up too
      d.classList.add("is-enraged");
      d.setAttribute("data-rim", o.el.getAttribute("data-rim") || "0");
      var dr2 = d.querySelector(".av-ms-token__ribbon"), sr2 = o.el.querySelector(".av-ms-token__ribbon");
      if (dr2 && sr2) { dr2.textContent = sr2.textContent; dr2.className = sr2.className; }
    });
    spawnDecoys(o, o.hp === 2 ? 1 : 2);
  }
  function spawnDecoys(src, n) {                                 // boss "splits" into look-alike decoys (worth 0)
    var host = src.mode === "arena" && arena ? arena.querySelector(".av-ms-arena") : overlay;
    if (!host) return;
    for (var i = 0; i < n; i++) {
      var b = makeToken(false, 1.4, true);                       // SAME size as the boss — no size tell
      b.classList.add("is-decoy");
      // perfect disguise: mirror the boss's rim state, enrage glow and ribbon pips
      if (src.el.classList.contains("is-enraged")) b.classList.add("is-enraged");
      b.setAttribute("data-rim", src.el.getAttribute("data-rim") || "0");
      b.appendChild(el("span", "av-ms-token__rim"));
      var srib = src.el.querySelector(".av-ms-token__ribbon"), drib = b.querySelector(".av-ms-token__ribbon");
      if (srib && drib) { drib.textContent = srib.textContent; drib.className = srib.className; }
      var ang = Math.random() * 6.283, spd = rnd(1.6, 2.6);
      var o = { el: b, x: src.x, y: src.y, vx: Math.cos(ang) * 7, vy: Math.sin(ang) * 7, bvx: Math.cos(ang) * spd, bvy: Math.sin(ang) * spd,
        _hw: b._hw, _hh: b._hh, rad: src.rad, dead0: 34, push: src.push, maxSp: src.maxSp, mode: src.mode, ttl: 9000, born: perfNow(), onGone: function () {} };   // inherits the ENRAGED boss's dodge — behavior doesn't tell either
      o.dashUntil = perfNow() + 400;                             // burst out of the boss uncatchably fast
      if (src.mode === "arena") { o.minX = src.minX; o.maxX = src.maxX; o.minY = src.minY; o.maxY = src.maxY; }
      // popping a twin is the core of PHASE 2 — say plainly that it was fake and how many
      // are left, so "click them away until one survives" reads as the intended plan.
      // `this` (not a closured `o`) — every decoy in this loop shares one `var o`.
      o.special = function (x, y) {
        this.el.classList.add("is-fake");
        var left = document.querySelectorAll(".av-ms-token.is-decoy:not(.is-caught)").length;
        toast(left ? "😜 <b>Fake!</b> " + left + " twin" + (left > 1 ? "s" : "") + " still out there"
                   : "😜 <b>Last fake gone</b> — the one still standing is the REAL boss", 1900);
        Sound.fx("crack"); buzz(18);
        if (!reduce) { burst.spawn(x, y, 6); showWarm(x, y, "😜 fake"); }
      };
      host.appendChild(b); b.style.transform = "translate(" + o.x + "px," + o.y + "px)";
      bindCatch(o, 0); addMob(o);
    }
  }
  function inviteCatch(x, y) {                                   // ambient medal clicked -> nudge into the round
    if (!reduce) { burst.spawn(x, y, 6); impactRing(x, y); }
    Sound.fx("check");
    toast("⏱ These only count in the <b>Challenge Round</b> — tap ▶ to start it", 3200);
    togglePop(true);
  }
  function spawnAmbient() {
    // AMBIENT medals are a LURE only: they drift for the celebration feel, but PROGRESS
    // counts ONLY inside the timed Challenge Round (anti-cheat — no timerless farming).
    // Clicking one pops it and invites the visitor to start the round. BOSS = arena only.
    if (isUnlocked() || getCaught() >= GOAL || active >= MAXTOK || !overlay) return;
    var vw = innerWidth, vh = innerHeight;
    var rare = Math.random() < 0.14, persona = null;
    if (!rare) { var pp = Math.random(); persona = pp < 0.22 ? "zig" : pp < 0.34 ? "dart" : pp < 0.44 ? "shy" : null; }
    var scale = rare ? rnd(0.82, 1.05) : persona === "dart" ? rnd(0.38, 0.52) : rnd(0.42, 1.0);
    var b = makeToken(rare, scale); active++;
    if (persona) b.classList.add("is-" + persona);
    var fromLeft = Math.random() < 0.5;
    var y0 = rnd(vh * 0.16, vh * 0.72), x0 = fromLeft ? -130 : vw + 130;
    var spd = persona === "dart" ? rnd(1.2, 1.9) : rnd(0.6, 1.4);
    var bvx = (fromLeft ? 1 : -1) * spd, bvy = rnd(-0.3, 0.3);
    var o = { el: b, x: x0, y: y0, vx: bvx, vy: bvy, bvx: bvx, bvy: bvy, _hw: b._hw, _hh: b._hh,
      rad: 100, dead0: 34, push: 0.28, maxSp: persona === "dart" ? 5 : 2.9, mode: "ambient", ttl: 44000, born: perfNow(), onGone: function () { active--; } };
    if (persona === "zig") { o.zig = 1; o.seed = Math.random() * 6.28; }
    else if (persona === "dart") { o.dart = 1; o.nextDart = perfNow() + 800; }
    else if (persona === "shy") o.shyTok = 1;
    o.special = inviteCatch;
    overlay.appendChild(b); b.style.transform = "translate(" + x0 + "px," + y0 + "px)";
    bindCatch(o, 0); addMob(o);
  }
  function gainCatch(worth, x, y, fromBoss) {
    if (ARCADE || funMode) { funGain(worth, x, y, fromBoss); return; }   // fun replay / arcade: separate counter, nothing persisted
    if (isUnlocked()) return;
    var prev = getCaught();
    // The last 3 points belong to the BOSS. Without this cap a magnet/chain/pinball
    // burst could jump 34 -> 40 and end the round with no boss fight at all.
    var c = Math.min(fromBoss ? GOAL : GOAL - 3, prev + worth); setCaught(c);
    if (prev === 0 && c > 0) { try { if (!localStorage.getItem(KEY + "_t0")) localStorage.setItem(KEY + "_t0", "" + Date.now()); } catch (e) {} }   // hunt timer starts on the 1st catch
    if (x != null) { showPlus(x, y, worth); Sound.hit(worth, c / GOAL, (x / innerWidth - 0.5) * 1.4); catchFx(x, y, worth); }
    updateHUD();
    if (c >= GOAL) { win(); return; }
    if (prev < 10 && c >= 10 && c < 20) { toast("💪 <b>" + c + "/" + GOAL + "</b> — keep going!", 2400); Sound.fx("check"); }
    else if (prev < 20 && c >= 20 && c < 30) { toast("🔥 <b>Halfway!</b> " + c + "/" + GOAL, 2400); Sound.fx("check"); }
    else if (prev < 30 && c >= 30 && c < GOAL - 3) { toast("⚡ <b>" + c + "/" + GOAL + "</b> — almost there!", 2400); Sound.fx("check"); }
  }
  function showPlus(x, y, worth) {
    var p = tier(el("div", "av-ms-plus", "+" + worth));
    p.style.cssText += ";position:fixed;left:" + (x - 8) + "px;top:" + (y - 10) + "px;";
    document.body.appendChild(p); setTimeout(function () { p.remove(); }, 720);
  }
  function impactRing(x, y) {
    var r = tier(el("div", "av-ms-ring"));
    r.style.cssText += ";left:" + x + "px;top:" + y + "px;";
    document.body.appendChild(r); setTimeout(function () { r.remove(); }, 300);
  }
  // lightweight persistent burst canvas: tier-colored shards + a white spark on each catch
  var burst = (function () {
    var cv, g, W, H, dpr = Math.min(window.devicePixelRatio || 1, 2), P = [], raf = 0, last = 0;
    var COLS = { bronze: ["#e8a15a", "#b76e2c"], silver: ["#e9f2ff", "#9fb3c8"], gold: ["#ffd875", "#e0a422"], platinum: ["#eaf4ff", "#a9c6e0"] };
    function size() { if (!cv) return; W = cv.width = innerWidth * dpr; H = cv.height = innerHeight * dpr; cv.style.width = innerWidth + "px"; cv.style.height = innerHeight + "px"; }
    function ensure() { if (cv) return; cv = el("canvas", "av-ms-burst"); cv.setAttribute("aria-hidden", "true"); document.body.appendChild(cv); g = cv.getContext("2d"); size(); addEventListener("resize", size, { passive: true }); }
    function spawn(x, y, n) {
      ensure(); var pal = (COLS[TIER] || COLS.silver).concat(["#ffffff"]); x *= dpr; y *= dpr;
      var count = Math.min(n || 6, 24);                          // big blasts (boss death) get the full spread
      for (var i = 0; i < count; i++) {
        if (P.length > 90) break;
        var a = Math.random() * 6.283, sp = (2 + Math.random() * 5) * dpr;
        P.push({ x: x, y: y, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp - 2 * dpr, s: (2 + Math.random() * 3) * dpr, rot: Math.random() * 6.28, vr: (Math.random() - 0.5) * 0.4, life: 0, ttl: 300 + Math.random() * 260, c: pal[(Math.random() * pal.length) | 0] });
      }
      P.push({ x: x, y: y, s: (5 + Math.random() * 3) * dpr, life: 0, ttl: 200, spark: true });
      if (!raf) { last = 0; raf = requestAnimationFrame(frame); }
    }
    function frame(t) {
      if (!last) last = t; var dt = Math.min(40, t - last); last = t; g.clearRect(0, 0, W, H);
      for (var i = P.length - 1; i >= 0; i--) {
        var p = P[i]; p.life += dt; if (p.life >= p.ttl) { P.splice(i, 1); continue; }
        var k = 1 - p.life / p.ttl; g.save(); g.translate(p.x, p.y);
        if (p.spark) { g.globalAlpha = k * k; g.fillStyle = "#ffffff"; g.beginPath(); g.arc(0, 0, p.s * (0.4 + k), 0, 6.283); g.fill(); }
        else { p.vy += 0.05 * dpr * dt / 16; p.x += p.vx * dt / 16; p.y += p.vy * dt / 16; p.rot += p.vr; p.vx *= 0.99; g.globalAlpha = k; g.rotate(p.rot); g.fillStyle = p.c; g.fillRect(-p.s / 2, -p.s / 2, p.s, p.s * 0.7); }
        g.restore();
      }
      raf = P.length ? requestAnimationFrame(frame) : 0;
    }
    return { spawn: spawn };
  })();

  /* =====================================================================
     ARCADE challenge round  (fast tokens, 30s, combo; catches count toward goal)
     ===================================================================== */
  var arena, arenaRaf, arenaEnd, arenaSpawn, combo = 0, lastCatch = 0, maxCombo = 0;
  // FUN MODE: replay the round after winning, purely for fun — each level is 10s
  // shorter and the boss 0.5x faster. No code/progress at stake.
  var funMode = false, funCaught = 0, funLevel = 2;
  try { funLevel = Math.max(2, parseInt(localStorage.getItem("av_ms_funlvl") || "2", 10) || 2); } catch (e) {}
  var funMax = funLevel;                                       // 🕹 highest level ever reached = the arcade picker ceiling
  var funRunStart = 0, funRunLog = [], ghostTracking = false, ghost = null;   // 👻 race your fastest clean round
  try { ghost = JSON.parse(localStorage.getItem("av_ms_ghost") || "null"); } catch (e) {}
  // 🃏 MUTATOR deck (L3+, seeded by level so L22 ≠ L23), 🧱 WALL bosses (every 5th),
  // 🌬 crosswind vector, 🕊 mercy after 2 fails on the same level.
  var muts = [], windX = 0, addTime = null, wallTier = 0, funFails = {};
  // ⚡💥🪞 SET PIECES — the rain+magnet pattern: EVENT -> KEY coin -> two systems fuse.
  var pinballUntil = 0, pinballHits = 0, chromeDipUntil = 0;
  // 🪞 the chrome bath is a real LIQUID: one JS-driven level drives BOTH the visual
  // and the buoyancy, so medals visibly get lifted out of it and bob on the surface.
  var waveEl = null, waveY = 0, wvFrom = 0, wvTo = 0, wvT0 = 0, wvDur = 1;
  function curWaveH() {
    if (!waveEl) return 0;
    var k = Math.max(0, Math.min(1, (perfNow() - wvT0) / wvDur));
    k = k < 0.5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;   // ease in-out
    return wvFrom + (wvTo - wvFrom) * k;
  }
  function setWave(toH, dur) { wvFrom = curWaveH(); wvTo = toH; wvT0 = perfNow(); wvDur = dur || 800; }
  var MUTS = {
    "CROSSWIND":   { icon: "»",  rule: "side-wind pushes every medal" },
    "MINEFIELD":   { icon: "⛔", rule: "fakes swarm — untouched fakes pay +0.5s" },
    "CHROME RUSH": { icon: "✨", rule: "chrome odds ×5 — feast!" }
  };
  function pickMuts(lvl) {
    var names = ["CROSSWIND", "MINEFIELD", "CHROME RUSH"];
    var out = [names[lvl % 3]];
    if (lvl >= 12) out.push(names[(lvl + 1) % 3]);               // L12+: DOUBLE MUTATION
    return out;
  }
  var WALLNAMES = ["", "OVERCLOCK", "TWIN SIGNAL", "PHANTOM FEINT", "IRONCLAD", "TWIN STORM"];
  // COMPRESSED ARC: something new every level to ~L16, then UNCAPPED asymptotic
  // curves — every level is measurably meaner forever, but never impossible.
  function funSecs() { return Math.max(20, Math.round(52 - (funLevel - 2) * 2.5)); }        // melts to 20s; PUMP feeds it back
  function playHalted() { return isUnlocked() && !funMode; }     // "unlocked" stops the real game but NOT fun replays
  function funBoost() { return +(4.0 - 2.8 * Math.pow(0.9, funLevel - 2)).toFixed(2); }     // boss → asymptote 4.0
  function funSpeed() { return +(2.6 - 1.6 * Math.pow(0.92, funLevel - 2)).toFixed(2); }    // medals → asymptote 2.6
  function funGain(worth, x, y, fromBoss) {
    funCaught = Math.min(fromBoss ? GOAL : GOAL - 3, funCaught + worth);   // last 3 are the boss's alone
    if (addTime) addTime(600 * worth);                           // ⏱ PUMP THE CLOCK: every catch feeds the timer
    if (ghostTracking) for (var gi = 0; gi < worth && funRunLog.length < GOAL; gi++) funRunLog.push(Math.round(perfNow() - funRunStart));
    if (x != null) { showPlus(x, y, worth); Sound.hit(worth, funCaught / GOAL, (x / innerWidth - 0.5) * 1.4); catchFx(x, y, worth); }
    if (funCaught >= GOAL) {
      var cleared = funLevel, ghostMsg = "";
      if (ghostTracking && funRunLog.length) {                   // 👻 fastest clean round becomes the ghost
        var gdur = funRunLog[funRunLog.length - 1];
        var fair = cleared >= (ghost && ghost.lvl || 0);        // an easy replay cannot erase a hard-level record
        var beat = !!(ghost && ghost.dur && fair && gdur < ghost.dur);
        if (!ghost || !ghost.dur || (fair && gdur < ghost.dur)) {
          ghost = { t: funRunLog.slice(), dur: gdur, lvl: cleared };
          try { localStorage.setItem("av_ms_ghost", JSON.stringify(ghost)); } catch (e) {}
        }
        if (beat) ghostMsg = " 👻 <b>Ghost beaten!</b>";
      }
      funLevel++;
      if (funLevel > funMax) funMax = funLevel;                  // replaying a low level must never lower the ceiling
      try { localStorage.setItem("av_ms_funlvl", "" + funMax); } catch (e) {}
      delete funFails[cleared];                                  // 🕊 mercy resets on a win
      funCaught = 0; funMode = false;
      Sound.win(); confetti(Math.min(4, 1 + 0.15 * (cleared - 1)));            // denser celebration each level (soft-capped 4x)
      closeArena();
      toast("🏆 <b>LEVEL " + cleared + " CLEARED!</b>" + ghostMsg + " Next: Level " + funLevel, 3800);
      if (pop) refreshPop();
    }
  }
  function startArena() {
    if (ARCADE) funMode = true;                                  // 🕹 arcade rounds are always no-stakes
    tutForce = funMode && funLevel === 1;                        // 📖 level 1 replays every tutorial card
    if (isUnlocked() && !funMode) return;
    if (arena) closeArena();                                     // never stack two arenas
    if (pop) pop.hidden = true;
    var DUR0 = funMode ? funSecs() * 1000 : 60000;
    ghostTracking = funMode && funCaught === 0;                  // 👻 pace race only on clean full rounds
    if (ghostTracking) { funRunStart = perfNow(); funRunLog = []; }
    var showGhost = ghostTracking && ghost && ghost.t && ghost.t.length;
    muts = funMode && funLevel >= 3 ? pickMuts(funLevel) : [];   // 🃏 this level's card(s)
    windX = muts.indexOf("CROSSWIND") > -1 ? (funLevel % 2 ? 1 : -1) * 0.9 : 0;
    wallTier = funMode && funLevel >= 5 && funLevel % 5 === 0 ? funLevel / 5 : 0;   // 🧱 every 5th level
    var mercy = funMode && (funFails[funLevel] || 0) >= 2;       // 🕊 two losses on this level -> quiet help
    if (mercy) DUR0 += 5000;
    var trapRate = !funMode || funLevel < 5 ? 0 : Math.min(0.26, 0.08 + (funLevel - 5) * 0.012);
    if (muts.indexOf("MINEFIELD") > -1) trapRate = 0.34;
    if (mercy) trapRate *= 0.5;
    var era = funMode && funLevel >= 11 ? ["ion", "void", "aurora", "solar"][Math.floor((funLevel - 11) / 3) % 4] : "";
    var modal = tier(el("div", "av-ms-modal av-ms-modal--arena is-open"));
    modal.innerHTML =
      '<div class="av-ms-modal__scrim"></div>' +
      '<div class="av-ms-arena">' +
        '<div class="av-ms-dawn" data-stage="0"><i class="d0"></i><i class="d1"></i><i class="d2"></i><i class="d3"></i></div>' +
        '<div class="av-ms-arena__timebar"><i></i></div>' +
        '<div class="av-ms-arena__hud">' +
          '<div class="av-ms-arena__stat"><b data-got>' + (funMode ? funCaught : getCaught()) + '</b><span>caught / ' + GOAL + '</span></div>' +
          '<div class="av-ms-arena__stat"><b data-time>' + Math.ceil(DUR0 / 1000) + '</b><span>seconds</span></div>' +
          (showGhost ? '<div class="av-ms-arena__stat av-ms-ghoststat"><b data-ghost>0</b><span>👻 pace</span></div>' : '') +
          (windX ? '<div class="av-ms-arena__stat av-ms-windstat"><b data-wind>' + (windX > 0 ? '»»»' : '«««') + '</b><span>🌬 wind</span></div>' : '') +
        '</div>' +
        (funMode
          ? '<div class="av-ms-arena__title"><b>LEVEL ' + funLevel + ' — Catch ' + GOAL + '</b><span>' + funSecs() + 's on the clock · boss ×' + funBoost().toFixed(1) + (funLevel >= 5 ? ' · 🚫 avoid the RED fakes (−5s)!' : ' speed · just for fun!') + '</span></div>'
          : '<div class="av-ms-arena__title"><b>Catch ' + GOAL + ' ' + TIER_NAME + ' tokens</b><span>Rare glow = +2 · <b>?</b> = mystery · ⏱ = +5s · some medals fight back!</span></div>') +
        '<div class="av-ms-arena__foot"><button class="av-ms-btn av-ms-btn--ghost" type="button" data-quit>Quit</button></div>' +
      '</div>';
    document.body.appendChild(modal); arena = modal;
    modal.setAttribute("data-tier", activeTier());               // fun L5+: the arena glows gold/platinum
    if (ARCADE) modal.setAttribute("data-arcade", "1");          // 🕹 badges the round as the easter egg
    if (era) modal.setAttribute("data-era", era);                // 🌌 L11+: named ERAS retint the whole arena
    try { var _w2 = new Image(); _w2.src = BOSS_SRC[activeTier()]; var _w3 = new Image(); _w3.src = MEDALS[activeTier()]; } catch (e) {}
    var holdUntil = 0;                                           // clock + spawns stay frozen while the intro card is up
    if (funMode && (muts.length || wallTier)) {                  // 🃏 the LEVEL STAMP slams its rules in
      holdUntil = perfNow() + 2400;
      var stampC = tier(el("div", "av-ms-mutstamp"));
      stampC.innerHTML =
        '<b>L' + funLevel + (wallTier ? ' · 🧱 WALL: ' + (WALLNAMES[Math.min(wallTier, 5)] || "APEX") : '') + (era ? ' · ' + era.toUpperCase() : '') + '</b>' +
        muts.map(function (m) { return '<span>' + (MUTS[m] ? MUTS[m].icon + " " : "") + m + '</span>'; }).join("") +
        '<i>' + muts.map(function (m) { return MUTS[m] ? MUTS[m].rule : ""; }).join(" · ") + (funLevel >= 4 ? ' · every catch +0.6s' : '') + '</i>';
      modal.appendChild(stampC);
      var ttl0 = modal.querySelector(".av-ms-arena__title");
      if (ttl0) ttl0.classList.add("is-min");                     // never stack the stamp on the title
      setTimeout(function () { Sound.fx("bosshit"); hitStop(100); arenaShake(); buzz(30); }, 350);
      setTimeout(function () {
        stampC.classList.add("is-out");
        if (ttl0) ttl0.classList.remove("is-min");                // hand the panel back once the stamp leaves
        setTimeout(function () { stampC.remove(); }, 500);
      }, 2200);
    }
    if (mercy) setTimeout(function () { toast("🕊 <b>The arena favors you</b>", 2200); }, 2900);
    // the arena scrim already hides the page -> park the site's heavy WebGL so the round
    // stays smooth even on weak devices (their IO-gated loops stop drawing when hidden)
    document.documentElement.classList.add("av-ms-lowfx");
    var playfield = arena.querySelector(".av-ms-arena");
    fieldSize();                                                 // paint the letterbox for THIS arena
    weaponsInit(playfield);                                      // ✒️ the pen is armed from the first second
    var windLayer = null;
    if (windX && !reduce) {                                      // 🌬 visible air: streaks blowing across the arena
      windLayer = tier(el("div", "av-ms-wind"));
      windLayer.setAttribute("data-dir", windX > 0 ? "r" : "l");
      var ws = "", wn = coarse ? 7 : 11;
      for (var wi = 0; wi < wn; wi++) {
        ws += '<i style="top:' + rnd(5, 92).toFixed(1) + '%;width:' + rnd(70, 190).toFixed(0) + 'px;' +
              'animation-duration:' + rnd(1.5, 3).toFixed(2) + 's;animation-delay:' + (-rnd(0, 3)).toFixed(2) + 's"></i>';
      }
      windLayer.innerHTML = ws;
      playfield.appendChild(windLayer);
    }
    var timeI = arena.querySelector(".av-ms-arena__timebar i");
    var gotB  = arena.querySelector("[data-got]");
    var timeB = arena.querySelector("[data-time]");
    arena.querySelector("[data-quit]").addEventListener("click", closeArena);
    arena.querySelector(".av-ms-modal__scrim").addEventListener("click", closeArena);

    var DURATION = DUR0, t0 = perfNow(), aActive = 0, AMAX = coarse ? 4 : 6;
    var timeBonus = 0, frenzyAt = 15000 + Math.random() * 18000, frenzyDone = false;
    // ⏱ The +5s medals used to stop spawning at a FLAT 15s on every level, while the
    // difficulty kept climbing around them: armour 1 -> 5 layers, and the round melting
    // from 52s to the 20s floor. That flat cap is why deep levels became unfinishable.
    var timeCap = 15000 + (funMode ? Math.max(0, funLevel - 5) * 1800 : 0);   // L18 -> ~38s
    var clutchOn = false, lastBeat = 0;                          // final-5s photo finish
    var gAhead = null, goldFlipped = false;                      // ghost chip state + BEST PACE flip
    var rainAt = 6000 + Math.random() * 7000, rainDone = false;    // ☔ guaranteed MEDAL RAIN — early enough that fast players see it too
    // ⛔ MINEFIELD is the round where the field fills with medals you must NOT touch, so the
    // bomb is its natural answer: it comes 3x instead of once, always the bomb, and sooner /
    // tighter — those rounds melt to 20s at high level, so a 9s gap would never fit three.
    var mineRound = muts.indexOf("MINEFIELD") > -1;
    var spMax = mineRound ? 3 : 1, spGap = mineRound ? 6000 : 9000;
    var spAt = rainAt + (mineRound ? 2000 : 6000), spCount = 0, dropAt = 0;    // ⚡💥🪞 a SECOND set piece after the rain
    pinballUntil = 0; pinballHits = 0; chromeDipUntil = 0;
    var lastEmber = 0, dawnSt = -1, bedOk = false, lastBedTry = 0;   // combo embers · tier dawn · tonal bed
    var mpOn = false, lastMpDash = 0, mpDashes = 0, windFlipped = false;   // 🎯 match point · 🌬 wind shift
    var lastLoopAt = 0;                                          // frame-gap watchdog (tab backgrounded)
    maxCombo = 0; combo = 0;
    addTime = funMode && funLevel >= 4 ? function (ms) { DURATION = Math.min(DURATION + ms, 90000); } : null;   // ⏱ PUMP THE CLOCK
    var titleEl = arena.querySelector(".av-ms-arena__title");    // auto-minimize so the field stays clear (esp. mobile)
    setTimeout(function () { if (titleEl && arena) titleEl.classList.add("is-min"); }, 4000);
    function loop() {
      var now = perfNow();
      var dt = lastLoopAt ? now - lastLoopAt : 0;
      lastLoopAt = now;
      // PAUSE (don't reset) the clock while a cinematic holds, and don't charge the
      // round for time a backgrounded tab spent with rAF suspended.
      if (now < holdUntil || guidePause || dt > 1000) { t0 += dt; arenaEnd = t0 + DURATION; }
      if (now < holdUntil || guidePause) { arenaRaf = requestAnimationFrame(loop); return; }
      var left = Math.max(0, DURATION - (now - t0));
      timeI.style.transform = "scaleX(" + (left / DURATION) + ")";
      timeB.textContent = Math.ceil(left / 1000);
      gotB.textContent = funMode ? funCaught : getCaught();
      var clutch = left <= 5000 && left > 0 && (funMode ? funCaught : getCaught()) >= GOAL - 4 && (funMode || !isUnlocked());
      if (!winning && !bossDying) slowmo = clutch ? 0.92 : 1;    // CLUTCH: photo-finish mercy slow (boss death owns slowmo)
      if (clutch && !clutchOn) { clutchOn = true; var pfc = arena.querySelector(".av-ms-arena"); if (pfc && !reduce) pfc.classList.add("is-clutch"); }
      else if (!clutch && clutchOn) { clutchOn = false; var pfc2 = arena.querySelector(".av-ms-arena"); if (pfc2) pfc2.classList.remove("is-clutch"); }
      if (clutch && now - lastBeat > 1000) { lastBeat = now; Sound.fx("beat"); timeB.classList.remove("is-pop"); void timeB.offsetWidth; timeB.classList.add("is-pop"); }
      if (ghostTracking && ghost && ghost.t) {                   // 👻 where was the PB run at this moment?
        var ge = now - t0, gcnt = 0;
        while (gcnt < ghost.t.length && ghost.t[gcnt] <= ge) gcnt++;
        var gEl = arena.querySelector("[data-ghost]");
        if (gEl) {
          gEl.textContent = gcnt;
          var ahead = funCaught >= gcnt;
          if (ahead !== gAhead) {
            var wasBehind = gAhead === false;
            gAhead = ahead; var gsn = gEl.parentNode; gsn.classList.toggle("is-ahead", ahead); gsn.classList.toggle("is-behind", !ahead);
            if (ahead && wasBehind && !goldFlipped) {             // 🥇 the frame you overtake your ghost
              goldFlipped = true; gsn.classList.add("is-goldflip");
              toast("🥇 <b>BEST PACE!</b>", 1300); Sound.fx("goldflip"); buzz([12, 30, 12]);
            }
          }
        }
      }
      var cRain = funMode ? funCaught : getCaught();             // fire by TIME or by PROGRESS (fast catchers hit 12 before rainAt), but never once the boss is due
      if (!rainDone && (now - t0 > rainAt || cRain >= 12) && cRain < GOAL - 3) { rainDone = true; toast("☔ <b>MEDAL RAIN!</b>", 2400); rain(); }
      // 🧲💣❄✒️ BOSS DROPS — the finale clears the field, so these are the only
      // other things on screen. First one lands ~2.6s after the boss settles.
      if (bossO && !bossDying && !reduce) {
        if (!dropAt) dropAt = now + 2600;
        else if (now > dropAt && document.querySelectorAll(".av-ms-drop:not(.is-caught)").length < 2) {
          dropAt = now + rnd(4200, 6200); bossDrop(playfield);
        }
      }
      if (spCount < spMax && rainDone && cRain < GOAL - 4 &&      // ⚡💥🪞 repeats are TIME-gated only, so the
          (now - t0 > spAt || (spCount === 0 && cRain >= 20))) {  // progress trigger can't fire all three at once
        spCount++; spAt = (now - t0) + spGap;
        if (mineRound) spPinball(playfield); else setPiece(playfield);
      }
      if (combo >= 4 && now - lastCatch < 2600 && now - lastEmber > (combo >= 6 ? 350 : 700) && !reduce) {   // combo EMBERS rise
        lastEmber = now;
        if (playfield.querySelectorAll(".av-ms-ember").length < 6) {
          var em = tier(el("div", "av-ms-ember" + (combo >= 7 ? " is-warm" : "")));
          em.style.left = (5 + Math.random() * 90) + "%"; em.style.top = (innerHeight - 90) + "px";
          playfield.appendChild(em); (function (e2) { setTimeout(function () { e2.remove(); }, 2700); })(em);
        }
      }
      var cNow = funMode ? funCaught : getCaught();               // TIER DAWN: the arena sunrise tracks progress
      var st = cNow >= GOAL - 3 ? 4 : cNow >= 30 ? 3 : cNow >= 20 ? 2 : cNow >= 10 ? 1 : 0;
      if (st !== dawnSt) {
        dawnSt = st;
        var dw = arena.querySelector(".av-ms-dawn"); if (dw) dw.setAttribute("data-stage", st);
        Sound.bed.level(Math.min(st, 3), funMode);
      }
      if (!bedOk && now - lastBedTry > 1500) { lastBedTry = now; bedOk = Sound.bed.start(funMode, Math.min(Math.max(dawnSt, 0), 3)); }
      if (funMode && funLevel >= 6 && !mpOn && funCaught === GOAL - 1) {   // 🎯 MATCH POINT: the last hit resists
        mpOn = true; toast("🎯 <b>MATCH POINT</b>", 1800); Sound.fx("beat"); buzz([20, 40, 20]);
        var shade = tier(el("div", "av-ms-mpshade")); arena.querySelector(".av-ms-arena").appendChild(shade);
      }
      if (mpOn && now - lastMpDash > (funLevel >= 13 ? 2100 : 3100) && mpDashes < 3) {
        lastMpDash = now;
        for (var mi2 = 0; mi2 < mobs.length; mi2++) {
          var bm = mobs[mi2];
          if (bm.bossFight && !bm.el.__caught && !bm.removed) {
            mpDashes++;
            bm.dashUntil = perfNow() + 400; bm.el.classList.add("is-dashing");
            (function (m) { setTimeout(function () { if (!m.removed) m.el.classList.remove("is-dashing"); }, 410); })(bm);
            if (pointerX > -9000) { var mdx2 = (bm.x + bm._hw) - pointerX, mdy2 = (bm.y + bm._hh) - pointerY, mdd2 = Math.sqrt(mdx2 * mdx2 + mdy2 * mdy2) || 1; bm.vx = (mdx2 / mdd2) * 8; bm.vy = (mdy2 / mdd2) * 8; }
            Sound.fx("beat"); break;
          }
        }
      }
      if (windX && funLevel >= 10 && !windFlipped && now - t0 > DURATION / 2) {   // 🌬 mid-round WIND SHIFT
        windFlipped = true; windX = -windX;
        if (windLayer) windLayer.setAttribute("data-dir", windX > 0 ? "r" : "l");
        var wEl = arena.querySelector("[data-wind]");
        if (wEl) { wEl.textContent = windX > 0 ? "»»»" : "«««"; wEl.parentNode.classList.remove("is-flip"); void wEl.offsetWidth; wEl.parentNode.classList.add("is-flip"); }
        for (var wj = 0; wj < mobs.length; wj++) if (mobs[wj].mode === "arena") mobs[wj].bvx = -mobs[wj].bvx * 0.5;   // the gust turns them
        toast((windX > 0 ? "»»» " : "««« ") + "<b>WIND SHIFT</b>", 1900); Sound.fx("magnet");
      }
      if (isUnlocked() && !winning && !funMode) { closeArena(); return; }   // keep the arena during the win slow-mo (fun replays run unlocked)
      if (!frenzyDone && now - t0 > frenzyAt && (funMode ? funCaught : getCaught()) < GOAL - 4 && !playHalted()) {   // 🔥 once-per-round medal wave
        frenzyDone = true; toast("🔥 <b>FRENZY!</b>", 2200); Sound.fx("frenzy"); eventPulse();
        for (var fi = 0; fi < 8; fi++) (function (k) { setTimeout(function () { if (arena && !playHalted()) spawnMini(); }, k * 220); })(fi);
      }
      if (left <= 0 && !bossDying) { endArena(gotB); return; }   // never cut the boss-death show short
      arenaRaf = requestAnimationFrame(loop);
    }
    function spawnFast() {
      if (playHalted()) return;
      var finale = (funMode ? funCaught : getCaught()) >= GOAL - 3;   // final stretch: clear the arena, only the BOSS
      if (finale) { if (playfield.querySelector(".av-ms-token.is-boss:not(.is-decoy)")) return; clearField("arena"); }
      else if (aActive >= AMAX) return;
      var boss = finale, kind = null, rare = false, worth = 1, persona = null;
      if (!boss) {
        if (forceRare) { rare = true; worth = 2; forceRare = false; }          // comeback: guaranteed rare (arena)
        else {
        var roll = Math.random();
        var chromeOdds = perfNow() < chromeDipUntil ? 1 : (muts.indexOf("CHROME RUSH") > -1 ? 0.125 : 0.025);   // 🪞 during the DIP everything spawns plated
        if (roll < chromeOdds) { kind = "chrome"; worth = 3; }
        else if (roll < chromeOdds + 0.18) { rare = true; worth = 2; }
        else if (roll < chromeOdds + 0.255) { kind = "wild"; }
        else if (roll < chromeOdds + 0.325 && timeBonus < timeCap) { kind = "time"; }
        else if (trapRate > 0 && roll < chromeOdds + 0.325 + trapRate) { kind = "trap"; }   // level-scaled fake medals (−5s)
        else { var pp = Math.random(); persona = pp < 0.22 ? "zig" : pp < 0.37 ? "dart" : pp < 0.47 ? "heavy" : null; if (persona === "dart" || persona === "heavy") worth = 2; }
        }
      }
      var scale = boss ? 1.4 : kind === "chrome" ? rnd(0.72, 0.9) : kind === "wild" ? rnd(0.72, 0.92) : kind === "time" ? rnd(0.58, 0.72) : kind === "trap" ? rnd(0.6, 0.9) : rare ? rnd(0.85, 1.1) : persona === "heavy" ? rnd(1.12, 1.3) : persona === "dart" ? rnd(0.4, 0.55) : rnd(0.55, 1.0);
      var b = makeToken(rare, scale, boss, kind); aActive++;
      if (persona) b.classList.add("is-" + persona);
      var w = b._hw * 2, h = b._hh * 2, pad = 60;
      var minX = FLD.x0 + pad, maxX = FLD.x1 - pad - w, minY = pad + 48, maxY = innerHeight - pad - h;
      var yTop = minY, yBot = maxY;
      if (waveY) yBot = Math.max(minY + 40, Math.min(maxY, waveY - h - 10));    // 🪞 while the bath is up, medals live ABOVE the waterline
      var x0 = minX + Math.random() * (maxX - minX), y0 = yTop + Math.random() * (yBot - yTop);
      var ang = Math.random() * 6.283, spd = boss ? rnd(1.5, 2.5) : persona === "heavy" ? rnd(0.5, 0.9) : persona === "dart" ? rnd(1.6, 2.4) : rnd(1.1, 2.1);
      var o = { el: b, x: x0, y: y0, vx: Math.cos(ang) * spd, vy: Math.sin(ang) * spd, bvx: Math.cos(ang) * spd, bvy: Math.sin(ang) * spd,
        _hw: b._hw, _hh: b._hh, rad: boss ? 110 : 96, dead0: 34, push: boss ? 0.5 : persona === "heavy" ? 0.14 : 0.36,
        maxSp: boss ? 4.2 : persona === "dart" ? 5.2 : persona === "heavy" ? 2 : 3.5, mode: "arena",
        minX: minX, maxX: maxX, minY: minY, maxY: maxY, ttl: boss ? 120000 : persona === "heavy" ? rnd(6500, 9000) : rnd(4500, 7200), born: perfNow(), combo: true, onGone: function () { aActive--; } };
      if (persona === "zig") { o.zig = 1; o.seed = Math.random() * 6.28; }
      else if (persona === "dart") { o.dart = 1; o.nextDart = perfNow() + 800; }
      else if (persona === "heavy") o.hp = 2;
      if (kind === "chrome") o.chromeTok = 1;
      if (kind === "wild") o.special = function (x, y) { wildEffect(x, y); };
      if (kind === "time") o.special = function (x, y) { timeBonus += 5000; DURATION += 5000; Sound.fx("time"); toast("⏱ <b>+5 seconds!</b>", 1800); if (!reduce) { burst.spawn(x, y, 6); impactRing(x, y); } };
      if (kind === "trap") {
        o.trapTok = 1; o.special = function (x, y) { DURATION -= 5000; Sound.fx("trap"); showPenalty(x, y, "−5s"); toast("🚫 <b>Fake medal!</b> −5 seconds", 2200); };
        if (muts.indexOf("MINEFIELD") > -1) {                    // MINEFIELD: dodging IS scoring — untouched fakes pay time
          var og2 = o.onGone; o.onGone = function () { og2(); if (!o.el.__caught && addTime) { addTime(500); Sound.fx("plink"); } };
        }
      }
      if (boss) armBoss(o, b);
      if (boss && funMode) { var fb2 = funBoost(); o.maxSp *= fb2; o.push *= fb2; o.vx *= fb2; o.vy *= fb2; o.bvx *= fb2; o.bvy *= fb2; }   // fun levels: faster boss
      if (!boss && funMode) { var fsp = funSpeed(); o.vx *= fsp; o.vy *= fsp; o.bvx *= fsp; o.bvy *= fsp; o.maxSp *= fsp; }                 // fun levels: faster medals
      playfield.appendChild(b); b.style.transform = "translate(" + x0 + "px," + y0 + "px)";
      if (boss) bossEntrance(o, b);
      if (boss && wallTier >= 2) (function (m) { setTimeout(function () { if (!m.removed && !m.el.__caught) spawnDecoys(m, wallTier >= 5 ? 2 : 1); }, ENTRANCE + 250); })(o);   // 🧱 TWIN SIGNAL: after the entrance
      bindCatch(o, worth); addMob(o);
    }
    function bossEntrance(o, b) {                                // ⚠ THE ARRIVAL — mirrors the kill cam, so the fight is bookended
      o.frozen = true;
      o.dashUntil = perfNow() + ENTRANCE;                        // untouchable while it lands
      o.x = FLD.x0 + FLD.w / 2 - o._hw; o.y = innerHeight * 0.42 - o._hh;
      b.style.transform = "translate(" + o.x + "px," + o.y + "px)";
      Sound.fx("bossin"); buzz([15, 60, 15, 60, 90]);
      if (reduce) { o.frozen = false; o.dashUntil = 0; toast("🏁 <b>FINAL BOSS</b>", 3000); return; }
      holdUntil = Math.max(holdUntil, perfNow() + ENTRANCE);     // the clock waits for the cinematic
      b.classList.add("is-arriving");
      var cam = tier(el("div", "av-ms-killcam")); cam.innerHTML = "<i></i>";
      playfield.appendChild(cam);
      requestAnimationFrame(function () { requestAnimationFrame(function () { cam.classList.add("is-on"); }); });
      var nm = tier(el("div", "av-ms-bossname"));
      nm.innerHTML = '<span>⚠ FINAL BOSS</span><b>' + esc(wallTier ? (WALLNAMES[Math.min(wallTier, 5)] || "APEX") : activeTier().toUpperCase()) + '</b>' +
        '<i>' + (o.hpShield ? "🛡 " + o.hpShield + " armour · " : "") + o.hp + " HP</i>";
      playfield.appendChild(nm);
      setTimeout(function () {                                   // it LANDS
        if (o.removed) return;
        arenaShake(); hitStop(160);
        if (!reduce) { burst.spawn(o.x + o._hw, o.y + o._hh, 20); impactRing(o.x + o._hw, o.y + o._hh); }
        var sw = tier(el("div", "av-ms-shock")); document.body.appendChild(sw); setTimeout(function () { sw.remove(); }, 900);
      }, 980);
      setTimeout(function () {                                   // ...and the fight is on
        b.classList.remove("is-arriving");
        cam.classList.remove("is-on"); setTimeout(function () { cam.remove(); }, 450);
        nm.classList.add("is-out"); setTimeout(function () { nm.remove(); }, 450);
        if (!o.removed) { o.frozen = false; o.dashUntil = 0; bossPhaseStart(o); }   // ✒️/✂️ weapons out, pen selected
      }, ENTRANCE);
    }
    function spawnMini() {                                       // 🔥 frenzy shower minis
      var b = makeToken(false, rnd(0.4, 0.55)); b.classList.add("is-lite"); aActive++;
      var pad = 60, w = b._hw * 2, h = b._hh * 2, minX = FLD.x0 + pad, maxX = FLD.x1 - pad - w, minY = pad + 48, maxY = innerHeight - pad - h;
      var x0 = minX + Math.random() * (maxX - minX), y0 = minY + Math.random() * (maxY - minY);
      var ang = Math.random() * 6.283, spd = rnd(2.2, 3.2);
      var o = { el: b, x: x0, y: y0, vx: Math.cos(ang) * spd, vy: Math.sin(ang) * spd, bvx: Math.cos(ang) * spd, bvy: Math.sin(ang) * spd,
        _hw: b._hw, _hh: b._hh, rad: 80, dead0: 30, push: 0.3, maxSp: 4, mode: "arena",
        minX: minX, maxX: maxX, minY: minY, maxY: maxY, ttl: rnd(2800, 4200), born: perfNow(), combo: true, onGone: function () { aActive--; } };
      if (funMode) { var fsm = funSpeed(); o.vx *= fsm; o.vy *= fsm; o.bvx *= fsm; o.bvy *= fsm; o.maxSp *= fsm; }
      playfield.appendChild(b); b.style.transform = "translate(" + x0 + "px," + y0 + "px)";
      bindCatch(o, 1); addMob(o);
    }
    var spawnEvery = Math.round((coarse ? 720 : 560) * (muts.indexOf("CHROME RUSH") > -1 ? 1.15 : 1));
    function beginSpawning() {                                   // the seed burst AND the interval both wait for the card
      if (!arena) return;
      arenaSpawn = setInterval(spawnFast, spawnEvery);
      for (var i = 0; i < (coarse ? 3 : 4); i++) spawnFast();
    }
    if (holdUntil) setTimeout(beginSpawning, holdUntil - perfNow());
    else beginSpawning();
    arenaRaf = requestAnimationFrame(loop);
    arenaEnd = t0 + DURATION;
  }
  function flashCombo(x, y) {
    Sound.combo(combo);
    var heat = combo >= 8 ? 5 : combo >= 5 ? 4 : combo >= 3 ? 3 : 2;   // combo "heats up" bronze->white
    var c = tier(el("div", "av-ms-arena__combo", "COMBO ×" + combo)); c.setAttribute("data-heat", heat);
    c.style.cssText += ";left:" + (x + 10) + "px;top:" + (y - 24) + "px;";
    (arena || document.body).appendChild(c); setTimeout(function () { c.remove(); }, 850);
    if (combo === 3 || combo === 5 || combo === 8) {
      var s = tier(el("div", "av-ms-streak", combo >= 8 ? "🔥 ON FIRE!" : combo >= 5 ? "🔥 STREAK!" : "STREAK!"));
      s.style.cssText += ";left:" + x + "px;top:" + (y - 60) + "px;";
      (arena || document.body).appendChild(s); setTimeout(function () { s.remove(); }, 1000);
    }
  }
  function endArena(gotB) {
    clearInterval(arenaSpawn); cancelAnimationFrame(arenaRaf);
    // Round over -> put the tools away FIRST. The weapon bar sits dead-centre at the
    // bottom on z-index 9; leaving it up covered the debrief's Retry / Keep browsing
    // buttons and swallowed their clicks.
    cutClear(); weaponsEnd(); closeGuide(true);
    var need = GOAL - (funMode ? funCaught : getCaught());
    var t = arena.querySelector(".av-ms-arena__title");
    if (t) t.classList.remove("is-min");                        // bring the panel back for the verdict
    if (need <= 0) { closeArena(); return; }
    if (funMode) funFails[funLevel] = (funFails[funLevel] || 0) + 1;   // 🕊 mercy counter
    var got = GOAL - need;
    if (t) t.innerHTML = '<b>' + got + ' banked ✦</b><span>' + need + ' more to go — ' + (ARCADE || funMode ? 'just for fun.' : 'progress saved.') + (maxCombo >= 3 ? ' Longest combo: ×' + maxCombo + '.' : '') + ' Try again!</span>';
    var pfd = arena.querySelector(".av-ms-arena");
    if (pfd) { pfd.classList.remove("is-clutch", "is-fever"); pfd.classList.add("is-debrief"); }   // ember-copper, not failure grey
    if (!reduce && hud && got > 0) {                             // medal ghosts arc into the HUD bank
      var hr = hud.getBoundingClientRect(), hx = hr.left + hr.width / 2, hy = hr.top + hr.height / 2;
      var GN = Math.min(6, got);
      for (var gi2 = 0; gi2 < GN; gi2++) (function (k) { setTimeout(function () {
        var fl2 = el("img", "av-ms-bankfly"); fl2.src = MEDALS[activeTier()] || MEDAL_SRC; fl2.setAttribute("aria-hidden", "true");
        var sx = innerWidth * (0.25 + Math.random() * 0.5), sy = innerHeight * (0.22 + Math.random() * 0.38);
        fl2.style.transform = "translate(" + sx + "px," + sy + "px)";
        document.body.appendChild(fl2);
        requestAnimationFrame(function () { requestAnimationFrame(function () {
          fl2.style.transform = "translate(" + hx + "px," + hy + "px) scale(.3)"; fl2.style.opacity = "0.15";
        }); });
        Sound.combo(k + 2);
        setTimeout(function () { fl2.remove(); }, 700);
      }, 250 + k * 130); })(gi2);
      setTimeout(function () { if (hud) { hud.classList.add("is-bank"); setTimeout(function () { hud.classList.remove("is-bank"); }, 700); } }, 250 + GN * 130 + 500);
    }
    var foot = arena.querySelector(".av-ms-arena__foot");
    if (foot) foot.innerHTML =
      '<button class="av-ms-btn" type="button" data-retry>↻ Retry round</button>' +
      '<button class="av-ms-btn av-ms-btn--ghost" type="button" data-quit>Keep browsing</button>';
    if (foot) {
      foot.querySelector("[data-retry]").addEventListener("click", function () { closeArena(); startArena(); });
      foot.querySelector("[data-quit]").addEventListener("click", closeArena);
    }
  }
  function closeArena() {
    document.documentElement.classList.remove("av-ms-lowfx");   // restore the site's 3D
    slowmo = 1; feverUntil = 0;                                 // clear clutch slow / fever state
    muts = []; windX = 0; addTime = null; wallTier = 0;         // clear level modifiers
    pinballUntil = 0; chromeDipUntil = 0;                       // clear set-piece windows
    waveEl = null; waveY = 0;                                   // drain the bath
    cutClear(); weaponsEnd(); closeGuide(true);                  // ✂️ drop the template, tools and any open guide
    Sound.bed.stop();                                           // fade the tonal bed out
    clearInterval(arenaSpawn); cancelAnimationFrame(arenaRaf);
    for (var i = mobs.length - 1; i >= 0; i--) { if (mobs[i].mode === "arena") { mobs[i].removed = true; mobs.splice(i, 1); } }
    if (arena) { arena.remove(); arena = null; }
    updateHUD();
  }

  /* =====================================================================
     ACCESSIBLE / low-motion variant (static, keyboard-first, mandatory catch)
     ===================================================================== */
  var a11yPanel;
  function buildA11y() {
    a11yPanel = tier(el("div", "av-ms-a11y"));
    a11yPanel.setAttribute("role", "group");
    a11yPanel.setAttribute("aria-label", milestone.n + " milestone reward — catch " + GOAL + " tokens");
    a11yPanel.innerHTML =
      '<h4>' + fmt(milestone.n) + ' templates! Catch ' + GOAL + '</h4>' +
      '<p>AutoVectors reached a new library milestone. Press the glowing medals (Tab + Enter works) to unlock your ' + (LABEL ? esc(LABEL) + ' ' : '') + 'discount code <b>' + esc(CODE) + '</b>.</p>' +
      '<div class="av-ms-a11y__grid" data-grid></div>' +
      '<div class="av-ms-a11y__bar"><i></i></div>' +
      '<div class="av-ms-mini"><button type="button" data-rich>' + (reduce ? "" : "switch to animated mode") + '</button></div>';
    document.body.appendChild(a11yPanel);
    var richBtn = a11yPanel.querySelector("[data-rich]");
    if (!richBtn.textContent) richBtn.parentNode.style.display = "none";
    else richBtn.addEventListener("click", function () { a11y = false; rebuild(); });
    var grid = a11yPanel.querySelector("[data-grid]");
    for (var i = 0; i < 3; i++) placeA11yToken(grid);
    updateA11y();
  }
  function placeA11yToken(grid) {
    if (isUnlocked() || getCaught() >= GOAL) return;
    var rare = Math.random() < 0.18, b = makeToken(rare, rnd(0.6, 0.9));
    var gw = grid.clientWidth || 280, gh = grid.clientHeight || 150, w = b._hw * 2, h = b._hh * 2;
    b.style.transform = "translate(" + rnd(4, Math.max(6, gw - w - 4)) + "px," + rnd(4, Math.max(6, gh - h - 4)) + "px)";
    grid.appendChild(b);
    b.addEventListener("click", function (ev) {
      ev.preventDefault(); if (b.__caught) return; b.__caught = 1;
      var r = b.getBoundingClientRect(); b.classList.add("is-caught");
      setTimeout(function () { b.remove(); if (!isUnlocked() && getCaught() < GOAL) placeA11yToken(grid); }, 320);
      gainCatch(rare ? 2 : 1, r.left + r.width / 2, r.top + r.height / 2);
      updateA11y();
    });
  }
  function updateA11y() {
    if (!a11yPanel) return;
    var i = a11yPanel.querySelector(".av-ms-a11y__bar i");
    if (i) i.style.width = Math.min(100, (getCaught() / GOAL) * 100) + "%";
  }

  /* =====================================================================
     REVEAL + confetti
     ===================================================================== */
  var winning = false, slowmo = 1, winDurMs = null, winIsBest = false, winPrevBest = null;
  function bloom() { var b = tier(el("div", "av-ms-bloom")); document.body.appendChild(b); setTimeout(function () { b.remove(); }, 600); }
  function win() {
    if (ARCADE) return;                                          // 🕹 the arcade has no prize to give
    setUnlocked(); updateHUD(); Sound.win();
    try {                                                        // personal-best hunt time (skip multi-day resumes)
      var t0v = parseInt(localStorage.getItem(KEY + "_t0") || "0", 10);
      if (t0v) {
        var du = Date.now() - t0v;
        if (du > 3000 && du < 1800000) {
          winDurMs = du;
          var pb = parseInt(localStorage.getItem("av_ms_best") || "0", 10); winPrevBest = pb || null;
          if (!pb || du < pb) { winIsBest = true; localStorage.setItem("av_ms_best", "" + du); }
        }
      }
    } catch (e) {}
    if (eventLayer) eventLayer.classList.add("is-pulse");
    var finish = function () {
      slowmo = 1; winning = false;
      if (arena) closeArena();
      clearTimeout(spawnTimer);
      mobs.length = 0; if (motionRaf) { cancelAnimationFrame(motionRaf); motionRaf = 0; }
      if (overlay) { overlay.remove(); overlay = null; active = 0; }
      if (a11yPanel) { a11yPanel.remove(); a11yPanel = null; }
      reveal(); confetti();
    };
    if (reduce) { finish(); return; }
    winning = true; slowmo = 0.3; bloom();     // brief slow-mo + white bloom, then the reveal
    setTimeout(finish, 480);
  }
  function reveal() {
    var modal = tier(el("div", "av-ms-modal is-open"));
    var bits = [];
    if (LABEL) bits.push('<b>' + esc(LABEL) + '</b>');   // the reward IS the discount code; no "points" line
    var achieveLine = '<p class="av-ms-reveal__sub">AutoVectors just published its <b>' + fmt(milestone.n) + 'th</b> pre-cut PPF template — a brand-new library milestone. Thanks for celebrating with us; here’s your reward for catching all ' + GOAL + '!</p>';
    var rewardLine = bits.length ? '<p class="av-ms-reveal__sub" style="margin-top:-6px">Reward: ' + bits.join(' · ') + '</p>' : '';
    var timeLine = winDurMs ? '<p class="av-ms-reveal__sub" style="margin-top:-6px">⏱ Unlocked in <b>' + fmtDur(winDurMs) + '</b>' + (winIsBest ? (winPrevBest ? ' — new personal best! 🏆' : '') : (winPrevBest ? ' · your best: ' + fmtDur(winPrevBest) : '')) + '</p>' : '';
    var ctxLine = '';                                            // contextual bridge: peak-dopamine, zero pressure
    try {
      var mpath = location.pathname.match(/^\/(collections|products)\/([a-z0-9-]+)/);
      if (mpath) {
        var nice = mpath[2].replace(/-/g, " ").replace(/\b\w/g, function (ch) { return ch.toUpperCase(); });
        ctxLine = '<p class="av-ms-reveal__sub" style="margin-top:10px">Valid on everything — including the <b>' + esc(nice) + '</b> templates you were browsing. <a class="av-ms-ctx" href="' + location.pathname + '?from=game">Back to ' + esc(nice) + ' →</a></p>';
      } else ctxLine = '<p class="av-ms-reveal__sub" style="margin-top:10px">Valid on all ' + fmt(Math.floor(COUNT / 100) * 100) + '+ templates in the library.</p>';
    } catch (e) {}
    modal.innerHTML =
      '<div class="av-ms-modal__scrim"></div>' +
      '<div class="av-ms-reveal">' +
        '<button class="av-ms-reveal__x" aria-label="Close">✕</button>' +
        '<div class="av-ms-reveal__medal"><img src="' + MEDAL_SRC + '" alt="" aria-hidden="true"><span class="av-ms-gleam"></span></div>' +
        '<div class="av-ms-reveal__k">' + esc(FX.rank) + '-grade unlocked</div>' +
        '<div class="av-ms-reveal__h">' + fmt(milestone.n) + ' templates reached 🎉</div>' +
        achieveLine + rewardLine + timeLine +
        // PLOTTER-CUT reveal: a blade traces the card outline (registration crosshairs
        // blink in), then the PPF liner film peels off the code — the store's own ritual.
        '<div class="av-ms-cut' + (reduce ? '' : ' will-cut') + '">' +
          '<div class="av-ms-lamp"><span></span><span></span><span></span><span></span><span></span><span></span></div>' +
          '<div class="av-ms-code"><input readonly value="' + esc(CODE) + '" aria-label="Promo code"><button type="button" data-copy>Copy</button></div>' +
          '<svg class="av-ms-cut__svg" viewBox="0 0 100 32" preserveAspectRatio="none" aria-hidden="true"><rect x="1" y="1" width="98" height="30" rx="4" pathLength="100"/></svg>' +
          '<span class="av-ms-cut__corner c1"></span><span class="av-ms-cut__corner c2"></span><span class="av-ms-cut__corner c3"></span><span class="av-ms-cut__corner c4"></span>' +
          '<div class="av-ms-cut__film"></div>' +
        '</div>' +
        ctxLine +
        '<p class="av-ms-founder" aria-hidden="true"></p>' +
        '<a class="av-ms-btn" href="/discount/' + encodeURIComponent(CODE) + '?redirect=/pages/template-library">Shop with code →</a>' +
        '<div class="av-ms-reveal__timer"></div>' +              // ⌛ exactly how long the reward lasts
        '<div class="av-ms-reveal__more">' +                     // 🎮 the code is won — now what?
          '<button class="av-ms-btn av-ms-btn--ghost" type="button" data-next>▶ Next: level ' + funLevel + '</button>' +
          '<button class="av-ms-btn av-ms-btn--ghost" type="button" data-again>↻ Level 1 + tips</button>' +
        '</div>' +
        '<p class="av-ms-reveal__fine">Copy the code and paste it at checkout. The reward retires when the celebration window closes.</p>' +
      '</div>';
    document.body.appendChild(modal);
    var cut = modal.querySelector(".av-ms-cut");
    if (cut && !reduce) {
      Sound.fx("plotter"); buzz([15, 40, 15, 40, 30, 40, 60]);
      requestAnimationFrame(function () { requestAnimationFrame(function () { cut.classList.add("is-cutting"); }); });
    }
    var fl = modal.querySelector(".av-ms-founder");              // "cut with care" — a note from a human, typed in
    if (fl) {
      var fmsg = "Cut with care — thank you for being part of the first " + fmt(milestone.n) + ".  — AutoVectors";
      if (reduce) fl.textContent = fmsg;
      else setTimeout(function () {
        if (!document.body.contains(fl)) return;
        for (var fk = 0; fk < fmsg.length; fk++) {
          var sp = el("span", "", esc(fmsg[fk]));                 // real spaces -> the line can WRAP inside the card
          sp.style.transitionDelay = (fk * 26) + "ms"; fl.appendChild(sp);
        }
        Sound.fx("typeline");
        requestAnimationFrame(function () { requestAnimationFrame(function () { fl.classList.add("is-write"); }); });
      }, 2350);
    }
    var close = function () { modal.remove(); };
    var rt = modal.querySelector(".av-ms-reveal__timer");
    if (rt) rt.appendChild(makeCountdown("av-ms-count--reveal"));
    modal.querySelector(".av-ms-reveal__x").addEventListener("click", close);
    // both routes onward: keep climbing, or go back to the teaching level with every
    // card replayed. `finish()` already cleared `winning` and closed the arena, so
    // startArena/arcadeStart are free to run.
    var nb = modal.querySelector("[data-next]");
    if (nb) nb.addEventListener("click", function () { close(); funMode = true; funCaught = 0; startArena(); });
    var ab = modal.querySelector("[data-again]");
    if (ab) ab.addEventListener("click", function () { close(); arcadeStart(1); });
    modal.querySelector(".av-ms-modal__scrim").addEventListener("click", close);
    wireCopy(modal);
    // "forge" the code in: scramble the characters, then settle to the real code
    var inp = modal.querySelector(".av-ms-code input");
    if (inp && !reduce) {
      var TGT = CODE, CH = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789", t0f = Date.now(), DUR = 850;
      inp.value = "";
      var fv = setInterval(function () {
        var t = Math.min(1, (Date.now() - t0f) / DUR), settled = Math.floor(t * TGT.length), s = TGT.slice(0, settled);
        for (var i = settled; i < TGT.length; i++) s += CH[(Math.random() * CH.length) | 0];
        inp.value = s;
        if (t >= 1) { clearInterval(fv); inp.value = TGT; }
      }, 45);
    }
    var f = modal.querySelector(".av-ms-reveal__x"); if (f) f.focus();
  }
  function wireCopy(scope) {
    var btn = scope.querySelector("[data-copy]"); if (!btn) return;
    btn.addEventListener("click", function () {
      var ok = function () { btn.textContent = "Copied ✓"; btn.classList.add("is-copied"); setTimeout(function () { btn.textContent = "Copy"; btn.classList.remove("is-copied"); }, 1800); };
      try { navigator.clipboard.writeText(CODE).then(ok, function () { legacyCopy(scope); ok(); }); }
      catch (e) { legacyCopy(scope); ok(); }
    });
  }
  function legacyCopy(scope) { var inp = scope.querySelector(".av-ms-code input"); if (inp) { inp.focus(); inp.select(); try { document.execCommand("copy"); } catch (e) {} } }

  function confetti(mult) {
    if (reduce) return;
    var cv = el("canvas", "av-ms-confetti is-on"); document.body.appendChild(cv);
    var g = cv.getContext("2d"), W, H, dpr = Math.min(devicePixelRatio || 1, 2);
    function size() { W = cv.width = innerWidth * dpr; H = cv.height = innerHeight * dpr; cv.style.width = innerWidth + "px"; cv.style.height = innerHeight + "px"; }
    size();
    var tierCol = { bronze: ["#e8a15a", "#b76e2c"], silver: ["#e9f2ff", "#9fb3c8"], gold: ["#ffd875", "#e0a422"], platinum: ["#eaf4ff", "#a9c6e0"] }[TIER] || ["#e9f2ff", "#9fb3c8"];
    var pal = tierCol.concat(["#ffffff", "#12e0c4"]), P = [];
    for (var i = 0, N = Math.round(FX.confetti * (mult || 1)); i < N; i++) P.push({ x: W * pseudo(), y: -20 * dpr - pseudo() * H * 0.4, vx: (pseudo() - 0.5) * 6 * dpr, vy: (2 + pseudo() * 5) * dpr, s: (4 + pseudo() * 6) * dpr, rot: pseudo() * 6.28, vr: (pseudo() - 0.5) * 0.3, c: pal[(pseudo() * pal.length) | 0] });
    var start = perfNow();
    (function frame() {
      var t = perfNow() - start; g.clearRect(0, 0, W, H);
      for (var i = 0; i < P.length; i++) { var p = P[i]; p.vy += 0.06 * dpr; p.x += p.vx; p.y += p.vy; p.rot += p.vr; p.vx *= 0.995;
        g.save(); g.translate(p.x, p.y); g.rotate(p.rot); g.globalAlpha = Math.max(0, 1 - t / 2600); g.fillStyle = p.c; g.fillRect(-p.s / 2, -p.s / 2, p.s, p.s * 0.6); g.restore(); }
      if (t < 2600) requestAnimationFrame(frame); else cv.remove();
    })();
    addEventListener("resize", size, { once: true });
  }

  /* --------------------- "time left" drain bar -------------------------- */
  // Honest, count-based: the bar shows the REAL templates remaining in the window
  // (buffer - used) and drains as new templates are added. No days/hours text
  // (that would be an inaccurate rate estimate) — just an hourglass + the bar.
  // The window closes by TEMPLATE COUNT (at milestone + BUFFER), not by clock — so the
  // template figure is exact and the days are an estimate from the publishing rate
  // (theme setting "Templates published per day"; 0 hides the estimate entirely).
  function eventLeft() {
    var left = Math.max(0, milestone.n + BUFFER - COUNT);
    return {
      left: left,
      days: RATE > 0 && left > 0 ? Math.max(1, Math.ceil(left / RATE)) : 0,
      pct: Math.max(0, Math.min(100, Math.round(left / BUFFER * 100)))
    };
  }
  function countdownText() {
    var e = eventLeft();
    if (!e.left) return "Event is closing — code retires now";
    var tail = e.left + " more template" + (e.left > 1 ? "s" : "") + " to go";
    if (!e.days) return "Code valid for " + tail;
    return "Code expires in <b>~" + e.days + " day" + (e.days > 1 ? "s" : "") + "</b> · " + tail;
  }
  function makeCountdown(extraCls) {
    var wrap = el("div", "av-ms-count" + (extraCls ? " " + extraCls : ""));
    var e = eventLeft();
    wrap.innerHTML =
      '<span class="av-ms-count__row">' +
        '<span class="av-ms-count__ico" aria-hidden="true">⌛</span>' +
        '<span class="av-ms-count__bar"><i style="width:' + e.pct + '%"></i></span>' +
      '</span>' +
      '<span class="av-ms-count__txt">' + countdownText() + '</span>';
    return wrap;
  }

  /* --------------------------- welcome modal ---------------------------- */
  // Prominent first-visit announcement while the celebration is live. Shows ONCE
  // per milestone (persistent flag) — never nags again — and only ever appears
  // during the active window, so it self-retires when the event ends.
  function consentOpen() {              // is a cookie-consent banner currently on screen?
    // NOTE: don't use offsetParent — it is null for position:fixed elements, and consent
    // banners are fixed. Measure the box + computed styles instead.
    var sels = ["#shopify-pc__banner", ".shopify-pc__banner", "[id^='shopify-pc__']", "#cookie-banner", ".cookie-banner", ".cookie-consent"];
    for (var i = 0; i < sels.length; i++) {
      var e = document.querySelector(sels[i]); if (!e) continue;
      var cs = getComputedStyle(e), r = e.getBoundingClientRect();
      if (cs.display !== "none" && cs.visibility !== "hidden" && parseFloat(cs.opacity || "1") > 0.05 && r.height > 8 && r.width > 8) return true;
    }
    return false;
  }
  // The consent dialog is injected a moment AFTER load and sits at z-index 2,000,000,
  // so a one-shot check at boot cannot decide this — it would always run too early.
  // WATCH it instead: while it is up the game's surfaces hide, and the moment it is
  // dealt with they come back. No artificial delay on a normal load, and it is correct
  // whichever order the two appear in. The arena is exempt: a banner must never kill a
  // round that is already running.
  function consentWatch() {
    var on = null;
    setInterval(function () {
      var open = consentOpen();
      if (open === on) return;
      on = open;
      document.documentElement.classList.toggle("av-ms-consent", open);
      if (open && pop) pop.hidden = true;
    }, 400);
  }
  function afterConsent(cb) {          // NEVER cover the cookie banner — wait until it's handled
    var waited = 0, saw = false;
    (function chk() {
      if (consentOpen()) {                                   // banner up -> keep waiting (max ~60s)
        saw = true; if (waited < 120) { waited++; return setTimeout(chk, 500); }
      } else if (!saw && waited < 14) {                       // grace: Shopify injects it a moment AFTER load (~5s)
        waited++; return setTimeout(chk, 400);
      }
      setTimeout(cb, saw ? 1000 : 700);                       // handled (or never shown) -> settle, then welcome
    })();
  }
  function welcome() {
    if (isUnlocked()) return;
    var wkey = "av_ms_welcome_" + milestone.n;
    try { if (localStorage.getItem(wkey) === "1") return; } catch (e) {}
    afterConsent(function () {
      if (isUnlocked()) return;
      try { if (localStorage.getItem(wkey) === "1") return; localStorage.setItem(wkey, "1"); } catch (e) {}
      var modal = tier(el("div", "av-ms-modal is-open"));
      var reward = LABEL ? 'an exclusive <b>' + esc(LABEL) + '</b> discount code' : 'an exclusive discount code';
      modal.innerHTML =
        '<div class="av-ms-modal__scrim"></div>' +
        '<div class="av-ms-welcome">' +
          '<button class="av-ms-welcome__x" aria-label="Close">✕</button>' +
          '<div class="av-ms-welcome__medal"><img src="' + MEDAL_SRC + '" alt="" aria-hidden="true"></div>' +
          '<div class="av-ms-welcome__k">' + esc(FX.rank) + '-grade milestone reached</div>' +
          '<h2 class="av-ms-welcome__h">' + fmt(milestone.n) + ' templates — unlocked! 🎉</h2>' +
          '<p class="av-ms-welcome__p">AutoVectors just published its <b>' + fmt(milestone.n) + 'th</b> pre-cut PPF template. To celebrate, beat the <b>Challenge Round</b> — catch <b>' + GOAL + '</b> ' + TIER_NAME + ' medals against the clock to unlock ' + reward + '.</p>' +
          '<div class="av-ms-welcome__timer"><div class="av-ms-welcome__badge">Limited-time celebration</div></div>' +
          '<button class="av-ms-btn av-ms-welcome__cta" type="button">▶ Start challenge round</button>' +
          '<p class="av-ms-welcome__fine">Available only while the milestone celebration is live — don’t miss it.</p>' +
          (function () { try { var pb = parseInt(localStorage.getItem("av_ms_best") || "0", 10); return pb ? '<p class="av-ms-welcome__fine">🏆 Your record: <b>' + fmtDur(pb) + '</b> — think you can beat it?</p>' : ''; } catch (e) { return ''; } })() +
        '</div>';
      document.body.appendChild(modal);
      if (!reduce) { var sw = tier(el("div", "av-ms-shock")); document.body.appendChild(sw); setTimeout(function () { sw.remove(); }, 900); }   // milestone-hit shockwave
      modal.querySelector(".av-ms-welcome__timer").appendChild(makeCountdown());
      var close = function () { modal.classList.add("is-closing"); setTimeout(function () { modal.remove(); }, 320); };
      modal.querySelector(".av-ms-welcome__x").addEventListener("click", close);
      modal.querySelector(".av-ms-welcome__cta").addEventListener("click", function () {
        close(); funMode = false; primerThen(startArena);
      });
      modal.querySelector(".av-ms-modal__scrim").addEventListener("click", close);
    });
  }

  /* ---------------------------- teaser (pre-milestone) ------------------- */
  function buildTeaser() {
    var dkey = "av_ms_teaser_dismissed_" + milestone.n;
    try { if (sessionStorage.getItem(dkey) === "1") return; } catch (e) {}
    var lead = leadFor(milestone), pct = Math.max(4, Math.min(100, Math.round((lead - remaining) / lead * 100)));
    var t = tier(el("div", "av-ms-teaser"));
    t.setAttribute("role", "status");
    t.innerHTML =
      '<button class="av-ms-teaser__x" aria-label="Dismiss">✕</button>' +
      '<div class="av-ms-teaser__medal"><img src="' + MEDAL_SRC + '" alt="" aria-hidden="true"><span class="av-ms-teaser__q">?</span></div>' +
      '<div class="av-ms-teaser__body">' +
        '<div class="av-ms-teaser__k">Milestone incoming</div>' +
        '<div class="av-ms-teaser__n"><b>' + fmt(remaining) + '</b> ' + (remaining === 1 ? 'template' : 'templates') + ' to go</div>' +
        '<div class="av-ms-teaser__s">until the <b>' + fmt(milestone.n) + '</b>-template milestone. Keep watching — a surprise reward unlocks the moment we hit it 🎁</div>' +
        '<div class="av-ms-teaser__bar"><i style="width:' + pct + '%"></i></div>' +
      '</div>';
    document.body.appendChild(t);
    requestAnimationFrame(function () { requestAnimationFrame(function () { t.classList.add("is-in"); }); });
    t.querySelector(".av-ms-teaser__x").addEventListener("click", function () {
      t.classList.remove("is-in"); setTimeout(function () { t.remove(); }, 420);
      try { sessionStorage.setItem(dkey, "1"); } catch (e) {}
    });
  }

  /* ------------------------- build / teardown --------------------------- */
  var eventLayer;
  function buildEventMode() {                                    // site-wide "the store went LIVE" tier light (from the top)
    if (reduce || eventLayer) return;
    eventLayer = tier(el("div", "av-ms-event")); eventLayer.setAttribute("aria-hidden", "true");
    eventLayer.style.setProperty("--ev-op", (0.26 + (FX.rays - 3) * 0.08).toFixed(2));   // tier-scaled intensity
    eventLayer.innerHTML = '<span class="av-ms-event__glow"></span>';
    document.body.appendChild(eventLayer);
  }
  function eventPulse() { if (!eventLayer) return; eventLayer.classList.add("is-pulse"); clearTimeout(eventLayer._pt); eventLayer._pt = setTimeout(function () { if (eventLayer) eventLayer.classList.remove("is-pulse"); }, 450); }
  function liteHint() {                 // weak device still on full 3D -> gently offer Lite mode
    if (document.documentElement.classList.contains("av-lite")) return;
    var weak = (navigator.hardwareConcurrency && navigator.hardwareConcurrency <= 4) ||
               (navigator.deviceMemory && navigator.deviceMemory <= 4);
    if (!weak) return;
    try { if (sessionStorage.getItem("av_ms_litehint") === "1") return; sessionStorage.setItem("av_ms_litehint", "1"); } catch (e) {}
    var show = function () {
      if (document.querySelector(".av-ms-welcome")) { setTimeout(show, 1500); return; }   // don't stack on the welcome
      var t = tier(el("div", "av-ms-litehint",
        '<span>⚡ Running slow? <b>Lite mode</b> is lighter — the game stays smooth.</span>' +
        '<button class="av-ms-btn" type="button" data-lite>Switch to Lite</button>' +
        '<button class="av-ms-litehint__x" type="button" data-x aria-label="Dismiss">✕</button>'));
      document.body.appendChild(t);
      requestAnimationFrame(function () { requestAnimationFrame(function () { t.classList.add("is-in"); }); });
      var hide = function () { t.classList.remove("is-in"); setTimeout(function () { t.remove(); }, 400); };
      t.querySelector("[data-lite]").addEventListener("click", function () { try { localStorage.setItem("av-lite", "1"); } catch (e) {} location.reload(); });
      t.querySelector("[data-x]").addEventListener("click", hide);
      setTimeout(hide, 14000);
    };
    setTimeout(show, 5000);
  }
  function buildGame() {
    Sound.arm();
    buildEventMode();
    if (a11y) buildA11y();
    else { buildOverlay(); scheduleSpawn(); }
    liteHint();
  }
  function rebuild() {
    // switch between rich and a11y without losing progress
    if (overlay) { clearTimeout(spawnTimer); overlay.remove(); overlay = null; active = 0; }
    if (a11yPanel) { a11yPanel.remove(); a11yPanel = null; }
    if (isUnlocked()) return;
    buildGame();
  }
  function teardown(userHid) {
    clearTimeout(spawnTimer); if (overlay) overlay.remove();
    if (a11yPanel) a11yPanel.remove(); if (pop) pop.remove();
    if (hud) hud.remove();
    if (userHid) { try { sessionStorage.setItem("av_ms_hidden_" + milestone.n, "1"); } catch (e) {} }
  }

  /* ------------------------------- utils -------------------------------- */
  function fmt(n) { return (n + "").replace(/\B(?=(\d{3})+(?!\d))/g, ","); }
  function fmtDur(ms) { var s = Math.round(ms / 1000), m = Math.floor(s / 60); return m ? m + "m " + (s % 60) + "s" : s + "s"; }
  function esc(s) { return (s + "").replace(/[&<>"']/g, function (c) { return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]; }); }
  function perfNow() { return (window.performance && performance.now) ? performance.now() : +new Date(); }

  document.addEventListener("visibilitychange", function () { if (!document.hidden && overlay && !isUnlocked()) scheduleSpawn(); });

  /* 🕹 ------------------------ ARCADE launcher --------------------------- */
  // A page may carry an opt-in launcher — [data-av-ms-arcade="1000"], today the "easter
  // egg" badge on the knowledge-hub reward table — that starts a round ON DEMAND in any
  // mode. It can never award the code: funMode routes every point to funGain, and
  // win()/setUnlocked() are barred while ARCADE.
  function arcadeLaunch(ev) {                            // the badge opens the LEVEL PICKER
    if (ev) {
      if (ev.isTrusted === false) return false;          // ignore the page's synthetic cursor FX
      ev.preventDefault(); ev.stopPropagation();
    }
    if (arena || winning) return false;                  // never interrupt a live round
    return arcadePicker();
  }
  function arcadePicker() {
    var old = document.querySelector(".av-ms-lvlmodal"); if (old) old.remove();
    try { Sound.arm(); } catch (e) {}
    var cells = "";
    for (var L = 1; L <= funMax; L++) {                   // every level you have ever reached
      cells += '<button type="button" class="av-ms-lvl' +
        (L >= 5 && L % 5 === 0 ? " is-wall" : "") + (L === funMax ? " is-best" : "") +
        '" data-lvl="' + L + '"' + (L >= 5 && L % 5 === 0 ? ' title="Wall boss level"' : '') + '>' + L + '</button>';
    }
    var m = tier(el("div", "av-ms-modal av-ms-lvlmodal is-open"));
    m.innerHTML =
      '<div class="av-ms-modal__scrim"></div>' +
      '<div class="av-ms-lvlpick">' +
        '<button class="av-ms-lvlpick__x" type="button" aria-label="Close">✕</button>' +
        '<b>🕹 ARCADE</b>' +
        '<span>Replay any level you have reached — just for fun, no code at stake.</span>' +
        '<div class="av-ms-lvlgrid">' + cells + '</div>' +
        '<u>🧱 every 5th level is a WALL boss · your best: LEVEL ' + funMax + '</u>' +
      '</div>';
    document.body.appendChild(m);
    function shut() { if (m.parentNode) m.remove(); }
    m.querySelector(".av-ms-lvlpick__x").addEventListener("click", shut);
    m.querySelector(".av-ms-modal__scrim").addEventListener("click", shut);
    m.querySelector(".av-ms-lvlgrid").addEventListener("click", function (ev2) {
      var b = ev2.target && ev2.target.closest ? ev2.target.closest("[data-lvl]") : null;
      if (!b) return;
      shut(); arcadeStart(parseInt(b.getAttribute("data-lvl"), 10) || 1);
    });
    document.addEventListener("keydown", function esc(kv) {
      if (kv.key !== "Escape") return;
      document.removeEventListener("keydown", esc); shut();
    });
    var best = m.querySelector(".av-ms-lvl.is-best"); if (best) best.scrollIntoView({ block: "nearest" });
    return true;
  }
  /* 📖 HOW TO PLAY — the animated primer shown before EVERY level-1 round.
     Level 1 is the on-ramp, so it never gets marked "seen": a first-timer and a
     returning player both get the same demo. It loops one full cycle of the real
     loop — draw a strand, a medal gets caught in it, click the medal, score. */
  function howToPlay(onPlay, playLabel, closeCancels) {
    var old = document.querySelector(".av-ms-htpmodal"); if (old) old.remove();
    // the primer REPLACES the welcome modal — stacked, its stage bled through the card
    [].forEach.call(document.querySelectorAll(".av-ms-modal"), function (o) {
      if (o.querySelector(".av-ms-welcome")) o.remove();
    });
    try { Sound.arm(); } catch (e) {}
    var m = tier(el("div", "av-ms-modal av-ms-htpmodal is-open"));
    m.innerHTML =
      '<div class="av-ms-modal__scrim"></div>' +
      '<div class="av-ms-htp">' +
        '<button class="av-ms-htp__x" type="button" aria-label="Close">✕</button>' +
        '<b>📖 HOW TO PLAY</b>' +
        '<span>Catch ' + GOAL + ' medals before the clock runs out.</span>' +
        '<div class="av-ms-htp__stage" aria-hidden="true">' +
          '<svg viewBox="0 0 320 180">' +
            '<path class="av-ms-htp__ink" d="M26,138 C80,60 150,165 214,104" />' +
            '<path class="av-ms-htp__loop" d="M258,26 A32,32 0 1 1 258,90 A32,32 0 1 1 258,26" />' +
          '</svg>' +
          '<i class="av-ms-htp__web"></i>' +                       // the golden "held" glow
          '<img class="av-ms-htp__m1" src="' + MEDAL_SRC + '" alt="" />' +
          '<img class="av-ms-htp__m2" src="' + MEDAL_SRC + '" alt="" />' +
          '<i class="av-ms-htp__ring"></i>' +
          '<i class="av-ms-htp__ring2"></i>' +
          '<i class="av-ms-htp__cursor"></i>' +
          '<s class="av-ms-htp__plus">+1</s>' +
          '<u class="av-ms-htp__beats">' +
            '<span>① DRAW A CURVE</span><span>② IT STICKS</span>' +
            '<span>③ LOOP = TRAPPED</span><span>④ CLICK = +1</span>' +
          '</u>' +
        '</div>' +
        '<p><i>1</i><span><em>Hold and drag</em> anywhere to draw a vector curve.</span></p>' +
        '<p><i>2</i><span>Medals that touch your curve <em>stick to it</em> — draw a web and they pile up waiting for you.</span></p>' +
        '<p><i>3</i><span>Loop a curve <em>around</em> a medal and it is trapped inside.</span></p>' +
        '<p><i>4</i><span><em>Click a medal</em> to collect it. That is your point.</span></p>' +
        '<u>Curves fade after a few seconds · ink refills by itself</u>' +
        '<button class="av-ms-btn" type="button" data-play>' + (playLabel || "▶ START") + '</button>' +
      '</div>';
    document.body.appendChild(m);
    // ---- ONE CLOCK, ONE THREAD, ONE RULER -------------------------------
    // CSS ran the ink on the main thread and the cursor on the compositor, and
    // the two clocks start a frame or two apart — the visible "line draws ahead
    // of the mouse". So the whole trio is driven from a single rAF: every frame
    // ONE number (distance along the tour) sets the dash of both strokes AND
    // the cursor position, all measured with the browser's own path ruler.
    try {
      var _ink = m.querySelector(".av-ms-htp__ink"), _loop = m.querySelector(".av-ms-htp__loop");
      var _cur = m.querySelector(".av-ms-htp__cursor"), _svg = _ink.ownerSVGElement;
      var TOUR = "M26,138 C80,60 150,165 214,104 L258,26 A32,32 0 1 1 258,90 A32,32 0 1 1 258,26 L117,95 L258,58";
      var _tp = document.createElementNS("http://www.w3.org/2000/svg", "path");
      _tp.setAttribute("d", TOUR); _tp.setAttribute("fill", "none"); _tp.setAttribute("stroke", "none");
      _svg.appendChild(_tp);                                     // stays: the ruler lives as long as the scene
      var LA = _ink.getTotalLength(), LC = _loop.getTotalLength(), LT = _tp.getTotalLength();
      var T1 = Math.hypot(258 - 214, 26 - 104);                  // pen-up glides are straight, so exact
      var D3 = LA + T1 + LC, D4 = LT - Math.hypot(258 - 117, 58 - 95);
      [_ink, _loop, _cur].forEach(function (e) { e.style.animation = "none"; });
      _cur.style.offsetPath = "none"; _cur.style.transformOrigin = "0 0";   // press shrinks toward the TIP
      _ink.style.strokeDasharray = LA; _loop.style.strokeDasharray = LC;
      function _apply(f) {                                       // f = 0..1 through the 11s story
        var d;                                                   //   the ONE number everything shares
        if      (f < 0.02) d = 0;
        else if (f < 0.17) d = LA * (f - 0.02) / 0.15;           // ✒ draw the strand
        else if (f < 0.22) d = LA + T1 * (f - 0.17) / 0.05;      // pen up, glide
        else if (f < 0.38) d = LA + T1;                          // watch the medal get caught
        else if (f < 0.54) d = LA + T1 + LC * (f - 0.38) / 0.16; // ⭕ draw the loop
        else if (f < 0.58) d = D3;                               // TRAPPED beat
        else if (f < 0.66) d = D3 + (D4 - D3) * (f - 0.58) / 0.08;   // glide to the caught medal
        else if (f < 0.74) d = D4;                               // 🖱 click #1
        else if (f < 0.80) d = D4 + (LT - D4) * (f - 0.74) / 0.06;   // glide to the trapped one
        else d = LT;                                             // 🖱 click #2
        _ink.style.strokeDashoffset = Math.max(0, LA - Math.min(LA, d));
        _loop.style.strokeDashoffset = Math.max(0, LC - Math.max(0, Math.min(LC, d - LA - T1)));
        _ink.style.stroke = f >= 0.31 ? "#ffd875" : "#7df9ff";   // gold the frame the medal sticks
        _loop.style.stroke = f >= 0.56 ? "#ffd875" : "#7df9ff";  // gold the frame the trap closes
        var so = f >= 0.96 ? 0 : f >= 0.88 ? 1 - (f - 0.88) / 0.08 : 1;
        _ink.style.opacity = so; _loop.style.opacity = so;
        var p = _tp.getPointAtLength(Math.max(0, Math.min(LT, d)));
        var sc = 1;                                              // the pointer visibly PRESSES
        function dip(a, b, mid, lo) { if (f >= a && f <= b) { var q = f < mid ? (f - a) / (mid - a) : (b - f) / (b - mid); sc = 1 - (1 - lo) * Math.max(0, Math.min(1, q)); } }
        dip(0.02, 0.05, 0.028, 0.8); dip(0.375, 0.41, 0.388, 0.8);
        dip(0.68, 0.73, 0.70, 0.75); dip(0.795, 0.85, 0.82, 0.75);
        _cur.style.opacity = f < 0.02 ? f / 0.02 : f >= 0.97 ? 0 : f >= 0.91 ? 1 - (f - 0.91) / 0.06 : 1;
        _cur.style.transform = "translate(" + p.x.toFixed(2) + "px," + p.y.toFixed(2) + "px) scale(" + sc.toFixed(3) + ")";
      }
      m.__htpApply = _apply;                                     // deterministic hook for tests
      var _t0 = performance.now();
      (function _tick() {
        if (!document.body.contains(m)) return;                  // modal closed -> driver dies with it
        _apply(((performance.now() - _t0) % 11000) / 11000);
        requestAnimationFrame(_tick);
      })();
    } catch (e) {}
    function go(start) {
      if (m.parentNode) m.remove();
      if (start && onPlay) onPlay();
    }
    m.querySelector("[data-play]").addEventListener("click", function () { go(true); });
    // dismissing the primer on the FIRST round still starts it (you already pressed Start);
    // from the arcade picker it cancels, so you can go back and choose another level.
    m.querySelector(".av-ms-htp__x").addEventListener("click", function () { go(!closeCancels); });
    m.querySelector(".av-ms-modal__scrim").addEventListener("click", function () { go(!closeCancels); });
    document.addEventListener("keydown", function esc(kv) {
      if (kv.key !== "Escape") return;
      document.removeEventListener("keydown", esc);
      if (m.parentNode) go(false);
    });
    return true;
  }
  // 📖 The primer IS the level-1 experience: it plays EVERY time level 1 is played,
  // whatever route got you there. And a first-time visitor's very first challenge round
  // is their level 1 too, so it plays once there as well.
  function primerThen(cb, always) {
    if (reduce) { cb(); return true; }
    var seen = false;
    try { seen = localStorage.getItem("av_ms_htp") === "1"; } catch (e) {}
    if (!always && seen) { cb(); return true; }
    try { localStorage.setItem("av_ms_htp", "1"); } catch (e) {}
    return howToPlay(cb, always ? "▶ START LEVEL 1" : "▶ START THE ROUND", !always);
  }
  function arcadeStart(L, skipHowTo) {
    if (arena || winning || arcadeBusy) return false;    // no re-entry, never tear down a live round
    // level 1 is the on-ramp: always show the primer first, then start on PLAY
    if (L === 1 && !skipHowTo) return primerThen(function () { arcadeStart(1, true); }, true);
    arcadeBusy = true; setTimeout(function () { arcadeBusy = false; }, 600);
    try { Sound.arm(); } catch (e) {}                    // arcade has no HUD toggle to arm audio
    funMode = true; funCaught = 0;                       // always a fun round: no code, no progress
    funLevel = Math.max(1, Math.min(funMax, L || funMax));
    if (pop) pop.hidden = true;
    try { startArena(); }
    catch (e) {                                          // a throw mid-build must never leave the article covered
      try {
        document.documentElement.classList.remove("av-ms-lowfx");
        var m = document.querySelectorAll(".av-ms-modal");
        for (var i = 0; i < m.length; i++) m[i].remove();
      } catch (e2) {}
      arena = null; return false;
    }
    if (arena && !document.__avMsEsc) {                   // Escape gets the reader back to the article
      document.__avMsEsc = 1;
      document.addEventListener("keydown", function (kv) { if (kv.key === "Escape" && arena) closeArena(); });
    }
    return !!arena;
  }
  function bindArcade() {
    var btns = document.querySelectorAll("[data-av-ms-arcade]");
    for (var i = 0; i < btns.length; i++) {
      if (btns[i].__avMsEgg) continue; btns[i].__avMsEgg = 1;
      btns[i].classList.add("is-armed");                  // the badge only becomes visible once the engine is here
      btns[i].addEventListener("click", function (ev) {
        var b = ev.currentTarget;
        if (arcadeLaunch(ev) === false) { b.classList.add("is-egg-failed"); setTimeout(function () { b.classList.remove("is-egg-failed"); }, 1200); }
      });
    }
  }

  // Sanctioned programmatic entry — the click path deliberately refuses untrusted events,
  // so tests and any future launcher call this instead. It still grants nothing.
  root.__avMsArcade = arcadeLaunch;                       // open the level picker
  root.__avMsStart  = arcadeStart;                        // start a specific level straight away
  root.__avMsBind   = bindArcade;                         // re-arm badges added after boot

  /* -------------------------------- go ---------------------------------- */
  bindArcade();                                         // 🕹 the easter egg works in every mode…
  if (mode === "arcade") return;                        // …and in arcade mode it is the ONLY thing on the page
  if (mode === "teaser") { buildTeaser(); return; }     // pre-milestone: only the teaser, no game
  var userHidden = false; try { userHidden = sessionStorage.getItem("av_ms_hidden_" + milestone.n) === "1"; } catch (e) {}
  // NOTHING appears until the cookie banner is handled — it sits at z-index 2,000,000
  // and would cover the HUD and panel, leaving a first-time visitor unable to reach
  // controls they can see. afterConsent resolves immediately when no banner shows.
  consentWatch(); startEverything();
  function startEverything() {
  buildHUD(); buildPop();
  if (isUnlocked()) { /* code stays available via HUD */ }
  else if (userHidden) { /* HUD stays as a re-entry point, no auto game */ }
  else {
    try {                                                        // COMEBACK: returned on a later day mid-hunt -> +2 & a guaranteed rare
      var ckey = KEY + "_lastday", tod = new Date().toDateString(), lastDay = localStorage.getItem(ckey);
      localStorage.setItem(ckey, tod);
      var c0 = getCaught();
      if (lastDay && lastDay !== tod && c0 > 0 && c0 < GOAL - 4) {
        setCaught(Math.min(GOAL - 4, c0 + 2)); forceRare = true; updateHUD();
        setTimeout(function () { toast("👋 Welcome back — <b>+2 bonus medals</b> & a rare incoming!", 3400); }, 1800);
      }
    } catch (e) {}
    buildGame(); welcome();
  }
  }
})();
